import React, { useState, useEffect, useRef } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import SoftButton from "components/SoftButton";
import AudioVisualizer from "./audioanimation";
import CloseIcon from '@mui/icons-material/Close';
import SoftBadge from "components/SoftBadge";
import SeparatorRecord from "./components/seperatorRecord";
import SeparatorPatient from "./components/seperatorPatient";
import SeperatorAllSaved from "./components/seperatorAllSaved";
import SeparatorTranscript from "./components/seperatorTranscript";
import SeparatorDescription from "./components/seperatorDescription";
import SeparatorEditTemplate from "./components/seperatorEditTemplate";
import SeparatorSumsList from "./components/seperatorSumsList";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SoftDropzone from "components/SoftDropzone";
import PlaceholderCard from "examples/Cards/PlaceholderCard";
import SeperatorTemplateInfo from "./components/seperatorNewTemplateInfo";
import SeperatorTemplatePrompts from "./components/seperatorTemplateprompts";
import SeperatorTemplateAdding from "./components/seperatorAddTemplatePrompts";
import SeparatorTemplate from "./components/seperatorTemplateGen";
import SeperatorNewSummaryTemplate from "./components/seperatorNewSumTemp";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import SpeechToText from "./speechRecognition";
import SpeechToTextSummaries from "./speechRecoSums";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import WarningIcon from '@mui/icons-material/Warning';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import ReportProblemModal from "examples/problemReporting/reportProblem";
import SeperatorPatientInstructions from "./components/seperatorInstructions";
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import Checkbox from "@mui/material/Checkbox";
import Snackbar from "@mui/material/Snackbar";
import SoftAlert from "components/SoftAlert";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import CustomTooltip from "./customTooltip";
import LibraryCard from "examples/Cards/ProjectCards/LibraryCard";
import AddTaskOutlinedIcon from '@mui/icons-material/AddTaskOutlined';
import SeperatorLibrary from "./components/seperatorLibrary";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import SeparatorDataPat from "./components/seperatorDataPat";
import LoadingSpinnerNewTranscript from "./components/loaderNew";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
// import React from 'react';
import { AudioRecorder, useAudioRecorder } from "react-audio-voice-recorder";
import 'react-voice-recorder/dist/index.css';
import axios from 'axios';
const INACTIVITY_LIMIT = 2 * 60 * 60 * 1000; // 2 hours in ms
const SILENCE_LIMIT = 2 * 60 * 60 * 1000; // also 2 hours
import  Result  from './result'
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftEditor from "components/SoftEditor";
import Divider from "@mui/material/Divider";
import ControllerCard from "examples/Cards/ControllerCard";
import SoftInput from "components/SoftInput";
import Swal from "sweetalert2";
import SoftSnackbar from "components/SoftSnackbar";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PromptSettings from "./prompts";
import TitleSection from "./titleheader";
import customIcons from "./components/customIcons";
//import breakpoints from "assets/theme/base/breakpoints";
import prompts from "./components/prompttexts";
import SummariesSidenav from "./sidenavsummaries";
import SoftSelect from "components/SoftSelect";
import ComplexProjectCard from "examples/Cards/ProjectCards/ComplexProjectCard";
import { ClockLoader } from "react-spinners";
import { ScaleLoader } from "react-spinners";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import Switch from "@mui/material/Switch";
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc, getDocs, collection, query, where, updateDoc, increment, deleteField, deleteDoc, addDoc, serverTimestamp } from "firebase/firestore";
import "../../../../firebase"
import { Icon } from "@mui/material";
import LoadingSpinner from "./components/ringLoader";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VoiceglowChatbot from "./components/chatbot";
import MyChat from "./components/customChatbot";
import VoiceflowChat from "./components/voiceflowCsutom";
import FreeTrialPrompt from "examples/NotLoggedIn/freeTrial";
import NoteSection from "./components/noteSection";
import { object } from "prop-types";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined';






const assemblyai = axios.create({
    baseURL: 'https://api.assemblyai.com/v2',
    headers: {
        authorization: process.env.REACT_APP_ASSEMBLY_API_KEY,
        'content-type': 'application/json',
    },
});

const initialState = {
    url: null,
    blob: null,
    chunks: null,
    duration: {
        h: 0,
        m: 0, 
        s: 0,
    },
}

const deepgram = axios.create({
    baseURL: 'https://api.deepgram.com/v1',
    headers: {
        Authorization: `Token ${process.env.REACT_APP_DEEPGRAM_API_KEY}`,
    },
});

  
  






const db = getFirestore();



function RecordingAudio() {

    
  const [inactivityTimeoutId, setInactivityTimeoutId] = useState(null);
  const [silenceTimeoutId, setSilenceTimeoutId] = useState(null);
const [audioDetails, setAudioDetails] = useState(initialState);
    const [transcript, setTranscript] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingNewTranscript, setIsLoadingNewTranscript] = useState(false);
    const [summaries, setSummaries] = useState({});
    const [templateSummaries, setTemplateSummaries] = useState({});
    const [patientName, setPatientName] = useState(''); 
    const [patientNameBeforeUpload, setPatientNameBeforeUpload] = useState(''); 
    const [patientAge, setPatientAge] = useState('');
    const [patientAgeBeforeUpload, setPatientAgeBeforeUpload] = useState('');
    const [patientGender, setPatientGender] = useState('');
    const [patientGenderBeforeUpload, setPatientGenderBeforeUpload] = useState('');
    const [userId, setUserId] = useState(null); 
    const [sessionName, setSessionName] = useState('');
    const [sessionNameBeforeUpload, setSessionNameBeforeUpload] = useState('');
    const [existingPatients, setExistingPatients] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState('');
    const [selectedPatientBeforeUpload, setSelectedPatientBeforeUpload] = useState('');
    const [patientTab, setPatientTab] = useState(0);
    const [isAddingNew, setIsAddingNew] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElInstructions, setAnchorElInstructions] = useState(null);
    const [currentInstructionId, setCurrentInstructionId] = useState(null);
    const [selectedCard, setSelectedCard] = useState(null);
    const [selectedCardBeforeUpload, setSelectedCardBeforeUpload] = useState(null);
    const [allDataGenerated, setAllDataGenerated] = useState(false);
    const [senderName, setSenderName] = useState('');
    const [senderEmail, setSenderEmail] = useState('');
    const [saveSuccessSender, setSaveSuccessSender] = useState(false);
    const [generatedEmails, setGeneratedEmails] = useState({});
    //const [recordingTime, setRecordingTime] = useState({ h: 0, m: 0, s: 0, ms: 0 });
    const [showRecordingTime, setShowRecordingTime] = useState(false);
    const [hasActiveOrTrialSubscription, setHasActiveOrTrialSubscription] = useState(true);
    const [editingPromptName, setEditingPromptName] = useState(null);
    const [saveSuccessTemplate, setSaveSuccessTemplate] = useState(false);
    const [isRegenerating, setIsRegenerating] = useState({});
    const [isRegeneratingTemplate, setIsRegeneratingTemplate] = useState({});
    const [anchorElTemplateSummary, setAnchorElTemplateSummary] = useState(null);
    const [currentSummary, setCurrentSummary] = useState(null);
    const [recordingTime, setRecordingTime] = useState(0);
    const [editMode, setEditMode] = useState({});
    const [editedText, setEditedText] = useState({});
    const [editModeInstruction, setEditModeInstruction] = useState({});
    const [editedInstructionText, setEditedInstructionText] = useState({});
    const [editModeTemplate, setEditModeTemplate] = useState({});
    const [editedTextTemplate, setEditedTextTemplate] = useState({});
    const [editModeTranscript, setEditModeTranscript] = useState(false);
    const [editedTextTranscript, setEditedTextTranscript] = useState({});
    const [templateSearchTerm, setTemplateSearchTerm] = useState('');
    const [summariesSearchTerm, setSummariesSearchTerm] = useState('');
    const [isCardExpanded, setIsCardExpanded] = useState(false);
    const [transcriptSearchTerm, setTranscriptSearchTerm] = useState('');
    const [uploadState, setUploadState] = useState(false);
    const [isTranscriptEdited, setIsTranscriptEdited] = useState(false);
    const [transcriptChangesSuccess, setIsTranscriptChangesSuccess] = useState(false);
    const [templates, setTemplates] = useState([])
    const [addingNewTemplate, setAddingNewTemplate] = useState(false);
    const [newTemplateName, setNewTemplateName] = useState('');
    const [newTemplateDescription, setNewTemplateDescription] = useState('');
    const [saveSuccessNewTemplates, setSaveSuccessNewTemplates] = useState(false);
    const [newTemplateSummary, setNewTemplateSummary] = useState({ name: "", content: "" });
    const [newAddSummaryTemplate, setNewAddSummaryTemplate] = useState({ name: "", content: "" });
    const [newTemplateSummaries, setNewTemplateSummaries] = useState([]);
    const [copyAllTemplate, setCopyAllTemplate] = useState(false);
    const [copyTemplateSummary, setCopyTemplateSummary] = useState(false);
    const [copyAllSummary, setCopyAllSummary] = useState(false);
    const [copySummary, setCopySummary] = useState(false);
    const [uploadComplete, setUploadComplete] = useState(false);
    const [currentTemplateId, setCurrentTemplateId] = useState(null);
    const [addNewSummaryTemplate, setAddNewSummaryTemplate] = useState(false);
    const addNewSummaryRef = useRef(null);
    const [isInputValid, setIsInputValid] = useState(false);
    const [errorGeneratingSummaries, setErrorGeneratingSummaries] = useState(false);
    const [errorSavingSummaries, setErrorSavingSummaries] = useState(false);
    const [errorTranscriptUndefined, setErrorTranscriptUndefined] =useState(false);
    const summaryAddRef = useRef(null);
    const [isSummaryLibraryOpen, setIsSummaryLibraryOpen] = useState(false);
    const [currentSummaryTab, setCurrentSummaryTab] = useState(0);
    const [selectedLibrarySummary, setSelectedLibrarySummary] = useState(null);
    const [librarySummaries, setLibrarySummaries] = useState({});
    const [showLibrarySummaryPrompt, setShowLibrarySummaryPrompt] = useState(false);
    const [todoNoteContent, setTodoNoteContent] = useState('');
    const [templateSummariesOrder, setTemplateSummariesOrder] = useState([]);
    const [selectedTemplateOrder, setSelectedTemplateOrder] = useState([]);
    const [templateNameToDisplay, setTemplateNameToDisplay] = useState('');
    const [isContentExpanded, setIsContentExpanded] = useState(false);
    const [newTranscript, setNewTranscript] = useState({});
    const [resetKey, setResetKey] = useState(0);
    const [silenceTime, setSilenceTime] = useState(0);
    const silenceThreshold = 2 * 60 * 60;
    const silenceVolumeThreshold = 5; // Adjust this value based on your environment
    const [lastAudioActivity, setLastAudioActivity] = useState(Date.now());
    const [recordingTimeout, setRecordingTimeout] = useState(null);
    const silenceTimeoutRef = useRef(null);

    

    const [remainingHours, setRemainingHours] = useState(0);
    const [audioUsage, setAudioUsage] = useState(0);
    const [maxHours, setMaxHours] = useState(100);


    const handleSummaryTabChange = (event, newValue) => {
        setCurrentSummaryTab(newValue);
    };
    const handleLibrarySummarySelect = (templateId) => {
        setSelectedLibrarySummary(templateId);
    };
    

    const [openTalkToNotes, setOpenTalkToNotes] = useState({});
    const [refineTemplateNotes, setRefineTemplateNotes] = useState({});
    const [isRecordingToNotes, setIsRecordingToNotes] = useState({});

    const [openTalkToSummaries, setOpenTalkToSummaries] = useState({});
    const [refineSummariesNotes, setRefineSummariesNotes] = useState({});
    const [isRecordingToSummaries, setIsRecordingToSummaries] = useState({});
    const [patientInstructions, setPatientInstructions] = useState({});
    const [saveSuccessInstruction, setSaveSuccessInstruction] = useState({});
    const [showGeneratedEmailContent, setShowGeneratedEmailContent] = useState(false);
    const [agreementEmail, setAgreementEmail] = useState(false);
    const handleSetAgreement = () => setAgreementEmail(!agreementEmail);
    const [emailSubjects, setEmailSubjects] = useState({});
    const [emailContents, setEmailContents] = useState({});
    const [emailSenderNames, setEmailSenderNames] = useState({});
    const [emailSenderEmails, setEmailSenderEmails] = useState({});
    const [patientEmail, setPatientEmail] = useState("");
    const [emailSentSuccess, setEmailSentSuccess] = useState(false);
    const [showHelp, setShowHelp] = useState(false);
    const [showHelpSecond, setShowHelpSecond] = useState(false);
    const [showHelpThird, setShowHelpThird] = useState(false);
    const [toggleReviewLink, setToggleReviewLink] = useState(false); 
    const [reviewLink, setReviewLink] = useState('');
    const [templateLibrary, setTemplateLibrary] = useState(false);
    const templateAddref = useRef(null);
    const [currentLibraryTab, setCurrentLibraryTab] = useState(0);
    const [selectedLibraryTemplate, setSelectedLibraryTemplate] = useState(null);
    const [expandedTemplateSummaries, setExpandedTemplateSummaries] = useState({});
    const [showLibrarySummaries, setShowLibrarySummaries] = useState(false);
    const [showLibrarySummariesNewTemplate, setShowLibrarySummariesNewTemplate] = useState(false);
    const [tempDisableUpload, setTempDisableUpload] = useState(false);

    const handleToggleLibrarySummaries = () => {
        setShowLibrarySummaries(!showLibrarySummaries);
    };    

    const handleToggleLibrarySummariesNewTemplate = () => {
        setShowLibrarySummariesNewTemplate(!showLibrarySummariesNewTemplate);
    };

    const toggleSummaryExpansion = (summaryName) => {
        setExpandedTemplateSummaries((prevExpandedSummaries) => ({
            ...prevExpandedSummaries,
            [summaryName]: !prevExpandedSummaries[summaryName],
        }));
    };

    const toggleContentVisibility = () => {
        setIsContentExpanded(!isContentExpanded);
    };    
    


    const handleLibraryTabChange = (event, newValue) => {
        setCurrentLibraryTab(newValue);
    };
    const handleLibrarySelect = (templateId) => {
        setSelectedLibraryTemplate(templateId);
    };


    const [libraryTemplates, setLibraryTemplates] = useState({});
    const [expandedSummaryIds, setExpandedSummaryIds] = useState({});
      

    // States for each controller card
    const [sentimentAnalysis, setSentimentAnalysis] = useState(localStorage.getItem('sentimentAnalysis') === 'true');
    const [entityDetection, setEntityDetection] = useState(localStorage.getItem('entityDetection') === 'true');
    const [keyPhrases, setKeyPhrases] = useState(localStorage.getItem('keyPhrases') === 'true');
    const [topicDetection, setTopicDetection] = useState(localStorage.getItem('topicDetection') === 'true');
    const [speakerDiarization, setSpeakerDiarization] = useState(localStorage.getItem('speakerDiarization') === 'true');
    const [contentModeration, setContentModeration] = useState(localStorage.getItem('contentModeration') === 'true');
    const [textFormatting, setTextFormatting] = useState(localStorage.getItem('textFormatting') === 'true');
    const [punctuation, setPunctuation] = useState(localStorage.getItem('punctuation') === 'true');
    const [selectedPrompts, setSelectedPrompts] = useState({})
    const [selectedInstructions, setSelectedInstructions] = useState(() => {
        // Attempt to retrieve any previously selected instructions from local storage
        const saved = localStorage.getItem("selectedInstructions");
        const initialSelection = saved ? JSON.parse(saved) : null;
      
        // If there's nothing saved yet, default to selecting "Comprehensive" and "Concise"
        if (!initialSelection || initialSelection.length === 0) {
          // Assuming instruction.id or instruction.title are the strings "Comprehensive" and "Concise"
          const defaultSelection = ["Comprehensive Instruction"];
          localStorage.setItem("selectedInstructions", JSON.stringify(defaultSelection));
          return defaultSelection;
        }
      
        return initialSelection;
    });
    const [promptsData, setPromptsData] = useState({});
    const [newPromptText, setNewPromptText] = useState('');
    const [newPromptName, setNewPromptName] = useState('');
    const [isAddPromptOpen, setIsAddPromptOpen] = useState(false);
    const [currentUserSubscription, setCurrentUserSubscription] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const loaderRef = useRef(null);
    const loaderRefNewTranscript = useRef(null);

    const [originalTranscript, setOriginalTranscript] = useState(null);
    const [showDropzone, setShowDropzone] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [providerName, setProviderName] = useState('');
    const [selectedSummaries, setSelectedSummaries] = useState({});
    const [selectedTemplateSummaries, setSelectedTemplateSummaries] = useState({});
    const [copySelectedSummary, setCopySelectedSummary] = useState(false);
    const [copySelectedTemplateSums, setCopySelectedTemplateSums] = useState(false);
    const [isCopyDialogOpen, setIsCopyDialogOpen] = useState(false);
    const [newCopiedTemplateName, setNewCopiedTemplateName] = useState("");

    useEffect(() => {
        const auth = getAuth();
        const db = getFirestore();
        onAuthStateChanged(auth, user => {
            if (user) {
                const userRef = doc(db, "users", user.uid);

                // Fetch user's audio usage
                getDoc(userRef).then(docSnap => {
                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        setAudioUsage(data.totalSeconds || 0);
                    }
                });

                // Fetch user's subscription details and calculate remaining hours
                const userSubDoc = collection(db, 'customerDetails', user.uid, 'subscriptions');
                getDocs(userSubDoc).then(docSnap => {
                    let latestSubscription = null;

                    docSnap.forEach(doc => {
                        const subscriptionData = doc.data();
                        if (!latestSubscription || subscriptionData.current_period_start.toDate() > latestSubscription.current_period_start.toDate()) {
                            if (["active", "trialing"].includes(subscriptionData.status)) {
                                latestSubscription = subscriptionData;
                            }
                        }
                    });

                    const planHoursMapping = {
                        "price_1P3kdWLiDfhhXJlFnroutVz5": 70,
                        "price_1P3kgVLiDfhhXJlFyAPLbcjy": 120,
                        "price_1P5UcILiDfhhXJlFkZDmU8VZ": 250,
                        "price_1PIu0ZLiDfhhXJlFNePzCIzm": 250,
                    };

                    if (latestSubscription) {
                        const planId = latestSubscription.items[0].plan.id;
                        const hours = planHoursMapping[planId] || 0; // Fallback to a default
                        setMaxHours(hours);
                    }
                });
            }
        });
    }, []);

    // Calculate remaining hours every time maxHours or audioUsage changes
    useEffect(() => {
        const usedHours = Number((audioUsage / 3600).toFixed(2)); // Convert seconds to hours
        const remaining = Math.max(maxHours - usedHours, 0);
        setRemainingHours(remaining);
    }, [maxHours, audioUsage]);
    useEffect(() => {
  if (!audioDetails.blob) return;

  const checkInactivity = () => {
    const now = Date.now();
    const timeSinceLastActivity = now - lastAudioActivity;

    if (timeSinceLastActivity >= 2 * 60 * 60 * 1000) { // 2 hours in milliseconds
      console.log("No audio activity for 2 hours. Stopping recording...");
      handleAudioStop(audioDetails); // Manually stop recording
      clearInterval(silenceTimeoutRef.current);
    }
  };

  // Set interval to check every minute
  silenceTimeoutRef.current = setInterval(checkInactivity, 60000);

  return () => clearInterval(silenceTimeoutRef.current);
}, [audioDetails.blob, lastAudioActivity]);


    useEffect(() => {
        const fetchTemplateSummaryOrder = async () => {
            if (!selectedTemplate || !userId) return;
    
            const db = getFirestore();
            // Assuming the order is stored at the template level
            const templateRef = doc(db, `users/${userId}/templateprompts`, selectedTemplate.name);
    
            try {
                const templateDoc = await getDoc(templateRef);
                if (templateDoc.exists()) {
                    const templateData = templateDoc.data();
                    // Check if the order exists in the document, otherwise set a default order or leave it empty
                    const order = templateData.summariesOrder ? templateData.summariesOrder : selectedTemplate.associatedPrompts.map(prompt => prompt.id);
                    setTemplateSummariesOrder(order);
                } else {
                    console.log("No such template!");
                    setTemplateSummariesOrder([]); // Reset to default or keep previous order
                }
            } catch (error) {
                console.error("Error fetching template summary order:", error);
                setTemplateSummariesOrder([]); // Reset to default or keep previous order in case of error
            }
        };
    
        fetchTemplateSummaryOrder();
    }, [selectedTemplate, userId]);

    useEffect(() => {
        const fetchSelectedCardSummaryOrder = async () => {
            if (!templateNameToDisplay || !userId) return;
            
            const db = getFirestore();
            const cardRef = doc(db, `users/${userId}/templateprompts`, templateNameToDisplay);
            
            try {
                const cardDoc = await getDoc(cardRef);
                if (cardDoc.exists()) {
                    const cardData = cardDoc.data();
                    // Check if the order exists, otherwise use a default
                    const order = cardData.summariesOrder ? cardData.summariesOrder : cardData.associatedPrompts.map(prompt => prompt.id);
                    setSelectedTemplateOrder(order);
                } else {
                    console.log("No such card!");
                    setSelectedTemplateOrder([]); // Reset to default
                }
            } catch (error) {
                console.error("Error fetching card summary order:", error);
                setSelectedTemplateOrder([]); // Reset in case of error
            }
        };
    
        fetchSelectedCardSummaryOrder();
    }, [templateNameToDisplay, userId]);
    
    
    // A function to help reorder the list based on drag & drop
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
    
        return result;
    };
    
    const onDragEnd = (result) => {
        // Destructure necessary properties from result
        const { destination, source } = result;
    
        // If the item is dropped outside the list or dropped in the same place, do nothing
        if (!destination || (destination.droppableId === source.droppableId && destination.index === source.index)) {
            return;
        }
    
        // Create a new copy of your summaries array
        const newSummariesOrder = Array.from(templateSummariesOrder);
        // Remove the dragged item from its original position
        const [reorderedItem] = newSummariesOrder.splice(source.index, 1);
        // Insert the dragged item at its new position
        newSummariesOrder.splice(destination.index, 0, reorderedItem);
    
        // Update the state to reflect the new summaries order
        setTemplateSummariesOrder(newSummariesOrder);
    
        // Optionally, update the order in the backend or local storage
        saveSummariesOrder(newSummariesOrder);
    };

    const saveSummariesOrder = async (newOrder) => {
        const db = getFirestore();
        const templateRef = doc(db, `users/${userId}/templateprompts`, selectedTemplate.name);
    
        try {
            await updateDoc(templateRef, {
                summariesOrder: newOrder
            });
            console.log("Order updated successfully");
        } catch (error) {
            console.error("Error updating order:", error);
        }
    };
    
    
    


    const handleOpenCopyTemplateDialog = () => {
        setIsCopyDialogOpen(true);
        handleCloseMenu();
    };
    
    const handleCloseCopyTemplateDialog = () => {
        setIsCopyDialogOpen(false);
        setNewTemplateName(""); // Reset the new template name for next use
    };

    const handleCopyTemplate = async () => {
        const db = getFirestore();
        const user = getAuth().currentUser;
    
        if (!user) {
            console.error("User not authenticated");
            return;
        }
    
        if (!newTemplateName || newTemplateName.trim() === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Template Name',
                text: 'Please enter a name for the template copy.',
                confirmButtonColor: '#344767',
                confirmButtonText: 'OK'
            });
            return; 
        }
    
        const originalTemplate = selectedTemplate;

        const originalTemplateRef = doc(db, `users/${user.uid}/templateprompts`, originalTemplate.id);
    
        try {
            const originalTemplateDoc = await getDoc(originalTemplateRef);
            if (!originalTemplateDoc.exists()) {
                console.error("Original template does not exist.");
                return;
            }
            const originalTemplateData = originalTemplateDoc.data();
    
            // Prepare the new template data
            const newTemplateData = {
                name: newTemplateName,
                description: originalTemplateData.description,
                iconName: originalTemplateData.iconName,
                summariesOrder: originalTemplateData.summariesOrder, // Copying the summariesOrder from the original
            };
    
            // Create a new template document with the specified copy name
            const newTemplateRef = doc(collection(db, `users/${user.uid}/templateprompts`), newTemplateName);
            await setDoc(newTemplateRef, newTemplateData);
    
            // Copy over the summaries
            const summariesCollectionRef = collection(originalTemplateRef, 'summaries');
            const summariesSnapshot = await getDocs(summariesCollectionRef);
            summariesSnapshot.forEach(async (summaryDoc) => {
                const newSummaryRef = doc(collection(newTemplateRef, 'summaries'), summaryDoc.id);
                await setDoc(newSummaryRef, summaryDoc.data());
            });
    
            console.log("Template and summaries copied successfully");
            handleCloseCopyTemplateDialog(); 
            showSnackbar("dark", "notifications", "Template Copied Successfully!", "Your copied template will be available shortly");
            fetchTemplates();
        } catch (error) {
            console.error("Error copying template and summaries:", error);
        }
    };
    
    


    const toggleSummarySelection = (summaryId) => {
        setSelectedSummaries((prev) => ({
          ...prev,
          [summaryId]: !prev[summaryId],
        }));
    };
    
    const toggleTemplateSummarySelection = (summaryId) => {
        setSelectedTemplateSummaries(prev => ({
            ...prev,
            [summaryId]: !prev[summaryId],
        }));
    };

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
            const loadToDoNoteContent = async () => {
                try {
                    const db = getFirestore();
                    const toDoDocRef = doc(db, "TODO/Todo note");
                    const toDoDoc = await getDoc(toDoDocRef);

                    if (toDoDoc.exists()) {
                        console.log("TODO: ", toDoDoc.data().content); 
                        setTodoNoteContent(toDoDoc.data().content); 
                    } else {
                        console.log("No such to-do note document!");
                    }
                } catch (error) {
                    console.log(" could not retrieve to do doc")
                }   
            };
            loadToDoNoteContent();
        }
        });
        return () => unsubscribe();
    }, []);
    
    const handleGenerateTodoNote = async () => {
        const todoContent = todoNoteContent; 
        const userId = getAuth().currentUser?.uid;
        if (!userId) {
            console.error('User is not logged in.');
            return;
        }
    
        const combinedPrompt = `<prompt>\n${todoContent}\n</prompt>\n\n<conversation>${transcript.data.results.channels[0].alternatives[0].paragraphs.transcript}\n</conversation>`; 
    
        try {
            const response = await fetch('https://stt-react-native-app.web.app/api/openai', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ prompt: combinedPrompt })
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const data = await response.json();
            const todoNoteText = data
    
            
            const db = getFirestore();
            let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
            const todoNotesRef = doc(db, `users/${userId}/tdNotes`, patientToUse);
            await setDoc(todoNotesRef, { content: todoNoteText, createdAt: serverTimestamp(), visitName: sessionName });
    
            console.log('Todo note successfully generated and stored.');
        } catch (error) {
            console.error('Error generating or storing todo note:', error);
        }
    };
    


    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
            const fetchUserNames = async () => {
                try {
                    const db = getFirestore();
                    const userDocRef = doc(db, "users", user.uid);
                    const userDoc = await getDoc(userDocRef);

                    const fullName = `${userDoc.data().firstname} ${userDoc.data().lastname}`;
                    console.log(" full name: ", fullName)
                    setProviderName(fullName);
                } catch (error) {
                    console.log(" could not retrieve user name")
                }   
            };
            fetchUserNames();
        }
        });
        return () => unsubscribe();
    }, []);

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    const openLibraryModal = () => {
        setTemplateLibrary(true);
    };
    
    // Function to close the modal
    const closeLibraryModal = () => {
        setTemplateLibrary(false);
    };

    const openSummaryLibrary = () => setIsSummaryLibraryOpen(true);
    const closeSummaryLibrary = () => setIsSummaryLibraryOpen(false);

    const fetchAndUpdatePromptsData = async () => {
        const db = getFirestore();
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
            const promptsRef = collection(db, `users/${user.uid}/prompts`);
            try {
                const querySnapshot = await getDocs(promptsRef);
                let promptsData = {};
                querySnapshot.forEach((doc) => {
                    promptsData[doc.id] = doc.data().content;
                });
                setPromptsData(promptsData);
            } catch (error) {
                console.error("Error fetching prompts:", error);
            }
        }
    };

    const renderInlineLibrarySummaries = () => {
        const professionNames = ["Psychiatry", "Therapy", "Medical", "Psychology", "General"]; 
        const currentProfession = professionNames[currentSummaryTab];
        const summaries = librarySummaries[currentProfession] || [];
        const selectedSummary = summaries.find(s => s.id === selectedLibrarySummary);
    
        return (
            <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" flexGrow={1} pt={4} pb={4} sx={{ width: '100%' }}>
                <SoftBadge
                    variant="contained"
                    color="warning"
                    size="md"
                    sx={{pb: 3}}
                    badgeContent={
                        <SoftTypography variant="h6">Choose your profession</SoftTypography>
                    }
                    container
                />
                <SoftBox sx={{ width: {md: '90%',lg: '90%', xl: '90%', xxl: '80%' }}} >
                    <AppBar position="static">
                        <Tabs value={currentSummaryTab} onChange={handleSummaryTabChange}>
                            {professionNames.map((name, index) => (
                                <Tab key={index} label={name} />
                            ))}
                        </Tabs>
                    </AppBar>
                </SoftBox>
                                
                <SoftBox display="flex" flexGrow={1} pt={3} sx={{ width: '100%', mt: 3 }}>
                    {/* Left Column: Summaries List */}
                    <SoftBox pt={2} width="35%" >
                        <SoftBox p={2} mb={3} display="flex" justifyContent="flex-start" alignItems="center" >
                            <SoftBadge
                                variant="contained"
                                color="warning"
                                size="md"
                                badgeContent={
                                    <SoftTypography variant="h6" >
                                        Summaries For {currentProfession}
                                    </SoftTypography>
                                }
                                container
                            />
                        </SoftBox>
                        <SoftBox pt={1} sx={{ width: '95%', maxHeight: '550px', overflowY: 'auto', pr: 2 }}>
                            {summaries.map((summary, index) => (
                                <SoftBox key={index} pb={1} px={0}>
                                    <Card
                                        sx={{
                                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                                            border: selectedLibrarySummary === summary.id ? '2px solid #344767' : '1px solid #e9ecef',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => handleLibrarySummarySelect(summary.id)}
                                    >
                                        <SoftBox p={2} display="flex" justifyContent="flex-start" alignItems="center">
                                            <SoftTypography sx={{ ml: 2 }} color="dark" variant="button">
                                                {summary.id}
                                            </SoftTypography>
                                        </SoftBox>
                                    </Card>
                                </SoftBox>
                            ))}
                        </SoftBox>
                    </SoftBox>

                    {/* Right Column: Selected Summary Content */}
                    <SoftBox width="65%" sx={{ overflowY: 'auto', pl: 3 }}>
                        {selectedSummary ? (
                            <>  <SoftBox px={2} >
                                    <SoftBox pt={4} pb={3} display="flex" justifyContent="center" alignItems="center">
                                        <SoftBadge
                                            variant="contained"
                                            color="secondary"
                                            size="md"
                                            badgeContent={
                                                <SoftTypography variant="h6" >
                                                    Selected Summary details
                                                </SoftTypography>
                                            }
                                            container
                                        />
                                    </SoftBox>


                                    <SoftBox py={2} display="flex" justifyContent="space-between" alignItems="center">
                                        <SoftTypography sx={{ mr: 2}} variant="h5">{selectedSummary.id}</SoftTypography>
                                        <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 Content viewing is available for Platinum and Gold Package subscribers only." : ""}>
                                            <span>
                                                <SoftButton 
                                                    onClick={toggleContentVisibility}
                                                    variant="outlined" 
                                                    color="dark"
                                                    disabled={currentUserSubscription === "Silver Subscription"}
                                                >
                                                    {isContentExpanded ? 'Collapse' : 'Show Summary Content'}
                                                </SoftButton>
                                            </span>
                                        </Tooltip>
                                    </SoftBox>
                                    {isContentExpanded && (
                                        <SoftBox my={2} sx={{ maxHeight: '300px', overflowY: 'auto', ml:1 }} >
                                            <SoftTypography variant="body2" sx={{ mt: 2, mb:3 }}>
                                                {selectedSummary.content}
                                            </SoftTypography>
                                        </SoftBox>
                                    )}

                                    
                                    <SoftBox py={2} pt={4} display="flex" justifyContent="center" alignItems="center">
                                        <Tooltip 
                                            title={currentUserSubscription === "Silver Subscription" ? "🔔 This feature is available for Platinum and Gold Package subscribers only." : `Import ${selectedSummary.id} to ${currentTemplateId}`} 
                                            placement="top"
                                        >
                                            <span> {/* Tooltip needs a span if the child is disabled */}
                                                <SoftButton 
                                                    startIcon={<AddTaskOutlinedIcon />} 
                                                    variant="contained" 
                                                    color="dark" 
                                                    onClick={() => handleImportLibrarySummaryToTemplate(selectedSummary)}
                                                    disabled={currentUserSubscription === "Silver Subscription"}
                                                >
                                                    Import {selectedSummary.id} to {currentTemplateId}
                                                </SoftButton>
                                            </span>
                                        </Tooltip>
                                    </SoftBox>
                                    <SoftBox display="flex" justifyContent="center" alignItems="center" p={2} sx={{ width: '100%' }} >
                                        <SoftTypography variant="body2" sx={{ mb: 2, mt: 2 }}>
                                            <strong>Note:</strong> Summaries in the library cannot be edited directly. For customization, please import the summary into your template, where you can freely edit and adjust them to your liking (according to your subscription).
                                        </SoftTypography>
                                    </SoftBox>
                                </SoftBox> 
                            </>
                        ) : (
                            <SoftBox display="flex" justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
                                <SoftTypography variant="h6" color="text">Select a summary to view its content.</SoftTypography>
                            </SoftBox>
                        )}
                    </SoftBox>
                </SoftBox>
            </SoftBox>
        );
    };

    const renderInlineLibrarySummariesNewTemplate = () => {
        const professionNames = ["Psychiatry", "Therapy", "Medical", "Psychology", "General"]; 
        const currentProfession = professionNames[currentSummaryTab];
        const summaries = librarySummaries[currentProfession] || [];
        const selectedSummary = summaries.find(s => s.id === selectedLibrarySummary);
    
        return (
            <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" flexGrow={1} pt={4} pb={4} sx={{ width: '100%' }}>
                <SoftBadge
                    variant="contained"
                    color="warning"
                    size="md"
                    sx={{pb: 3}}
                    badgeContent={
                        <SoftTypography variant="h6">Choose your profession</SoftTypography>
                    }
                    container
                />
                <SoftBox sx={{ width: {md: '90%',lg: '90%', xl: '90%', xxl: '80%' }}} >
                    <AppBar position="static">
                        <Tabs value={currentSummaryTab} onChange={handleSummaryTabChange}>
                            {professionNames.map((name, index) => (
                                <Tab key={index} label={name} />
                            ))}
                        </Tabs>
                    </AppBar>
                </SoftBox>
                                
                <SoftBox display="flex" flexGrow={1} pt={3} sx={{ width: '100%', mt: 3 }}>
                    {/* Left Column: Summaries List */}
                    <SoftBox pt={2} width="35%" >
                        <SoftBox p={2} mb={3} display="flex" justifyContent="flex-start" alignItems="center" >
                            <SoftBadge
                                variant="contained"
                                color="warning"
                                size="md"
                                badgeContent={
                                    <SoftTypography variant="h6" >
                                        Summaries For {currentProfession}
                                    </SoftTypography>
                                }
                                container
                            />
                        </SoftBox>
                        <SoftBox pt={1} sx={{ maxHeight: '550px', overflowY: 'auto', pr: 2 }}>
                            {summaries.map((summary, index) => (
                                <SoftBox key={index} pb={1} px={1}>
                                    <Card
                                        sx={{
                                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                                            border: selectedLibrarySummary === summary.id ? '2px solid #344767' : '1px solid #e9ecef',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => handleLibrarySummarySelect(summary.id)}
                                    >
                                        <SoftBox p={2} display="flex" justifyContent="flex-start" alignItems="center">
                                            <SoftTypography sx={{ ml: 2 }} color="dark" variant="button">
                                                {summary.id}
                                            </SoftTypography>
                                        </SoftBox>
                                    </Card>
                                </SoftBox>
                            ))}
                        </SoftBox>
                    </SoftBox>

                    {/* Right Column: Selected Summary Content */}
                    <SoftBox width="65%" sx={{ overflowY: 'auto', pl: 3 }}>
                        {selectedSummary ? (
                            <>
                            <SoftBox px={2} >
                                <SoftBox pt={4} pb={3} display="flex" justifyContent="center" alignItems="center">
                                    <SoftBadge
                                        variant="contained"
                                        color="secondary"
                                        size="md"
                                        badgeContent={
                                            <SoftTypography variant="h6" >
                                                Selected Summary details
                                            </SoftTypography>
                                        }
                                        container
                                    />
                                </SoftBox>


                                <SoftBox py={2} display="flex" flexDirection="column" alignItems="center" sx={{ width: '100%' }}>
                                    <SoftBox py={2} display="flex" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
                                        <SoftTypography sx={{ mr: 2 }} variant="h5">{selectedSummary.id}</SoftTypography>
                                        <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 Content viewing is available for Platinum and Gold Package subscribers only." : ""}>
                                            <span>
                                                <SoftButton 
                                                    onClick={toggleContentVisibility}
                                                    variant="outlined" 
                                                    color="dark"
                                                    disabled={currentUserSubscription === "Silver Subscription"}
                                                >
                                                    {isContentExpanded ? 'Collapse' : 'Show Summary Content'}
                                                </SoftButton>
                                            </span>
                                        </Tooltip>
                                    </SoftBox>
                                    {isContentExpanded && (
                                        <SoftBox my={2} sx={{ maxHeight: '300px', overflowY: 'auto', width: '100%' }}>
                                            <SoftTypography variant="body2" sx={{ mt: 2, mb:3 }}>
                                                {selectedSummary.content}
                                            </SoftTypography>
                                        </SoftBox>
                                    )}
                                </SoftBox>



                                <Tooltip 
                                    title={currentUserSubscription === "Silver Subscription" ? "🔔 This feature is available for Platinum and Gold Package subscribers only." : `Import ${selectedSummary.id} to new template`} 
                                    placement="top"
                                >
                                    <span>
                                    <SoftBox py={2} display="flex" justifyContent="center" alignItems="center">
                                        <SoftButton startIcon={<AddTaskOutlinedIcon />} variant="contained" color="dark" disabled={currentUserSubscription === "Silver Subscription"} onClick={() => handleImportLibrarySummaryToNewTemplate(selectedSummary)}>
                                            Include {selectedSummary.id} in new template
                                        </SoftButton>
                                    </SoftBox>
                                    </span>
                                </Tooltip>


                                <SoftBox display="flex" justifyContent="center" alignItems="center" p={2} sx={{ width: '100%' }} >
                                    <SoftTypography variant="body2" sx={{ mb: 2, mt: 2 }}>
                                        <strong>Note:</strong> Summaries in the library cannot be edited directly. For customization, please import the summary into your template, where you can freely edit and adjust them to your liking.
                                    </SoftTypography>
                                </SoftBox>
                            </SoftBox>
                            </>
                        ) : (
                            <SoftBox display="flex" justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
                                <SoftTypography variant="h6" color="text">Select a summary to view its content.</SoftTypography>
                            </SoftBox>
                        )}
                    </SoftBox>
                </SoftBox>
            </SoftBox>
        );
    };
    


    const handleSummaryClick = (summaryId) => {
        setExpandedSummaryIds(prevState => ({
            ...prevState,
            [summaryId]: !prevState[summaryId] // Toggle expanded state for the clicked summary
        }));
    };

    const handleImportTemplate = async (selectedTemplate) => {
        const db = getFirestore();
        const user = getAuth().currentUser;
    
        if (!user) {
            console.error("User not authenticated");
            return;
        }
    
        if (!selectedTemplate) {
            console.error("No template selected for import");
            return;
        }
    
        const templateRef = doc(collection(db, `users/${user.uid}/templateprompts`), selectedTemplate.name);
    
        const templateData = {
            name: selectedTemplate.name,
            description: selectedTemplate.description,
            iconName: selectedTemplate.iconName || "library_add",
            summariesOrder: selectedTemplate.summariesOrder 
        };
    
        try {
            // Save the template data
            await setDoc(templateRef, templateData);
    
            // Save each summary as a sub-document under this template
            if (selectedTemplate.summaries) {
                const summariesRef = collection(templateRef, 'summaries');

                await Promise.all(selectedTemplate.summaries.map(async (summary) => {
                    const summaryRef = doc(summariesRef, summary.id); 
                    const summaryData = { content: summary.content };
                    await setDoc(summaryRef, summaryData);
                }));

            }
    
            showSnackbar("dark", "notifications", "Template Imported Successfully!", "Your new template will be available shortly");
            await fetchTemplates(); // Refresh the user's templates to include the newly imported one
        } catch (error) {
            console.error("Error importing template:", error);
            // Optionally, handle errors (e.g., show error message to the user)
        }
    };
    
    

    useEffect(() => {
        const db = getFirestore();
        const professions = ["Psychiatry", "Therapy", "Medical"]; // Add more professions as necessary
    
        const fetchTemplatesForProfession = async (profession) => {
            const templatesRef = collection(db, `templatesLibrary/${profession}/templates`);
            const querySnapshot = await getDocs(templatesRef);
    
            // Map over each template to fetch its summaries from a subcollection
            const templatesWithSummariesPromises = querySnapshot.docs.map(async (doc) => {
                const templateData = {
                    id: doc.id,
                    ...doc.data(),
                };
    
                // Attempt to fetch summaries from the subcollection
                const summariesRef = collection(db, `templatesLibrary/${profession}/templates/${doc.id}/summaries`);
                const summariesSnapshot = await getDocs(summariesRef);
                const summaries = summariesSnapshot.docs.map(summaryDoc => ({
                    id: summaryDoc.id,
                    content: summaryDoc.data().content 
                }));
    
                // Add summaries to the template data, if available
                if (summaries.length > 0) {
                    templateData.summaries = summaries;
                }
    
                return templateData;
            });
    
            // Wait for all summaries to be fetched and added to their respective templates
            const templatesWithSummaries = await Promise.all(templatesWithSummariesPromises);
            return templatesWithSummaries;
        };
    
        const fetchAllTemplates = async () => {
            let allTemplates = {};
            
            // Fetch templates and summaries for each profession
            const professionsTemplatesPromises = professions.map(async (profession) => {
                allTemplates[profession] = await fetchTemplatesForProfession(profession);
            });
    
            // Wait for all professions' templates and summaries to be fetched
            await Promise.all(professionsTemplatesPromises);
            setLibraryTemplates(allTemplates);
        };
    
        fetchAllTemplates();
    }, []);
    

    const renderTemplatesForCurrentTab = () => {
        const professionNames = ["Psychiatry", "Therapy", "Medical"]; 
        const currentProfession = professionNames[currentLibraryTab];
        const templates = libraryTemplates[currentProfession] || [];

        const selectedTemplate = templates.find(template => template.id === selectedLibraryTemplate);

    
        return (
            <SoftBox display="flex" flexDirection="column" flexGrow={1} pt={3} pl={2} pb={4}>
                <SoftBox display="flex" flexGrow={1} sx={{ overflow: 'hidden' }}>
                    <SoftBox pl={2} pt={2} sx={{ width: '20%' }}>

                        <SoftBox p={2} display="flex" justifyContent="center" alignItems="center" >
                            <SoftTypography variant="h6" >
                                Templates For {currentProfession}
                            </SoftTypography>
                        </SoftBox>
                        {templates.map((template) => (
                            <SoftBox key={template.id} pb={1} >
                                <Card  sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', border: selectedLibraryTemplate === template.id ? '1px solid #344767' : 'none', cursor: 'pointer' }} onClick={() => handleLibrarySelect(template.id)} >
                                    <SoftBox p={2}  display="flex" justifyContent="flex-start" alignItems="center">
                                        <Icon>{template.iconName}</Icon>
                                        <SoftTypography sx={{ ml:2 }} color="dark" variant="h6">
                                            {template.name}
                                        </SoftTypography>
                                    </SoftBox>
                                </Card>
                            </SoftBox>
                        ))}
                    </SoftBox>
    
                    <SoftBox pt={3} sx={{ width: '75%', overflow: 'auto', pl: 2 }}>
                        {selectedTemplate ? (
                            <>
                                <SoftBox py={2} pl={4} display="flex" justifyContent="space-between" >
                                    <SoftTypography variant="h5" >
                                        {selectedTemplate.name}
                                    </SoftTypography>
                                    <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 Importing templates is available for Platinum and Gold Package subscribers only." : "Import this template to your personal templates"} placement="top" >
                                        <span> 
                                            <SoftButton 
                                                startIcon={<AddTaskOutlinedIcon />} 
                                                variant="contained" 
                                                color="dark" 
                                                size="medium" 
                                                onClick={() => handleImportTemplate(selectedTemplate)}
                                                disabled={currentUserSubscription === "Silver Subscription"} 
                                            >
                                                Import {selectedTemplate.name}
                                            </SoftButton>
                                        </span>
                                    </Tooltip>

                                </SoftBox>
                                <SoftBox pl={4} sx= {{ width: '60%' }} display="flex" justifyContent="flex-start" >
                                    <SoftTypography variant="body2" sx={{ mb: 2 }}>
                                        {selectedTemplate.description || "No description available."}
                                    </SoftTypography>
                                </SoftBox>
                                
                                    {/* Assuming summaries is an array of string */}
                                {selectedTemplate && selectedTemplate.summaries && selectedTemplate.summaries.length > 0 ? (
                                    <>
                                        <SoftBox display="flex" justifyContent="center" alignItems="center" p={2} >
                                            <SoftBadge
                                                variant="contained"
                                                color="secondary"
                                                size="md"
                                                sx={{ mb: 2, mt: 2 }}
                                                badgeContent={
                                                    <SoftTypography variant="h6" >
                                                        Included Summaries For {selectedTemplate.name}
                                                    </SoftTypography>
                                                }
                                                container
                                            />
                                        </SoftBox>
                                        {selectedTemplate.summariesOrder.map(summaryId => {
                                            const summary = selectedTemplate.summaries.find(s => s.id === summaryId);
                                            return summary && (
                                                <SoftBox p={1} key={summary.id} sx={{ width: '80%', margin: '0 auto' }} >
                                                    <SoftBox p={2} display="flex" justifyContent="space-between" alignItems="center" sx={{ border: '1px solid #344767', borderRadius: '8px'}}  >
                                                        <SoftTypography variant="h6" sx={{ cursor: 'pointer' }} onClick={() => handleSummaryClick(summary.id)}>
                                                            {summary.id} 
                                                        </SoftTypography>
                                                        <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 Content viewing is available for Platinum and Gold Package subscribers only." : ""}>
                                                            <span>
                                                                <SoftButton 
                                                                    onClick={() => { if (currentUserSubscription !== "Silver Subscription") handleSummaryClick(summary.id); }}
                                                                    variant="outlined" 
                                                                    color="dark" 
                                                                    sx={{ ml: 2, minWidth: 'auto' }}
                                                                    disabled={currentUserSubscription === "Silver Subscription"}
                                                                >
                                                                    {expandedSummaryIds[summary.id] ? 'Collapse' : 'Show Summary Content'}
                                                                </SoftButton>
                                                            </span>
                                                        </Tooltip>
                                                    </SoftBox>
                                                    {expandedSummaryIds[summary.id] && currentUserSubscription !== "Silver Subscription" && ( 
                                                        <SoftBox ml={1} mt={1} mb={1} >
                                                            <SoftTypography variant="body2" >
                                                                {summary.content}
                                                            </SoftTypography>
                                                        </SoftBox>
                                                    )}
                                                </SoftBox>
                                            );
                                        })}
                                        <SoftBox display="flex" justifyContent="center" alignItems="center" p={2} sx={{ width: '80%', margin: '0 auto' }} >
                                            <SoftTypography variant="body2" sx={{ mb: 2, mt: 2 }}>
                                                <strong>Note:</strong> Summaries in the library cannot be edited directly. For customization, please import them into your personal notes, where you can freely edit and adjust them to your liking.
                                            </SoftTypography>
                                        </SoftBox>
                                    </>
                                ) : (
                                    <SoftBox p={4} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                                        <SoftTypography variant="body2">
                                            No summaries available.
                                        </SoftTypography>
                                    </SoftBox>
                                )}
                            </>
                        ) : (
                            <SoftBox display="flex" alignItems="center" justifyContent="center" p={4} pt={15} >
                                <SoftTypography variant="body1">
                                    Select one of the template at the left side to see details.
                                </SoftTypography>
                            </SoftBox>
                        )}
                    </SoftBox>

                </SoftBox>
            </SoftBox>
        );
    };

    const handleImportSummary = async (selectedSummary) => {
        const db = getFirestore();
        const user = getAuth().currentUser;
    
        if (!user) {
            console.error("User not authenticated");
            return;
        }
    
        if (!selectedSummary) {
            console.error("No summary selected for import");
            return;
        }
    
        // Assuming summaries are saved directly under `prompts` collection without sub-collections
        const summaryRef = doc(collection(db, `users/${user.uid}/prompts`), selectedSummary.id);
    
        const summaryData = {
            content: selectedSummary.content // The content of the summary to import
        };
    
        try {
            // Save the summary data
            await setDoc(summaryRef, summaryData);
    
            // Show success message (assuming you have a function to display success messages)
            showSnackbar("dark", "notifications", "Summary Imported Successfully!", "The imported summary will be available shortly in your personal notes.");
    
            await fetchAndUpdatePromptsData();
            // This step depends on how you're managing state and UI updates
        } catch (error) {
            console.error("Error importing summary:", error);
            // Optionally, handle errors (e.g., show error message to the user)
        }
    };
    

    useEffect(() => {
        const db = getFirestore();
        const professions = ["Psychiatry", "Therapy", "Medical"]; // Add more professions as necessary
    
        const fetchSummariesForProfession = async (profession) => {
            const summariesRef = collection(db, `summariesLibrary/${profession}/summaries`);
            const querySnapshot = await getDocs(summariesRef);
    
            // Map over each document to get its data
            const summariesData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));
    
            return summariesData;
        };
    
        const fetchAllSummaries = async () => {
            let allSummaries = {};
    
            // Fetch summaries for each profession
            for (const profession of professions) {
                allSummaries[profession] = await fetchSummariesForProfession(profession);
            }
    
            setLibrarySummaries(allSummaries); 
        };
    
        fetchAllSummaries();
    }, []);
    

    const renderSummariesForCurrentTab = () => {
        const professionNames = ["Psychiatry", "Therapy", "Medical"]; 
        const currentProfession = professionNames[currentSummaryTab];
        const summaries = librarySummaries[currentProfession] || [];

        const selectedSummary = summaries.find(s => s.id === selectedLibrarySummary);

    
        return (
            <SoftBox display="flex" flexDirection="column" flexGrow={1} pt={3} pb={4}>
                <SoftBox display="flex" flexGrow={1} >
                    <SoftBox pl={4} pt={2} sx={{ width: '25%' }}>

                        <SoftBox p={2} display="flex" justifyContent="center" alignItems="center" >
                            <SoftTypography variant="h6" >
                                Summaries For {currentProfession}
                            </SoftTypography>
                        </SoftBox>
                        <SoftBox pt={1} sx={{ maxHeight: '500px', overflowY: 'auto' }} >
                            {summaries.map((summary) => (
                                <SoftBox key={summary.id} pb={1} pr={1} >
                                    <Card  sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', border: selectedLibrarySummary === summary.id ? '1px solid #344767' : 'none', cursor: 'pointer' }} onClick={() => handleLibrarySummarySelect(summary.id)} >
                                        <SoftBox p={2}  display="flex" justifyContent="flex-start" alignItems="center">
                                            <SoftTypography sx={{ ml:2 }} color="dark" variant="h6">
                                                {summary.id}
                                            </SoftTypography>
                                        </SoftBox>
                                    </Card>
                                </SoftBox>
                            ))}
                        </SoftBox>
                    </SoftBox>
    
                    <SoftBox pt={3} sx={{ width: '75%', overflow: 'auto', pl: 2 }}>
                        {selectedSummary ? (
                            <>
                                <SoftBox py={2} pl={4} pr={4} display="flex" justifyContent="space-between">
                                    <SoftTypography variant="h5" sx={{ mt: 1}} >
                                        {selectedSummary.id}
                                    </SoftTypography>
                                    <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 Importing is available for Platinum and Gold Package subscribers only." : "Import this summary to your personal notes"} placement="top" >
                                        <span> 
                                            <SoftButton 
                                                startIcon={<AddTaskOutlinedIcon />} 
                                                variant="contained" 
                                                color="dark" 
                                                size="medium" 
                                                onClick={() => handleImportSummary(selectedSummary)}
                                                disabled={currentUserSubscription === "Silver Subscription"}
                                            >
                                                Import {selectedSummary.id}
                                            </SoftButton>
                                        </span>
                                    </Tooltip>
                                </SoftBox>

                                <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" mt={4} p={2} mx={5}  >
                                    <SoftBox p={2} display="flex" justifyContent="space-between" alignItems="center" sx={{ border: '1px solid #344767', borderRadius: '8px', width: '100%'}}  >
                                        <SoftBox display="flex" >
                                            <SoftTypography variant="button" sx={{ mt:0.5}} >
                                                Content of the summary
                                            </SoftTypography>
                                            <Tooltip title="This prompt guides our AI to create summaries following this specific style" placement="right">
                                                <IconButton size="small" sx={{ ml:0.5}}  >
                                                    <InfoOutlinedIcon fontSize="small"  />
                                                </IconButton>
                                            </Tooltip>
                                        </SoftBox>
                                        <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 Content viewing is available for Platinum and Gold Package subscribers only." : ""}>
                                            <span>  
                                                <SoftButton 
                                                    onClick={() => { if (currentUserSubscription !== "Silver Subscription") toggleContentVisibility(); }}
                                                    variant="outlined" 
                                                    color="dark" 
                                                    sx={{ ml: 2, minWidth: 'auto' }}
                                                    disabled={currentUserSubscription === "Silver Subscription"}
                                                >
                                                    {isContentExpanded ? 'Collapse' : 'Expand'}
                                                </SoftButton>
                                            </span>
                                        </Tooltip>
                                    </SoftBox>
                                    {isContentExpanded && (
                                        <SoftBox  pl={1} pr={2} pt={2} display="flex" justifyContent="center">
                                            <SoftTypography variant="body2" sx={{ mb: 2 }}>
                                                {selectedSummary.content}
                                            </SoftTypography>
                                        </SoftBox>
                                    )}
                                    {!["Platinum Subscription", "Gold Subscription"].includes(currentUserSubscription) && (
                                        <SoftBox px={4} pt={4} sx={{ mb: 3}} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                                        <SoftBadge
                                            variant="contained"
                                            color="error"
                                            size="md"
                                            badgeContent={
                                                <SoftTypography variant="button">
                                                    🔔&nbsp;&nbsp;You need a Platinum or Gold subscription in order to view the summary&apos;s content.
                                                </SoftTypography>
                                            }
                                            container
                                        />
                                        </SoftBox>
                                    )}
                                </SoftBox>


                                <SoftBox display="flex" justifyContent="center" alignItems="center" p={2} sx={{ width: '80%', margin: '0 auto' }} >
                                    <SoftTypography variant="body2" sx={{ mb: 2, mt: 2 }}>
                                        <strong>Note:</strong> Summaries in the library cannot be edited directly. For customization, please import the summary into your personal notes, where you can freely edit and adjust them to your liking.
                                    </SoftTypography>
                                </SoftBox>
                            </>
                        ) : (
                            <SoftBox display="flex" alignItems="center" justifyContent="center" p={4} pt={15}>
                                <SoftTypography variant="body1">
                                    Select a summary from the left side to see details.
                                </SoftTypography>
                            </SoftBox>
                        )}
                    </SoftBox>

                </SoftBox>
            </SoftBox>
        );
    };
    
      

    const toggleDropzone = () => setShowDropzone(!showDropzone);

    const toggleHelp = () => {
        setShowHelp(!showHelp);
    };

    const toggleHelpSecond = () => {
        setShowHelpSecond(!showHelpSecond);
    };

    const toggleHelpThird = () => {
        setShowHelpThird(!showHelpThird);
    };

    const handleFileAdded = (file) => {
        console.log('File added:', file);
        
        setAudioDetails({ ...audioDetails, blob: file, file: file });
    };

    const handleToggleChange = (event) => {
        setToggleReviewLink(event.target.checked);
    };

    const handleReviewLinkChange = (event) => {
        setReviewLink(event.target.value);
    };


    const recorderControls = useAudioRecorder({
        noiseSuppression: true,
        echoCancellation: true,
    }, (err) => console.error(err));


    const AudioElement = (blob) => {
        const url = URL.createObjectURL(blob);
        const audioFile = new File([blob], "recording.mp3", { type: "audio/mpeg" });
        setAudioDetails({ ...audioDetails, url: url, blob: blob, file: audioFile });
        setSilenceTime(0)
        
    };

    const detectSilence = (stream, onSilence, onSound) => {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const analyser = audioContext.createAnalyser();
        const source = audioContext.createMediaStreamSource(stream);
        source.connect(analyser);
        analyser.fftSize = 512;
        const dataArray = new Uint8Array(analyser.frequencyBinCount);

        const checkAudio = () => {
            analyser.getByteFrequencyData(dataArray);
            const avgVolume = dataArray.reduce((a, b) => a + b) / dataArray.length;
            if (avgVolume < silenceVolumeThreshold) {
                onSilence();
            } else {
                onSound();
            }
            requestAnimationFrame(checkAudio);
        };

        checkAudio();
    };

    useEffect(() => {
        let recordingInterval = null;
        let silenceTimeout = null;
        let silenceDetectionStream = null;
    
        const handleSilence = () => {
            if (!silenceTimeout) {
                silenceTimeout = setTimeout(() => {
                    if (recorderControls.isRecording) {
                        // NEW: hard 2-hour stop timer
const MAX_DURATION_MS = 2 * 60 * 60 * 1000; // 2 hours
const hardStopTimeout = setTimeout(() => {
    Swal.fire({
        title: 'Recording limit reached',
        text: 'The maximum recording time of 2 hours has been reached. Your recording will now stop.',
        icon: 'info',
        confirmButtonText: 'OK'
    });
    recorderControls.stopRecording();
}, MAX_DURATION_MS);

// Make sure we clear this with the rest of the timers
cleanupFunctions.push(() => clearTimeout(hardStopTimeout));
                        recorderControls.stopRecording();
                        Swal.fire({
                            title: 'Recording Ended',
                            text: 'We have ended the recording due to inactivity for the last 30 minutes.',
                            icon: 'warning',
                            confirmButtonText: 'Ok'
                        });
                    }
                    setSilenceTime(0); // Reset silence time after alert
                }, silenceThreshold * 1000);
            }
        };
    
        const handleSound = () => {
            clearTimeout(silenceTimeout);
            silenceTimeout = null;
            setSilenceTime(0);
        };
    
        if (recorderControls.isRecording) {
            navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
                silenceDetectionStream = stream;
                detectSilence(stream, handleSilence, handleSound);
    
                recordingInterval = setInterval(() => {
                    setRecordingTime((prevTime) => prevTime + 1);
                }, 1000);
            });
        } else if (!recorderControls.isRecording && recordingTime !== 0) {
            clearInterval(recordingInterval);
            if (silenceTimeout) {
                clearTimeout(silenceTimeout);
            }
            if (silenceDetectionStream) {
                silenceDetectionStream.getTracks().forEach(track => track.stop());
            }
        }
    
        return () => {
            clearInterval(recordingInterval);
            if (silenceTimeout) {
                clearTimeout(silenceTimeout);
            }
            if (silenceDetectionStream) {
                silenceDetectionStream.getTracks().forEach(track => track.stop());
            }
        };
    }, [recorderControls.isRecording]);

    function formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = (seconds % 60).toFixed(0);
        return `${minutes} minutes and ${remainingSeconds} seconds`;
    }


    useEffect(() => {
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
            if (user) {
                // Fetch user subscription details
                const fetchUserSubscription = async () => {
                    const db = getFirestore();
                    const userSubDoc = collection(db, 'customerDetails', user.uid, 'subscriptions');
                    const docSnap = await getDocs(userSubDoc);

                    let foundActiveOrTrial = false;

                    docSnap.forEach((doc) => {
                      const subscriptionData = doc.data();
                      if (["active", "trialing"].includes(subscriptionData.status)) {
                        foundActiveOrTrial = true;
                      }
                    });
            
                    setHasActiveOrTrialSubscription(foundActiveOrTrial);
                };
                fetchUserSubscription();
            } else {
                setHasActiveOrTrialSubscription(false);
            }
        });
    }, []); 


    const handleAddPromptOpen = () => {
        setIsAddPromptOpen(true);
        setTimeout(() => {
            if (summaryAddRef.current) {
                summaryAddRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
    };

    const handleAddPromptClose = () => setIsAddPromptOpen(false);


    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    const resetAllValues = () => {
        setPatientNameBeforeUpload('');  
        setPatientAgeBeforeUpload('');  
        setPatientGenderBeforeUpload('');  
        setSelectedPatientBeforeUpload('');  
        setSessionNameBeforeUpload('');  
        setShowRecordingTime(false);  
        setAudioDetails({...initialState});
        setRecordingTime(0);
        setUploadState(false); 
        //setUploadComplete(false);
    };

    const scrollToRecordingRef = () => {
        resetAllValues();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };


    const handleTimeUpdate = (time) => {
        const roundedTime = Math.round(time);
        const timeToSet = Number(time).toFixed(0);
        setRecordingTime(time);
        console.log("rec. time: ", time)
        console.log("duration recording: ", roundedTime)
    };

    {/*const formatTime = (timeInMilliseconds) => {
        const seconds = Math.floor((timeInMilliseconds / 1000) % 60);
        const minutes = Math.floor((timeInMilliseconds / (1000 * 60)) % 60);
        const hours = Math.floor((timeInMilliseconds / (1000 * 60 * 60)) % 24);
    
        return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };*/}
    
    const nameToDisplay = patientName || selectedPatient;


    useEffect(() => {
        const auth = getAuth();
        onAuthStateChanged(auth, (user) => {
        if (user) {
            const fetchUserSubscription = async () => {
                try {
                    const db = getFirestore();
                    const userSubDoc = collection(db, 'customerDetails', user.uid, 'subscriptions'); 
                    const q = query(userSubDoc, where("status", "in", ["active", "trialing"]));
                    const querySnapshot = await getDocs(q);
                    let latestSubscription = null;

                    querySnapshot.forEach((doc) => {
                    if (!latestSubscription || doc.data().current_period_start.seconds > latestSubscription.current_period_start.seconds) {
                        latestSubscription = doc.data();
                    }
                    });

                    setCurrentUserSubscription(latestSubscription.items[0].price.product.name);
                    console.log("user subscription: ", latestSubscription.items[0].price.product.name);
                } catch (error) {
                    console.error("Error fetching user subscription:", error);
                    setCurrentUserSubscription(null);
                }   
            };
            fetchUserSubscription();
        }
        });
    }, []);
    

    // Function to format the date to dd/MM/yyyy
    function formatDate(date) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${month}/${day}/${year} ${hours}:${minutes}`;
    }

    // Function to filter patients based on search text
    const getFilteredPatients = () => {
        if (!searchText) {
            return existingPatients;
        }
        return existingPatients.filter(patient =>
            patient.toLowerCase().includes(searchText.toLowerCase())
        );
    };

    // Filtered patients for SoftSelect
    const filteredPatients = getFilteredPatients();

    const handlePatientTabChange = (event, newValue) => {
        setPatientTab(newValue);
    };

    const handleAddNewPatient = () => {
        setIsAddingNew(true);
        setSelectedPatientBeforeUpload('');
    };

    const handleSoftSelectChange = async (selectedOption) => {
        setSelectedPatientBeforeUpload(selectedOption.value);

        // Fetch patient details from Firestore
        try {
            const patientRef = doc(db, `users/${userId}/summaries/${selectedOption.value}`);
            const docSnap = await getDoc(patientRef);

            if (docSnap.exists()) {
                const patientData = docSnap.data();
                setPatientAgeBeforeUpload(patientData.age || ''); // Set age if available
                setPatientGenderBeforeUpload(patientData.gender || ''); // Set gender if available
            } else {
                console.log("No such patient!");
            }
        } catch (error) {
            console.error("Error fetching patient details:", error);
        }

    };

    const handleInstructionSelect = (title) => {
        setSelectedInstructions((prev) => {
          let updated;
          if (prev.includes(title)) {
            // Unselect if already selected
            updated = prev.filter(t => t !== title);
          } else {
            // Add to selection
            updated = [...prev, title];
          }
          // Update local storage
          localStorage.setItem("selectedInstructions", JSON.stringify(updated));
          return updated;
        });
    };

    useEffect(() => {
        const localInstructions = localStorage.getItem('patientInstructions');
        if (localInstructions) {
            setPatientInstructions(JSON.parse(localInstructions));
        }

        const auth = getAuth();
        onAuthStateChanged(auth, async (user) => {
          if (user) {
            // User is signed in, fetch patient instructions
            fetchPatientInstructions(user.uid);
          } else {
            // No user is signed in, clear the patient instructions
            setPatientInstructions({});
          }
        });
    }, []);

    const fetchPatientInstructions = async (userId) => {
        const db = getFirestore();
        const instructionsRef = collection(db, `users/${userId}/patientInstructions`);
      
        try {
            const querySnapshot = await getDocs(instructionsRef);
            let instructionsData = {};
            querySnapshot.forEach((doc) => {
                instructionsData[doc.id] = { id: doc.id, content: doc.data().content };
            });

            setPatientInstructions(instructionsData);
            localStorage.setItem('patientInstructions', JSON.stringify(instructionsData));
            //console.log("instructionssss; ", instructionsData)
        } catch (error) {
            console.error("Error fetching patient instructions:", error);
        }
    };

    const handleOpenMenuInstructions = (event, instruction) => {
        event.stopPropagation();
        setAnchorElInstructions(event.currentTarget);
        setCurrentInstructionId(instruction);
        
    };

    const handleCloseMenuInstructions = () => {
        setAnchorElInstructions(null);
    };

    const handleEditClickInstruction = () => {
        // Assuming currentInstructionId holds the ID of the instruction to be edited
        if (currentInstructionId && patientInstructions[currentInstructionId]) {
            // Directly access the instruction using its ID
            const instructionToEdit = patientInstructions[currentInstructionId];
            
            // Set the instruction into edit mode and store its current content
            setEditModeInstruction({ ...editModeInstruction, [currentInstructionId]: true });
            setEditedInstructionText({ ...editedInstructionText, [currentInstructionId]: instructionToEdit.content });
        } else {
            console.error("Instruction not found with ID:", currentInstructionId);
        }
    
        // Close the menu
        handleCloseMenuInstructions();
    };

    const handleSaveInstructionEdit = async (instructionId) => {
        const editedContent = editedInstructionText[instructionId];
    
        // Check if there's actually something to save
        if (!editedContent.trim()) {
            console.error("The edited content is empty.");
            return;
        }
    
        // Update local state first
        setPatientInstructions(prev => ({
            ...prev,
            [instructionId]: {
                ...prev[instructionId],
                content: editedContent
            }
        }));
    
        // Update the database
        try {
            const db = getFirestore();
            const instructionRef = doc(db, `users/${userId}/patientInstructions/${instructionId}`);
            await updateDoc(instructionRef, {
                content: editedContent
            });
    
            setSaveSuccessInstruction(prev => ({ ...prev, [instructionId]: true }));
    
            setTimeout(() => {
                setSaveSuccessInstruction(prev => ({ ...prev, [instructionId]: false })); // Reset success state for this instruction
                //setEditModeInstruction(prev => ({ ...prev, [instructionId]: false }));
                //handleCloseMenuInstructions();
            }, 4000);

            localStorage.setItem('patientInstructions', JSON.stringify({
                ...patientInstructions,
                [instructionId]: {
                    ...patientInstructions[instructionId],
                    content: editedContent
                }
            }));
    
            //handleCloseEditMode(instructionId);
        } catch (error) {
            console.error("Error updating instruction:", error);
        }
    };
    
    
    const handleCloseEditMode = (instructionId) => {
        // Update the editModeInstruction state to set the specific instruction's edit mode to false
        setEditModeInstruction(prev => ({
            ...prev,
            [instructionId]: false
        }));
    
        // Optionally, clear the edited text for that instruction if needed
        setEditedInstructionText(prev => ({
            ...prev,
            [instructionId]: "" // or keep the edited text if you want
        }));
    };

    const handleSenderNameChange = (event) => {
        setSenderName(event.target.value);
    };

    const handleSenderEmailChange = (event) => {
        setSenderEmail(event.target.value);
    };
    
    const saveSenderDetails = async () => {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
          const userRef = doc(db, "users", user.uid);
          try {
            await updateDoc(userRef, { 
                senderName: senderName,
                senderEmail: senderEmail,
                reviewLink: reviewLink,
            });
            setSaveSuccessSender(true);
    
            setTimeout(() => {
                setSaveSuccessSender(false);
            }, 4000);
            //console.log("Sender details saved successfully.");
          } catch (error) {
            console.error("Error saving sender details: ", error);
          }
        }
    };

    useEffect(() => {
        const auth = getAuth(); 
        const db = getFirestore();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const fetchSenderDetails = async () => {
                    const userRef = doc(db, "users", user.uid);
                    try {
                        const docSnap = await getDoc(userRef);
                        if (docSnap.exists()) {
                            const data = docSnap.data();
                            setSenderName(data.senderName || '');
                            setSenderEmail(data.senderEmail || '');
                            setReviewLink(data.reviewLink || '');
                        } else {
                            console.log("No sender details found");
                        }
                    } catch (error) {
                        console.error("Error fetching sender details: ", error);
                    }
                };
    
                fetchSenderDetails();
            }
        });
    
        // Cleaning up the listener when component unmounts
        return () => unsubscribe();
    }, []); 
    
    const handleGenerateEmailsClick = async () => {
        const newGeneratedEmails = {};
        const selectedInstructionIds = JSON.parse(localStorage.getItem('selectedInstructions')) || [];
        
        const instructionsToGenerate = Object.keys(patientInstructions).filter(id => selectedInstructionIds.includes(id));

        
    
        // Reseting any previous errors or states if needed
        // setErrorGeneratingEmails(false);
    
        for (const instructionId of instructionsToGenerate) {
            const instructionContent = patientInstructions[instructionId].content;
            const combinedEmailPrompt = `<prompt>\n${instructionContent}\n</prompt>\n\n<conversation>${transcript.data.results.channels[0].alternatives[0].paragraphs.transcript}\n</conversation>\n\nThe name of the sender, which is the provider is: ${senderName}\n\nAnd the name of the patient is:${nameToDisplay}`;
        
            try {
                const response = await fetch('https://stt-react-native-app.web.app/api/openai', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ prompt: combinedEmailPrompt })
                });
        
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
        
                const data = await response.json();
                if (reviewLink) {
                    data.response = data.response + `\n\nPlease provide us your feedback by visiting: ${reviewLink}`;
                }
                newGeneratedEmails[instructionId] = data;
            } catch (error) {
                console.error(`Error during email generation for instruction ${instructionId}:`, error);
                // You might want to log this error, show a message to the user, or take some other action.
                // Optionally, you can mark the specific instruction as failed for UI feedback.
                //setErrorGeneratingEmails(true); // Consider handling this differently since you're now in a loop.
            }
        }
        
        setGeneratedEmails(newGeneratedEmails);
        await saveEmailsToFirestore(newGeneratedEmails);        
    };

    const handleGenerateEmailsClickNewTranscript = async () => {
        const newGeneratedEmails = {};
        const selectedInstructionIds = JSON.parse(localStorage.getItem('selectedInstructions')) || [];
        
        const instructionsToGenerate = Object.keys(patientInstructions).filter(id => selectedInstructionIds.includes(id));
    
        // Reseting any previous errors or states if needed
        // setErrorGeneratingEmails(false);
    
        for (const instructionId of instructionsToGenerate) {
            const instructionContent = patientInstructions[instructionId].content;
            const combinedEmailPrompt = `<prompt>\n${instructionContent}\n</prompt>\n\n<conversation>${newTranscript}\n</conversation>\n\nThe name of the sender, which is the provider is: ${senderName}\n\nAnd the name of the patient is:${nameToDisplay}`;
        
            try {
                const response = await fetch('https://stt-react-native-app.web.app/api/openai', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ prompt: combinedEmailPrompt })
                });
        
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
        
                const data = await response.json();
                if (reviewLink) {
                    data.response = data.response + `\n\nPlease provide us your feedback by visiting: ${reviewLink}`;
                }
                newGeneratedEmails[instructionId] = data;
            } catch (error) {
                console.error(`Error during email generation for instruction ${instructionId}:`, error);
                // You might want to log this error, show a message to the user, or take some other action.
                // Optionally, you can mark the specific instruction as failed for UI feedback.
                //setErrorGeneratingEmails(true); // Consider handling this differently since you're now in a loop.
            }
        }
        
        setGeneratedEmails(newGeneratedEmails);
        await saveEmailsToFirestore(newGeneratedEmails);        
    };

    const saveEmailsToFirestore = async (newGeneratedEmails) => {
        if (!userId || (!patientName && !selectedPatient)) throw new Error("User ID or patient name missing");
        //setErrorSavingSummaries(false); 

        try {
    
            let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
            const visitDocRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);
        
            await setDoc(visitDocRef, {
                emails: newGeneratedEmails,
            }, { merge: true });
        
        } catch (error) {
            //setErrorSavingSummaries(true);
        }
    };


    const handleToggleGeneratedEmailContent = () => {
        setShowGeneratedEmailContent(true);
    };

    const handleGenerateEmailContentClose = () => {
        setShowGeneratedEmailContent(false);
    };
    
    const handleEmailSubjectChange = (instructionId, value) => {
        setEmailSubjects(prev => ({ ...prev, [instructionId]: value }));
    };

    const handleEmailSenderNameChange = (instructionId, value) => {
        setEmailSenderNames(prev => ({ ...prev, [instructionId]: value }));
    };

    const handleEmailSenderEmailChange = (instructionId, value) => {
        setEmailSenderEmails(prev => ({ ...prev, [instructionId]: value }));
    };

    const handlePatientEmailChange = (event) => {
        setPatientEmail(event.target.value);
    };
    

    const handleEmailContentEdit = (instructionId, newContent) => {
        setGeneratedEmails(prevEmails => ({
            ...prevEmails,
            [instructionId]: {
                ...prevEmails[instructionId],
                response: newContent, // Assume 'response' holds the email content; adjust if your structure differs
            }
        }));
    };

   const handleSendEmail = async (instructionId) => {
    if (!patientEmail || patientEmail.trim() === '') {
        Swal.fire({
            icon: 'warning',
            title: 'Missing Patient Email',
            text: 'Please enter the email of the patient.',
            confirmButtonColor: '#344767',
            confirmButtonText: 'OK'
        });
        return;
    }

    const emailContent = generatedEmails[instructionId]?.response;
    const emailSubject = emailSubjects[instructionId] || "";
    const sendersName = emailSenderNames[instructionId] || senderName;
    const sendersEmail = emailSenderEmails[instructionId] || senderEmail;

    const payload = {
        subject: emailSubject,
        content: emailContent,
        senderName: sendersName,
        patientEmail: patientEmail,
        senderEmail: sendersEmail
    };

    try {
        const response = await fetch("https://stt-react-native-app.web.app/api/ghl/patient-instructions", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            const text = await response.text();
            throw new Error(`HTTP error! status: ${response.status} body: ${text}`);
        }

        setAgreementEmail(false);
        showSnackbar("dark", "email", "Email is sent to patient!", "Tell patient to see spam folder as well.");
    } catch (error) {
        console.error("Error sending email to the webhook:", error);
    }
};
    
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setEmailSentSuccess(false);
    };
    
    


      

    const saveTemplatesToLocalstorage = (templatesData) => {
        const templatesDataString = JSON.stringify(templatesData);
        localStorage.setItem("templatesData", templatesDataString);
    }    

    const loadTemplatesFromLocalstorage = () => {
        const templatesDataString = localStorage.getItem("templatesData");
        return templatesDataString ? JSON.parse(templatesDataString) : null;
    }    
    

    useEffect(() => {
        const cachedTemplates = loadTemplatesFromLocalstorage();
        if (cachedTemplates) {
            setTemplates(cachedTemplates); 
        }

        const auth = getAuth();
        onAuthStateChanged(auth, async (user) => {
            if (user) {
                setUserId(user.uid);
    
                // Initialize Firestore and reference to the user's summaries
                const db = getFirestore();
                const summariesRef = collection(db, `users/${user.uid}/summaries`);
                const templatePromptsRef = collection(db, `users/${user.uid}/templateprompts`);
    
                // Fetch all documents under the summaries collection
                try {
                    const summariesSnapshot = await getDocs(summariesRef);
                    const patients = summariesSnapshot.docs.map(doc => doc.id); // Extracts patient names/IDs
                    setExistingPatients(patients);
                } catch (error) {
                    console.error("Error fetching patients:", error);
                }

                // Fetch prompts
                const promptsRef = collection(db, `users/${user.uid}/prompts`);

                try {
                    const querySnapshot = await getDocs(promptsRef);
                    let promptsData = {};
                    querySnapshot.forEach((doc) => {
                        promptsData[doc.id] = doc.data().content; // Assuming 'content' holds the prompt text
                    });
                    // Update your state or context with fetched prompts
                    setPromptsData(promptsData);
                    //console.log("Fetched prompts from db: ", promptsData)
                } catch (error) {
                    console.error("Error fetching prompts:", error);
                }

                // Fetch template prompts
                const templatesRef = collection(db, `users/${user.uid}/templateprompts`)
                
                try {
                    const templateSnapshot = await getDocs(templatesRef);
                    let templatesData = [];
                    //console.log(`Fetched ${templateSnapshot.docs.length} templates`);


                    for (const doc of templateSnapshot.docs) {
                        //console.log(`Template ID: ${doc.id}`, doc.data());
                    
                        const summariesSnapshot = await getDocs(collection(db, `users/${user.uid}/templateprompts/${doc.id}/summaries`));
                        let summariesData = [];
                        summariesSnapshot.forEach(summaryDoc => {
                            summariesData.push({
                            id: summaryDoc.id,
                            content: summaryDoc.data().content // Assuming 'content' holds the prompt text
                            });
                            //console.log(`Summary ID: ${summaryDoc.id}`, summaryDoc.data());
                        });

                        // Include template details (name, iconName, etc.) and associated prompts
                        templatesData.push({
                            id: doc.id,
                            name: doc.data().name,
                            iconName: doc.data().iconName,
                            description: doc.data().description,
                            associatedPrompts: summariesData // Map summaries to just content if that's all you need
                        });
                    }
                    saveTemplatesToLocalstorage(templatesData);
                    setTemplates(templatesData);
                    //console.log("templates date: ", templatesData)
                } catch (error) {
                    console.error("Error fetching template prompts:", error);
                }

            } else {
                console.log("No user logged in");
            }
        });
    }, []);


    const handlePatientSelection = (event) => {
        setSelectedPatientBeforeUpload(event.target.value);
    };


    // Function to save summaries to Firestore
    /*const saveSummariesToFirestore = async () => {
        if (!userId || (!patientName && !selectedPatient)) {
            console.error("User ID or patient name missing");
            return;
        }

        try {
            let patientToUse = isAddingNew ? patientName : selectedPatient;
            
            // Check if the patient is new or existing
            if (existingPatients.includes(patientToUse)) {
                // Existing patient, add a new visit
                const visitDocRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);
                await setDoc (visitDocRef, {
                    transcript: transcript.text,
                    summaries: summaries,
                    timestamp: new Date()
                });
            } else {
                // New patient, create new patient and visit
                const visitRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);
                await setDoc(visitRef, {
                    transcript: transcript.text,
                    summaries: summaries,
                    timestamp: new Date()
                });
            }
            console.log("Summaries saved successfully");
        } catch (error) {
            console.error("Error saving summaries:", error);
        }
    };*/


    // Function to update the selected prompts from PromptSettings
    const handleUpdateSelectedPrompts = (newSelectedPrompts) => {
        setSelectedPrompts(newSelectedPrompts);
    };

    const updatePromptsData = (newData) => {
        setPromptsData(newData);
    };

    const regenerateSummary = async (summaryType) => {
        setIsRegenerating(prevState => ({ ...prevState, [summaryType]: true }));

       
        const promptText = promptsData[summaryType];
        const combinedPrompt = `<prompt>\n${promptText}\n</prompt>\n\n<conversation>${transcript.data.results.channels[0].alternatives[0].paragraphs.transcript}\n</conversation>`; // Combine prompt text with transcript
        //console.log(" combined baby, ", combinedPrompt)
        try {
            // Call your API or function to regenerate summary
            const response = await fetch('https://stt-react-native-app.web.app/api/openai', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ prompt: combinedPrompt })
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const newSummary = await response.json();
            setSummaries(prevSummaries => ({
                ...prevSummaries,
                [summaryType]: newSummary
            }));

            // Update the specific summary in Firestore
            if (userId && (patientName || selectedPatient)) {
                let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
                const visitDocRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);
                
                // Prepare the update data
                const updateData = {};
                updateData[`summaries.${summaryType}`] = newSummary;

                await updateDoc(visitDocRef, updateData);

                //console.log("Summary updated successfully");
            } else {
                console.error("User ID or patient name missing");
            }
        } catch (error) {
            console.error('Error regenerating summary:', error);
        }
        setIsRegenerating(prevState => ({ ...prevState, [summaryType]: false }));
    };


    const makeRegularSummaryMoreConcise = async (summaryType) => {
        setIsRegenerating(prevState => ({ ...prevState, [summaryType]: true }));
        const originalSummary = summaries[summaryType].response; 
     
        const concisePrompt = `Given the detailed summary below, create a more concise version that retains all essential information:\n\n"${originalSummary}`;
        //console.log("concise prmpt: ", concisePrompt)
    
        try {
            const response = await fetch('https://stt-react-native-app.web.app/api/openai', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ prompt: concisePrompt})
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const conciseSummary = await response.json();

            setSummaries(prevSummaries => ({
                ...prevSummaries,
                [summaryType]: conciseSummary 
            }));
    
            // Update Firestore with the concise summary
            if (userId && (patientName || selectedPatient)) {
                let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
                const visitDocRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);
                
                const updateData = {};
                updateData[`summaries.${summaryType}`] = conciseSummary;
    
                await updateDoc(visitDocRef, updateData);
    
                //console.log("Summary made more concise successfully");
            } else {
                console.error("User ID or patient name missing");
            }
        } catch (error) {
            console.error('Error making summary more concise:', error);
        } finally {
            setIsRegenerating(prevState => ({ ...prevState, [summaryType]: false }));
        }
    };

    const onRefineSummary = async (summaryType) => {
        setIsRegenerating(prevState => ({ ...prevState, [summaryType]: true }));
        //console.log("ahah summary: ", summaryType)

        const originalSummary = summaries[summaryType].response; 
        const instruction = refineSummariesNotes[summaryType].text
        const InstructionPrompt = `Adjust the summary below based on the user's adjustment instructions found between the <instruction> tags, the summary, found between the <summary> tags and use the transcript as context when you need this which is found between the <transcript> tags. \n\nThe summary: \n<summary>\n ${originalSummary} \n<summary>\n\nThe user's adjustment instructions: \n<instruction>\n${instruction}\n<instruction>\n\nThe original transcript: \n<transcript>\n${newTranscript}\n<transcript>`;
        //console.log("summary", summaryType);
        //console.log("instrction", instruction);
        console.log("all tog: ", InstructionPrompt )
        
        try {
            const response = await fetch('https://stt-react-native-app.web.app/api/openai', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ prompt: InstructionPrompt })
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const data = await response.json();
            const newConciseSummary = data.response 
    
            setSummaries(prevSummaries => ({
                ...prevSummaries,
                [summaryType]: data 
            }));
    
            // Update Firestore with the concise summary
            if (userId && (patientName || selectedPatient)) {
                let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
                const visitDocRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);
                
                const updateData = {};
                updateData[`summaries.${summaryType}`] = data;
    
                await updateDoc(visitDocRef, updateData);
    
                //console.log("Summary made more concise successfully");
            } else {
                console.error("User ID or patient name missing");
            }
        } catch (error) {
            console.error('Error making summary more concise:', error);
        } finally {
            setIsRegenerating(prevState => ({ ...prevState, [summaryType]: false }));
        }
    };


    const handleOpenTalkSummaries = (promptType) => {
        setOpenTalkToSummaries({ ...openTalkToSummaries, [promptType]: true });
        //setCurrentSummary(promptType);
    };

    const handleCloseTalkSummaries = (promptType) => {
        setOpenTalkToSummaries({ ...openTalkToSummaries, [promptType]: false });
        setRefineSummariesNotes(prevTexts => ({
            ...prevTexts,
            [promptType]: { text: '',}
          }));
    };
    
    
    

    const deleteSummary = async (summaryType) => {
        // Update the local state to remove the summary
        setSummaries(prevSummaries => {
            const newSummaries = { ...prevSummaries };
            delete newSummaries[summaryType];
            return newSummaries;
        });

        // Update Firestore to remove the specific summary
        if (userId && (patientName || selectedPatient)) {
            let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
            const visitDocRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);

            try {
                // Prepare the update data to delete the specific summary
                const updateData = {};
                updateData[`summaries.${summaryType}`] = deleteField(); 

                await updateDoc(visitDocRef, updateData);

                //console.log("Summary deleted successfully");
            } catch (error) {
                console.error("Error deleting summary:", error);
            }
        } else {
            console.error("User ID or patient name missing");
        }
    };

    const MAX_RETRIES = 3; // Maximum number of retries
    const RETRY_DELAY = 5000; // Delay between retries in milliseconds

    const handleGenerateSummariesClick = async () => {
        const generatedSummaries = {};
        const selectedPrompts = JSON.parse(localStorage.getItem('selectedPrompts'));
        setErrorGeneratingSummaries(false);
        setErrorTranscriptUndefined(false);

        if (!transcript?.data?.results?.channels[0]?.alternatives[0]?.paragraphs?.transcript) {
            console.error('Transcript data is undefined.');
            setErrorTranscriptUndefined(true);
            return;
        }

        const fetchSummary = async (combinedPrompt, attempt = 0) => {
            try {
                const response = await fetch('https://stt-react-native-app.web.app/api/openai', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ prompt: combinedPrompt })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                return data;
            } catch (error) {
                if (attempt < MAX_RETRIES) {
                    await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
                    return fetchSummary(prompt, combinedPrompt, attempt + 1);
                } else {
                    throw error; // Rethrow after max attempts are reached
                }
            }
        };

        for (const prompt in selectedPrompts) {
            if (selectedPrompts[prompt]) {
                try {
                    const promptText = promptsData[prompt];
                    const combinedPrompt = `<prompt>\n${promptText}\n</prompt>\n\n<conversation>${transcript.data.results.channels[0].alternatives[0].paragraphs.transcript}\n</conversation>`;
                    const data = await fetchSummary(combinedPrompt);
                    generatedSummaries[prompt] = data;
                } catch (error) {
                    console.error(`Error during request for ${prompt}:`, error);
                }
            }
        }
    
        setSummaries(sortSummariesWithCustomOrder(generatedSummaries, summariesOrder));
        try {
            await saveSummariesToFirestore(generatedSummaries);
        } catch (error) {
            console.error('Error saving summaries to Firestore:', error);
            setErrorGeneratingSummaries(true);
        }
    
    };


    const handleGenerateSummariesClickNewTranscript = async () => {
        const generatedSummaries = {};
        const selectedPrompts = JSON.parse(localStorage.getItem('selectedPrompts'));
        setErrorGeneratingSummaries(false);
        setErrorTranscriptUndefined(false);

        if (!newTranscript) {
            console.error('Transcript data is undefined.');
            setErrorTranscriptUndefined(true);
            return;
        }

        const fetchSummary = async (combinedPrompt, attempt = 0) => {
            try {
                const response = await fetch('https://stt-react-native-app.web.app/api/openai', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ prompt: combinedPrompt })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                return data;
            } catch (error) {
                if (attempt < MAX_RETRIES) {
                    await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
                    return fetchSummary(prompt, combinedPrompt, attempt + 1);
                } else {
                    throw error; // Rethrow after max attempts are reached
                }
            }
        };

        for (const prompt in selectedPrompts) {
            if (selectedPrompts[prompt]) {
                try {
                    const promptText = promptsData[prompt];
                    const combinedPrompt = `<prompt>\n${promptText}\n</prompt>\n\n<conversation>${newTranscript}\n</conversation>`;
                    const data = await fetchSummary(combinedPrompt);
                    generatedSummaries[prompt] = data;
                } catch (error) {
                    console.error(`Error during request for ${prompt}:`, error);
                }
            }
        }
    
        try {
            const patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
            const sessionRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);
    
            await updateDoc(sessionRef, {
                summaries: generatedSummaries,
                timestamp: formatDate(new Date())
            });
    
            setSummaries(sortSummariesWithCustomOrder(generatedSummaries, summariesOrder));
        } catch (error) {
            console.error('Error saving summaries to Firestore:', error);
            setErrorGeneratingSummaries(true);
        }
    
    };


    const saveSummariesToFirestore = async (generatedSummaries) => {
        if (!userId || (!patientName && !selectedPatient)) throw new Error("User ID or patient name missing");
        setErrorSavingSummaries(false); 

        try {
    
            let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
            const patientDocRef = doc(db, `users/${userId}/summaries/${patientToUse}`);
            const visitDocRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);
            const patientUpdateData = {
                lastVisit: formatDate(new Date()),
                lastRecordingTime: transcript.data.metadata.duration,
                ...(patientAge && {age: patientAge}),
                ...(patientGender && {gender: patientGender})
            };
        
            await setDoc(visitDocRef, {
                transcript: transcript.data.results.channels[0].alternatives[0].paragraphs.transcript,
                summaries: generatedSummaries,
                timestamp: formatDate(new Date()),
                recordingTime: transcript.data.metadata.duration
            }, { merge: true });
        
            await setDoc(patientDocRef, patientUpdateData, { merge: true });
        } catch (error) {
            setErrorSavingSummaries(true);
        }
    };


    const handleOpenMenuTemplateSum = (event, promptType) => {
        setAnchorElTemplateSummary(event.currentTarget);
        setCurrentSummary(promptType);
    };
    
    const handleCloseMenuTemplateSum = () => {
        setAnchorElTemplateSummary(null);
        //setCurrentSummary(null);
    };



    const regenerateTemplateSummary = async () => {
        setIsRegeneratingTemplate(prevState => ({ ...prevState, [currentSummary]: true }));
        handleCloseMenuTemplateSum();
    
        const selectedTemplate = templates.find(template => template.name === templateNameToDisplay);

        if (!selectedTemplate) {
            console.error("Selected template not found:", templateNameToDisplay);
            setIsRegeneratingTemplate(prevState => ({ ...prevState, [currentSummary]: false }));
            return;
        }

        // Find the associated prompt for the currentSummary within the selected template
        const originalPrompt = selectedTemplate.associatedPrompts.find(prompt => prompt.id === currentSummary);

        if (!originalPrompt) {
            console.error("Original prompt not found for summary:", currentSummary);
            setIsRegeneratingTemplate(prevState => ({ ...prevState, [currentSummary]: false }));
            return;
        }

        const combinedPrompt = `<prompt>\n${originalPrompt.content}\n</prompt>\n\n<conversation>${transcript.data.results.channels[0].alternatives[0].paragraphs.transcript}\n</conversation>`;

        //console.log("Prompt content:", originalPrompt);
        //console.log("Combined prompt:", combinedPrompt);
    
        try {
            const response = await fetch('https://stt-react-native-app.web.app/api/openai', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ prompt: combinedPrompt })
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const data = await response.json();
            // Accessing the nested "response" key within the response object for the new summary content
            const newSummaryContent = data.response; // Adjust this based on the actual structure of the response
    
            // Update the local state with the regenerated summary
            setTemplateSummaries(prevSummaries => ({
                ...prevSummaries,
                [currentSummary]: { ...prevSummaries[currentSummary], response: newSummaryContent } // Update the specific summary with new content
            }));
    
            // Update Firestore
            if (userId && (patientName || selectedPatient)) {
                let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
                const templateRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}/templates/${templateNameToDisplay}`);
                await updateDoc(templateRef, {
                    [`templateSummaries.${currentSummary}.response`]: newSummaryContent // Directly updating the nested field with new content
                });
    
                //console.log("Template summary regenerated successfully");
            }
        } catch (error) {
            console.error('Error regenerating template summary:', error);
        } finally {
            setIsRegeneratingTemplate(prevState => ({ ...prevState, [currentSummary]: false }));
        }
    };
    
    
    const makeSummaryMoreConcise = async () => {
        setIsRegeneratingTemplate(prevState => ({ ...prevState, [currentSummary]: true }));
        handleCloseMenuTemplateSum();
        
        const selectedTemplate = templates.find(template => template.name === templateNameToDisplay);
    
        if (!selectedTemplate) {
            console.error("Selected template not found:", templateNameToDisplay);
            setIsRegeneratingTemplate(prevState => ({ ...prevState, [currentSummary]: false }));
            return;
        }
    
        const originalSummary = templateSummaries[currentSummary].response;
    
      
        const concisePrompt = `Given the following detailed summarization, condense the information into a concise form while ensuring all critical data and key points are preserved. The audience consists of professionals requiring precise and efficient communication. \n\nDetailed Summarization: ${originalSummary} \n\nProduce a concise version.`;
    
        //console.log("Requesting concise summary for:", currentSummary);
        //console.log("Concise prompt:", concisePrompt);
    
        try {
            const response = await fetch('https://stt-react-native-app.web.app/api/openai', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ prompt: concisePrompt })
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const data = await response.json();
            const newConciseSummary = data.response 
    
            // Update the local state with the new concise summary
            setTemplateSummaries(prevSummaries => ({
                ...prevSummaries,
                [currentSummary]: { ...prevSummaries[currentSummary], response: newConciseSummary }
            }));
    
            // Update Firestore
            if (userId && (patientName || selectedPatient)) {
                let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
                const templateRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}/templates/${templateNameToDisplay}`);
                await updateDoc(templateRef, {
                    [`templateSummaries.${currentSummary}.response`]: newConciseSummary
                });
    
                //console.log("Summary made more concise successfully");
            }
        } catch (error) {
            console.error('Error making summary more concise:', error);
        } finally {
            setIsRegeneratingTemplate(prevState => ({ ...prevState, [currentSummary]: false }));
        }
    };
    
    

    const deleteTemplateSummary = async (promptName) => {
        handleCloseMenuTemplateSum();
        setTemplateSummaries(prevSummaries => {
            const newSummaries = { ...prevSummaries };
            delete newSummaries[currentSummary];
            return newSummaries;
        });
    
        if (userId && (patientName || selectedPatient)) {
            let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
            const templateRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}/templates/${templateNameToDisplay}`);
            const templateDoc = await getDoc(templateRef);
            if (templateDoc.exists()) {
                await updateDoc(templateRef, {
                    [`templateSummaries.${currentSummary}`]: deleteField() // Delete the specific summary
                });
            }
            //console.log("Template summary deleted successfully");
        }
    };

    const handleOpenTalkNotes = (promptType) => {
        setOpenTalkToNotes({ ...openTalkToNotes, [promptType]: true });
        setCurrentSummary(promptType);
    };

    const handleCloseTalkNotes = (promptType) => {
        setOpenTalkToNotes({ ...openTalkToNotes, [promptType]: false });
        setRefineTemplateNotes(prevTexts => ({
            ...prevTexts,
            [promptType]: { text: '',}
          }));
    };

    const onRefineNote = async (promptType) => {
        setIsRegeneratingTemplate(prevState => ({ ...prevState, [promptType]: true }));
        //console.log("ahah: ", promptType)

        const selectedTemplate = templates.find(template => template.name === templateNameToDisplay);

        if (!selectedTemplate) {
            console.error("Selected template not found:", templateNameToDisplay);
            setIsRegeneratingTemplate(prevState => ({ ...prevState, [promptType]: false }));
            return;
        }

        const originalSummary = templateSummaries[promptType].response;
        const instruction = refineTemplateNotes[promptType].text
        const InstructionPrompt = `Adjust the summary below based on the user's adjustment instructions found between the <instruction> tags, the summary, found between the <summary> tags and use the transcript as context when you need this which is found between the <transcript> tags. \n\nThe summary: \n<summary>\n ${originalSummary} \n<summary>\n\nThe user's adjustment instructions: \n<instruction>\n${instruction}\n<instruction>\n\nThe original transcript: \n<transcript>\n${newTranscript}\n<transcript> `;
        //console.log("summary", promptType);
        //console.log("instrction", instruction);
        //console.log("all tog: ", InstructionPrompt )
        
        try {
            const response = await fetch('https://stt-react-native-app.web.app/api/openai', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ prompt: InstructionPrompt })
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const data = await response.json();
            const newConciseSummary = data.response 
    
            // Update the local state with the new concise summary
            setTemplateSummaries(prevSummaries => ({
                ...prevSummaries,
                [promptType]: { ...prevSummaries[promptType], response: newConciseSummary }
            }));
    
            // Update Firestore
            if (userId && (patientName || selectedPatient)) {
                let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
                const templateRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}/templates/${templateNameToDisplay}`);
                await updateDoc(templateRef, {
                    [`templateSummaries.${promptType}.response`]: newConciseSummary
                });
    
                //console.log("Summary made more concise successfully");
            }
        } catch (error) {
            console.error('Error making summary more concise:', error);
        } finally {
            setIsRegeneratingTemplate(prevState => ({ ...prevState, [promptType]: false }));
        }
    };
    
    
    const fetchWithRetry = async (url, options, maxRetries = 3) => {
        for (let attempt = 0; attempt <= maxRetries; attempt++) {
          try {
            const response = await fetch(url, options);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return await response.json();
          } catch (error) {
            if (attempt === maxRetries) throw error;
          }
        }
    };

    const handleGenerateTemplatesClick = async () => {
        // Check if a template is selected
        if (templateNameToDisplay) {
            const selectedTemplate = templates.find(template => template.name === templateNameToDisplay);
    
            if (selectedTemplate) {
                const generatedTemplateSummaries = {};
    
                for (const prompt of selectedTemplate.associatedPrompts) {
                    // Retrieve prompt text (assuming it's stored in promptsData)
                    const promptText = prompt.content
                    const combinedPrompt = `<prompt>\n${promptText}\n</prompt>\n\n<conversation>${transcript.data.results.channels[0].alternatives[0].paragraphs.transcript}\n</conversation>`;
    
                    try {
                        const data = await fetchWithRetry('https://stt-react-native-app.web.app/api/openai', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ prompt: combinedPrompt })
                        }, 3);
    
                        {/*if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }*/}
    
                        //const data = await response.json();
                        generatedTemplateSummaries[prompt.id] = data; // Store the summary for each prompt
                        //console.log("generated template: ", generatedTemplateSummaries)
                        //console.log("generated template Data!: ", data)
                    } catch (error) {
                        console.error('Error during request:', error);
                    }
                }
    
                //console.log('Generated Template Summaries:', generatedTemplateSummaries);
                setTemplateSummaries(sortSummariesWithCustomOrder(generatedTemplateSummaries, selectedTemplateOrder));

                if (!userId || (!patientName && !selectedPatient)) {
                    console.error("User ID or patient name missing");
                    return;
                }
    
                try {
                    let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
                    const sessionRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);
    
                    // Check if the session already exists, if not, create it
                    const sessionDoc = await getDoc(sessionRef);
                    if (!sessionDoc.exists()) {
                        await setDoc(sessionRef, {
                            transcript: transcript.data.results.channels[0].alternatives[0].paragraphs.transcript,
                            timestamp: formatDate(new Date()),
                            recordingTime: (transcript.data.metadata.duration)
                        });
                    }
    
                    // Saving each template summary under the session in different docus
                    {/*for (const [prompt, summary] of Object.entries(generatedTemplateSummaries)) {
                        const templateSummaryRef = doc(sessionRef, 'templates', selectedCard, 'summaries',prompt);
                        await setDoc(templateSummaryRef, {
                            response: summary
                        });
                    }*/}

                    const templateRef = doc(sessionRef, 'templates', templateNameToDisplay);
                    await setDoc(templateRef, {
                        templateSummaries: generatedTemplateSummaries // Spread the summaries as fields
                    });

                    const patientDocRef = doc(db, `users/${userId}/summaries/${patientToUse}`);
                    const dateLastVisit = formatDate( new Date());

                    const patientUpdateData = {
                        lastVisit: dateLastVisit,
                        lastRecordingTime: (transcript.data.metadata.duration)
                    };
                    
                    // Only add age and gender to the update data if they are provided
                    if (patientAge) {
                        patientUpdateData.age = patientAge;
                    }
                    if (patientGender) {
                        patientUpdateData.gender = patientGender;
                    }                

                    await setDoc(patientDocRef, patientUpdateData, { merge: true });

                    //console.log("Template summaries saved successfully");
                } catch (error) {
                    console.error("Error saving template summaries:", error);
                }
            }
        }
    };


    const handleGenerateTemplatesClickNewTranscript = async () => {
        // Check if a template is selected
        if (templateNameToDisplay) {
            const selectedTemplate = templates.find(template => template.name === templateNameToDisplay);
    
            if (selectedTemplate) {
                const generatedTemplateSummaries = {};
    
                for (const prompt of selectedTemplate.associatedPrompts) {
                    // Retrieve prompt text (assuming it's stored in promptsData)
                    const promptText = prompt.content
                    const combinedPrompt = `<prompt>\n${promptText}\n</prompt>\n\n<conversation>${newTranscript}\n</conversation>`;
    
                    try {
                        const data = await fetchWithRetry('https://stt-react-native-app.web.app/api/openai', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ prompt: combinedPrompt })
                        }, 3);
    
    
                        //const data = await response.json();
                        generatedTemplateSummaries[prompt.id] = data; // Store the summary for each prompt
                        //console.log("generated template: ", generatedTemplateSummaries)
                        //console.log("generated template Data!: ", data)
                    } catch (error) {
                        console.error('Error during request:', error);
                    }
                }
    
                //console.log('Generated Template Summaries:', generatedTemplateSummaries);
                setTemplateSummaries(sortSummariesWithCustomOrder(generatedTemplateSummaries, selectedTemplateOrder));

                if (!userId || (!patientName && !selectedPatient)) {
                    console.error("User ID or patient name missing");
                    return;
                }
    
                try {
                    let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
                    const sessionRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);
    

                    const templateRef = doc(sessionRef, 'templates', templateNameToDisplay);
                    await setDoc(templateRef, {
                        templateSummaries: generatedTemplateSummaries // Spread the summaries as fields
                    });

                } catch (error) {
                    console.error("Error saving template summaries:", error);
                }
            }
        }
    };
    


    // Toggle functions for each controller card
    const toggleSentimentAnalysis = () => {
        setSentimentAnalysis(!sentimentAnalysis);
        localStorage.setItem('sentimentAnalysis', !sentimentAnalysis);
    };
    const toggleEntityDetection = () => {
        setEntityDetection(!entityDetection);
        localStorage.setItem('entityDetection', !entityDetection);
    };
    const toggleKeyPhrases = () => {
        setKeyPhrases(!keyPhrases);
        localStorage.setItem('keyPhrases', !keyPhrases);
    };
    const toggleTopicDetection = () => {
        setTopicDetection(!topicDetection);
        localStorage.setItem('topicDetection', !topicDetection);
    };
    const toggleSpeakerDiarization = () => {
        setSpeakerDiarization(!speakerDiarization);
        localStorage.setItem('speakerDiarization', !speakerDiarization);
    };
    const toggleContentModeration = () => {
        setContentModeration(!contentModeration);
        localStorage.setItem('contentModeration', !contentModeration);
    };
    const toggleTextFormatting = () => {
        setTextFormatting(!textFormatting);
        localStorage.setItem('textFormatting', !textFormatting);
    };
    const togglePunctuation = () => {
        setPunctuation(!punctuation);
        localStorage.setItem('punctuation', !punctuation);
    };

  useEffect(() => {  
    const interval = setInterval(async () => {

        if (transcript.status === 200 && uploadComplete) {

            clearInterval(interval);

            console.log("PROCESSING STARTED");

            setUploadComplete(false);
            setTempDisableUpload(false);
            setOriginalTranscript(transcript);

            const transcriptText =
                transcript?.data?.results?.channels?.[0]?.alternatives?.[0]?.paragraphs?.transcript ||
                transcript?.data?.results?.channels?.[0]?.alternatives?.[0]?.transcript ||
                "";

            console.log("PROCESSING DEBUG:", {
                transcriptStatus: transcript?.status,
                uploadComplete,
                hasResults: !!transcript?.data?.results,
                hasParagraphTranscript: !!transcript?.data?.results?.channels?.[0]?.alternatives?.[0]?.paragraphs?.transcript,
                hasRegularTranscript: !!transcript?.data?.results?.channels?.[0]?.alternatives?.[0]?.transcript,
                transcriptLength: transcriptText?.length,
                selectedPrompts: localStorage.getItem("selectedPrompts"),
                selectedInstructions: localStorage.getItem("selectedInstructions"),
                selectedCard,
                templateNameToDisplay,
                templatesCount: templates?.length,
            });

            if (!transcriptText) {
                console.error("NO TRANSCRIPT TEXT FOUND");
                setErrorTranscriptUndefined(true);
                setIsLoading(false);
                return;
            }

            handleTimeUpdate(transcript.data.metadata.duration);

            setNewTranscript(transcriptText);

            try {

                console.log("STARTING SUMMARY GENERATION");
                await handleGenerateSummariesClick();

                console.log("STARTING TEMPLATE GENERATION");
                await handleGenerateTemplatesClick();

                console.log("STARTING EMAIL GENERATION");
                await handleGenerateEmailsClick();

                console.log("UPDATING AUDIO USAGE");
                await updateAudioUsage(transcript.data.metadata.duration);

                console.log("GENERATING TODO NOTE");
                await handleGenerateTodoNote();

                console.log("ALL PROCESSING COMPLETE");

            } catch (error) {

                console.error("Error during processing: ", error);

            } finally {

                setIsLoading(false);
                setAllDataGenerated(true);

                console.log("FINAL TRANSCRIPT:", transcriptText);

            }
        }

    }, 1000);

    return () => clearInterval(interval);

}, [uploadComplete, transcript]);


    const handleManualProcessing = async () => {
        setIsLoadingNewTranscript(true); 
        setAllDataGenerated(false); 
        setSummaries({});  
        setGeneratedEmails({}); 
        setTemplateSummaries({}); 
        setErrorSavingSummaries(false); 
        try {
            await Promise.all([
                handleGenerateSummariesClickNewTranscript(),
                handleGenerateTemplatesClickNewTranscript(),
                handleGenerateEmailsClickNewTranscript()
            ]);
            //await handleGenerateTodoNote();
        } catch (error) {
            console.error("Error during manual processing: ", error);
            // Optionally, update the UI to indicate an error
        } finally {
            setIsLoadingNewTranscript(false); 
            setAllDataGenerated(true); 
        }
    };

    
    const updateAudioUsage = async (audioDuration) => {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
            const userDocRef = doc(db, 'users', user.uid);
            try {
                await updateDoc(userDocRef, {
                    totalSeconds: increment(audioDuration)
                });
                console.log("User audio usage updated");
            } catch (error) {
                console.error("Error updating user audio usage: ", error);
            }
        }
    };

  
  const handleAudioStop = (data) => {
  setAudioDetails(data);
  console.log("Audio recording stopped. Duration:", data.duration);
};

    const handleReset = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#344767',
            cancelButtonColor: '#ea0606',
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                setAudioDetails({...initialState});
                setShowRecordingTime(false);
                setRecordingTime(0);
                setUploadState(false);
                Swal.fire(
                    'Cleared!',
                    'The recording has been cleared.',
                    'success'
                );
            }
        });
    };

    const [snackbar, setSnackbar] = useState({
        show: false,
        message: "",
        title: "",
      });
      
      const showSnackbar = (color, icon, title, message ) => {
        setSnackbar({ show: true, color, icon, title, message: `${message}`});
      };
      
      const hideSnackbar = () => {
        setSnackbar({ ...snackbar, show: false });
      };

    const handleAudioUpload = async () => {

        if ((!patientNameBeforeUpload || patientNameBeforeUpload.trim() === '') && !selectedPatientBeforeUpload) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Patient Name',
                text: 'Please enter the name of a new patient or select an existing one before uploading.',
                confirmButtonColor: '#344767',
                confirmButtonText: 'OK'
            });
            return; // Stop the function if no patient name is provided or selected
        }
    
        if (!sessionNameBeforeUpload || sessionNameBeforeUpload.trim() === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Visit Name',
                text: 'Please enter a name for this visit/session before uploading.',
                confirmButtonColor: '#344767',
                confirmButtonText: 'OK'
            });
            return; // Stop the function if no visit name is provided
        }

        if (!audioDetails.file) {
            Swal.fire({
                icon: 'warning',
                title: 'No Recording Detected',
                text: 'Please record before uploading',
                confirmButtonColor: '#344767',
                confirmButtonText: 'OK'
            });
            return;
        }

        setTemplateNameToDisplay(selectedCard);
        setTempDisableUpload(true);
        setIsLoading(true);
        setUploadState(true);
        const audioFile = audioDetails.file;
        setPatientName(patientNameBeforeUpload)
        setSelectedPatient(selectedPatientBeforeUpload)
        setPatientAge(patientAgeBeforeUpload)
        setPatientGender(patientGenderBeforeUpload)
        setSessionName(sessionNameBeforeUpload)
        setTranscript({}); 
        setSummaries({});  
        setGeneratedEmails({}); 
        setTemplateSummaries({}); 
        setAllDataGenerated(false);  
        setEditModeTranscript(false);  
        setErrorTranscriptUndefined(false); 
        setErrorSavingSummaries(false); 
        setSelectedSummaries({}); 
        setSelectedTemplateSummaries({});  
        setPatientEmail("");
        setEmailSubjects({});
        setNewTranscript({});
      
        try {

  const response = await deepgram.post('/listen', audioFile, {
    params: {
      model: "nova-2-medical",
      smart_format: true,
      diarize: true,
      utterances: true,
    },
    headers: {
      "Content-Type": audioFile?.type || "application/octet-stream",
    },
    maxBodyLength: Infinity,
    maxContentLength: Infinity,
  });

  setTranscript(response);
  setUploadComplete(true);

} catch (error) {

  console.error("DEEPGRAM ERROR message:", error?.message);
  console.error("DEEPGRAM ERROR status:", error?.response?.status);
  console.error("DEEPGRAM ERROR data:", error?.response?.data);
  console.error("DEEPGRAM ERROR raw:", error);

  showSnackbar(
    "dark",
    "notifications",
    "Upload Failed",
    error?.response?.data
      ? JSON.stringify(error.response.data)
      : error?.message || "Unknown error occurred."
  );

  setIsLoading(false);
        } finally {
          //setIsLoading(false);
          //console.log("transcript assembly: ", transcript)
          
        }
    };


    const [openMenu, setOpenMenu] = useState(null);
    const [currentView, setCurrentView] = useState('Transcript Preferences');

    const handleOpenMenu = (event, templateName) => {
        event.stopPropagation();
        const selectedTemp = templates.find(template => template.name === templateName);
        if (selectedTemp) {
            setSelectedTemplate(selectedTemp);
        } else {
            console.error("Template not found: ", templateName);
        }
        setAnchorEl(event.currentTarget);
        setCurrentTemplateId(templateName);
        
    };

    const handleCloseEdit = () => {
        // Logic to handle closing the edit box
        setSelectedTemplate(null);
        setIsEditMode(false);
    };

    
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleMenuItemClick = (view) => {
        setCurrentView(view);
        handleCloseMenu();
    };

    const editSectionRef = useRef(null);
    
    const handleEditClick = () => {
        if (currentTemplateId) {
          const templateToEdit = templates.find(template => template.name === currentTemplateId);
          if (templateToEdit) {
            setIsEditMode(true);
            setSelectedTemplate(templateToEdit); 
            setTimeout(() => {
              if (editSectionRef.current) {
                editSectionRef.current.scrollIntoView({ behavior: 'smooth' });
              }
            }, 100);
          } else {
            console.error("Template not found with ID:", currentTemplateId);
          }
        } else {
          console.error("No template ID selected");
        }
        handleCloseMenu();
    };

    const handleDeleteClick = async () => {
        handleCloseMenu();

        Swal.fire({
            title: "You won't be able to revert this!",
            text: `Are you sure you want to delete the template: "${currentTemplateId}" ?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                // User confirmed the deletion
                if (!currentTemplateId || !userId) {
                    console.error("Template ID or User ID missing");
                    return;
                }
    
                const db = getFirestore();
                const templateRef = doc(db, `users/${userId}/templateprompts/${currentTemplateId}`);
                const summariesRef = collection(templateRef, 'summaries');

    
                try {
                    const querySnapshot = await getDocs(summariesRef);
                    const deletePromises = querySnapshot.docs.map((doc) => deleteDoc(doc.ref));
                    await Promise.all(deletePromises);

                    await deleteDoc(templateRef);
                    //console.log("Template deleted successfully");
    
                    // Show success message
                    Swal.fire(
                        'Deleted!',
                        'Your template has been deleted.',
                        'success'
                    );
                    await fetchTemplates();
                } catch (error) {
                    console.error("Error deleting template:", error);
                    // Optionally, show an error message
                    Swal.fire(
                        'Failed!',
                        'There was a problem deleting your template.',
                        'error'
                    );
                }
            }
        });
    };

    const handlePromptChange = (promptId, newText) => {
        // Update the local state for the prompt being edited
        const updatedTemplates = templates.map(template => {
            if (template.name === currentTemplateId) {
                const updatedPrompts = template.associatedPrompts.map(prompt => {
                    if (prompt.id === promptId) {
                        return { ...prompt, content: newText };
                    }
                    return prompt;
                });
                return { ...template, associatedPrompts: updatedPrompts };
            }
            return template;
        });
    
        setTemplates(updatedTemplates); // Update the templates state with the modified template
        setEditingPromptName(promptId); // Keep track of the currently editing prompt ID for UI feedback
    };
    
      

    const handleSaveEditedPrompts = async () => {
        const auth = getAuth();
        const user = auth.currentUser;
    
        if (user) {
            const db = getFirestore();
            // Assuming 'selectedCard' is the name of the template being edited
            // and 'templates' contains the full list including 'id' or a unique identifier for Firestore docs
            const selectedTemplateName = currentTemplateId; 
            const template = templates.find(t => t.name === selectedTemplateName);
    
            if (template) {
                const templateId = template.id; // Assuming each template has a unique 'id' field for Firestore doc reference
                template.associatedPrompts.forEach(async (prompt) => {
                    const promptRef = doc(db, `users/${user.uid}/templateprompts/${currentTemplateId}/summaries/${prompt.id}`);
                    try {
                        await updateDoc(promptRef, { content: prompt.content });
                        setSaveSuccessTemplate(true);
                        setTimeout(() => {
                            setSaveSuccessTemplate(false);
                            setEditingPromptName(null); // Reset editing state
                        }, 3000); // Adjusted timeout for UI feedback
                        
                    } catch (error) {
                        console.error("Error updating prompt:", error);
                        // Optionally, handle error in UI
                    }
                });
            } else {
                console.error("Selected template not found");
            }
        } else {
            console.error("No authenticated user found");
        }
    };

    const handleDeleteSummaryClick = async (summaryId) => {
        if (!currentTemplateId || !userId) {
            console.error("Template ID or User ID missing");
            return;
        }
    
        // SweetAlert confirmation dialog
        const willDelete = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });
    
        // Proceed only if confirmed
        if (willDelete.isConfirmed) {
            const db = getFirestore();
            const summaryRef = doc(db, `users/${userId}/templateprompts/${currentTemplateId}/summaries/${summaryId}`);
            const templateRef = doc(db, `users/${userId}/templateprompts`, currentTemplateId);
    
            try {
                await deleteDoc(summaryRef);

                setTemplateSummariesOrder(prevOrder => prevOrder.filter(id => id !== summaryId));

                // Fetch the current order
                const templateDoc = await getDoc(templateRef);
                if (templateDoc.exists()) {
                    const templateData = templateDoc.data();
                    const currentOrder = templateData.summariesOrder || [];

                    // Remove the summaryId from the order
                    const updatedOrder = currentOrder.filter(id => id !== summaryId);

                    // Update the order in the database
                    await updateDoc(templateRef, {
                        summariesOrder: updatedOrder
                    });

                    // Update the local state to reflect changes
                    //setTemplateSummariesOrder(updatedOrder);

                    await fetchTemplates();
                    showSnackbar("dark", "notifications", "Summary deleted!", `Summary: "${summaryId}" is successfully deleted.`);
                    setTimeout(() => {
                        hideSnackbar();
                    }, 5000);
                }
                
            } catch (error) {
                console.error("Error deleting summary:", error);
            }
        } else {
            // If the user clicks 'Cancel', do nothing
            console.log("Deletion cancelled");
        }
    };
    
      

    const handleOpenAddNewSummary = () => {
        setAddNewSummaryTemplate(true); 

        setTimeout(() => {
            if (addNewSummaryRef.current) {
                addNewSummaryRef.current.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    };

    const handleCloseAddNewSummary = () => {
        setAddNewSummaryTemplate(false); // Close the add new summary UI
    };

    const handleSaveNewSummaryToTemplate = async () => {
        if (!currentTemplateId || !userId) {
            console.error("Template or User ID missing");
            return;
        }
    
        const db = getFirestore();
        const templateRef = doc(db, `users/${userId}/templateprompts/${currentTemplateId}/summaries/${newAddSummaryTemplate.name}`);
        const templateOrderRef = doc(db, `users/${userId}/templateprompts`, currentTemplateId);
    
        try {
                await setDoc(templateRef, {content: newAddSummaryTemplate.content});
                const updatedOrder = [...templateSummariesOrder, newAddSummaryTemplate.name];
                await updateDoc(templateOrderRef, {
                    summariesOrder: updatedOrder
                });
    
                //console.log("Summary added successfully to the template");
                //setAddNewSummaryTemplate(false);
                setTemplateSummariesOrder(prevOrder => [...prevOrder, newAddSummaryTemplate.name]);
                setNewAddSummaryTemplate({ name: "", content: "" });
                showSnackbar("dark", "notifications", "Summary successfully added!", "Your new summary will be available shortly");
                await fetchTemplates();
                setTimeout(() => {
                    hideSnackbar();
                }, 5000);
        } catch (error) {
            console.error("Error adding summary to template:", error);
        }
    };
    
    const handleImportLibrarySummaryToTemplate = async (selectedSummary) => {
        if (!currentTemplateId || !userId || !selectedSummary) {
            console.error("Template, User ID, or selected summary missing");
            return;
        }
    
        const db = getFirestore();
        const summaryContent = selectedSummary.content;
    
        const templateRef = doc(db, `users/${userId}/templateprompts/${currentTemplateId}/summaries/${selectedSummary.id}`);
        const templateOrderRef = doc(db, `users/${userId}/templateprompts`, currentTemplateId);
    
        try {
            await setDoc(templateRef, { content: summaryContent });
            const updatedOrder = [...templateSummariesOrder, selectedSummary.id];
            await updateDoc(templateOrderRef, {
                summariesOrder: updatedOrder
            });
    
            setTemplateSummariesOrder(prevOrder => [...prevOrder, selectedSummary.id]);
            //setAddNewSummaryTemplate(false);
            //setShowLibrarySummaries(false); // Hide the library summaries view
            //setNewAddSummaryTemplate({ name: "", content: "" }); // Reset the add new summary form if used
            showSnackbar("dark", "notifications", `Summary added to ${currentTemplateId}!`, "Your new summary will be available shortly");
            await fetchTemplates(); // Refresh the templates to show the newly added summary
            setTimeout(() => {
                hideSnackbar();
            }, 5000);
        } catch (error) {
            console.error("Error importing summary to template:", error);
        }
    };
    

      

    useEffect(() => {
        if (isLoading && loaderRef.current) {
            loaderRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [isLoading]);

    useEffect(() => {
        if (isLoadingNewTranscript && loaderRefNewTranscript.current) {
            loaderRefNewTranscript.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [isLoadingNewTranscript]);

    useEffect(() => {
        const savedTemplate = localStorage.getItem("selectedTemplate");
        if (savedTemplate) {
            setSelectedCard(savedTemplate);
        }
    }, []);

    // Function to handle card selection
    const handleCardSelect = (cardTitle) => {
        if (selectedCard === cardTitle) {
            setSelectedCard(null); 
            localStorage.removeItem("selectedTemplate");
            //console.log(" unslected the card", selectedCard)
        } else {
            setSelectedCard(cardTitle);
            localStorage.setItem("selectedTemplate", cardTitle);
            //console.log(" selected card: ", selectedCard)
            {/*const selectedTemp = templates.find(template => template.name === cardTitle);
            if (selectedTemp) {
                setSelectedTemplate(selectedTemp);
            } else {
                console.error("Template not found: ", cardTitle);
            }*/}
        }
        setIsEditMode(false);
    };


    // State to manage current tab
    const [currentTab, setCurrentTab] = useState(0);

    // Function to handle tab change
    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };
      
    const renderMenu = () => (
        <Menu
          anchorEl={openMenu}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          open={Boolean(openMenu)}
          onClose={handleCloseMenu}
        >
          <MenuItem onClick={() => handleMenuItemClick('Transcript Preferences')}>Transcript Preferences</MenuItem>
          <MenuItem onClick={() => handleMenuItemClick('Summaries')}>Summaries</MenuItem>
        </Menu>
    ); 

    const handleSummarySelect = (summaryType) => {
        event.preventDefault();
        const summaryElement = document.getElementById(summaryType);
    if (summaryElement) {
      summaryElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
    };

    const handleCreatePrompt = async () => {
        const auth = getAuth();
        const user = auth.currentUser;
      
        if (user && newPromptName.trim()) {
          const db = getFirestore();
          const promptsRef = doc(db, `users/${user.uid}/prompts/${newPromptName}`);
      
          try {
           
            await setDoc(promptsRef, {
              content: newPromptText  
            });
      
            /*
            setNewPromptName('');
            setNewPromptText('');
            setIsAddPromptOpen(false); */
            //console.log('prompt text new:', newPromptText)
            setSaveSuccess(true);
            setTimeout(() => setSaveSuccess(false), 6000);
      
            await fetchAndUpdatePromptsData();
          } catch (error) {
            console.error("Error adding new prompt:", error);
          }
        } else {
          console.error("No authenticated user found");
        }
    };

    const tabText = (tabIndex) => {
        switch (tabIndex) {
            case 0:
                return "Setup Templates";
            case 1:
                return "Summarization Controls";
            case 2: 
                return "Patient Instruction Settings";
            default:
                return "Preferences";
        }
    };

    const tooltips = {
        transcript: 'For more info about our Audio Intelligences, go to our AI assistant and type something like: "Transcript Preferences"',
        summarization: 'For more info about our summarization controls and the abilities, go to our AI assistant and type something like: "Summarization Controls"',
        templates: 'Leverage our pre-configured templates to instantly aggregate essential information, or tailor and create your own templates for a personalized experience.'
    };

    {/*const templates = [
        {
            name: "Medical H&P Note",
            iconName: "medical_services", // Replace with specific icon name
            description: "A thorough record detailing the patient's medical history and findings from a physical examination, crucial for initial patient assessment.",
            associatedPrompts: ["Chief Complaint", "Medications", "Objective", "Assessment and Plan"]
        },
        {
            name: "Psychiatry H&P Note",
            iconName: "psychology", // Replace with specific icon name
            description: "Structured documentation for psychiatric history, mental status, and physical examination of the patient.",
            associatedPrompts: ["Chief Complaint", "Medications", "Mental Status Exam", "Risk Assessment", "Assessment and Plan"]
        },
        {
            name: "Psychotherapy Progress Note",
            iconName: "assessment", // Replace with specific icon name
            description: "A structured note format used for documenting a patient's progress, including subjective information, objective data, assessments, and treatment plans.",
            associatedPrompts: ["Subjective", "Objective", "Mental Status Exam", "Risk Assessment", "Assessment and Plan"]
        },
        {
            name: "Psychotherapy Progress Note - PMIRP",
            iconName: "record_voice_over", // Replace with specific icon name
            description: "A detailed account of therapy sessions focusing on specific problems, interventions used, modifications, patient responses, and future plans.",
            associatedPrompts: ["Client Representation", "Mental Status Exam", "Therapeutic Interventions"]
        },
        {
            name: "Psychiatry Follow-Up Note",
            iconName: "sync_alt", // Replace with specific icon name
            description: "Detailed note for tracking the progress and treatment response of a patient in psychiatric care, focusing on changes since the last visit.",
            associatedPrompts: ["Subjective", "Objective", "Mental Status Exam", "Risk Assessment", "Assessment and Plan"]
        },
        {
          name: "Medical SOAP Note",
          iconName: "description", // Replace with specific icon name
          description: "Detailed and formatted note following the SOAP (Subjective, Objective, Assessment and Plan) format.",
          associatedPrompts: ["Subjective", "Objective", "Assessment and Plan"]
        },
        {
          name: "Medical Follow-Up Note",
          iconName: "follow_the_signs", // Replace with specific icon name
          description: "Notes for tracking patient progress after initial treatment or diagnosis.",
        },
        
        {
          name: "Prescription Overview",
          iconName: "local_pharmacy", // Replace with specific icon name
          description: "An overview of patient prescriptions, including dosages and instructions."
        },
        {
          name: "Patient Intake Form",
          iconName: "assignment_ind", // Replace with specific icon name
          description: "Form used to gather initial patient information, including medical history."
        },
        
        {
          name: "Treatment Plan",
          iconName: "format_list_numbered", // Replace with specific icon name
          description: "A detailed plan outlining a patient's treatment strategy.",
        },
    ];*/}

    const handleSummaryTextEdit = (promptType) => {
        setEditMode({ ...editMode, [promptType]: true });
        setEditedText({ ...editedText, [promptType]: summaries[promptType].response });
    };

    const handleSummaryTextChange = (e, promptType) => {
        setEditedText({ ...editedText, [promptType]: e.target.value });
    };

    // Function to save changes
    const handleSave = async (promptType) => {
        try {
            // Update local state with edited text
            const updatedSummaries = {
                ...summaries, 
                [promptType]: { 
                    ...summaries[promptType], 
                    response: editedText[promptType] 
                }
            };
            setSummaries(updatedSummaries);
    
            // Check for necessary information
            if (!userId || (!patientName && !selectedPatient)) {
                console.error("User ID or patient name missing");
                return;
            }
    
            // Update Firestore database
            let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
            const visitDocRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);
            const updateData = {};
            updateData[`summaries.${promptType}.response`] = editedText[promptType];
    
            await updateDoc(visitDocRef, updateData);
            //console.log("Summary updated successfully");
    
            // Exit edit mode
            setEditMode({ ...editMode, [promptType]: false });
        } catch (error) {
            console.error("Failed to save summary:", error);
            // Optional: Revert changes in UI if needed
        }
    };
    
    // Function to cancel editing
    const handleCancel = (promptType) => {
        setEditMode({ ...editMode, [promptType]: false });
    };



    const handleEditTemplateSummary = (promptType) => {
        setEditModeTemplate({ ...editModeTemplate, [promptType]: true });
        setEditedTextTemplate({ ...setEditedTextTemplate, [promptType]: templateSummaries[promptType].response });
    };

    const handleTemplateTextChange = (e, promptType) => {
        setEditedTextTemplate({ ...editedTextTemplate, [promptType]: e.target.value });
    };

    const handleSaveTemplate = async (promptType) => {
        try {
            // Update local state with edited text
            const updatedSummariesTemplate = {
                ...templateSummaries, 
                [promptType]: { 
                    ...templateSummaries[promptType], 
                    response: editedTextTemplate[promptType] 
                }
            };
            setTemplateSummaries(updatedSummariesTemplate);
    
            // Check for necessary information
            if (!userId || (!patientName && !selectedPatient)) {
                console.error("User ID or patient name missing");
                return;
            }

            // Update Firestore database
            let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
            const templateRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}/templates/${templateNameToDisplay}`);
            const updateData = {};
            updateData[`templateSummaries.${promptType}`] = updatedSummariesTemplate[promptType];

            await updateDoc(templateRef, updateData);
            //console.log("Summary updated successfully");

    
            // Exit edit mode
            setEditModeTemplate({ ...editModeTemplate, [promptType]: false });
        } catch (error) {
            console.error("Failed to save summary:", error);
            // Optional: Revert changes in UI if needed
        }
    };


    const handleCancelTemplate = (promptType) => {
        setEditModeTemplate({ ...editModeTemplate, [promptType]: false });
    };



    {/*const handleEditTranscript = () => {
        setEditModeTranscript(true);
        setEditedTextTranscript(transcript.text); // Initialize with current transcript text
    };*/}

    const handleSaveTranscript =  async () => {
        if (!userId || (!patientName && !selectedPatient)) {
            console.error("User ID or patient name missing");
            return;
        }
    
        try {
            const patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
            const sessionRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);
    
            // Assuming transcript is an object containing the updated utterances
            await updateDoc(sessionRef, {
                transcript: newTranscript,
            });
            console.log(`Saving transcript for user: ${userId}, patient: ${patientToUse}, session: ${sessionName}`);
            console.log("Transcript data to save:", newTranscript);
            // console.log("Transcript data to save:", transcript);
    
            setIsTranscriptEdited(false); // Reset the edit flag
            //console.log("Transcript saved successfully");
            setIsTranscriptChangesSuccess(true); // Notify success

            setTimeout(() => {
                setIsTranscriptChangesSuccess(false);
            }, 5000); 
        } catch (error) {
            console.error("Error saving transcript:", error);
        }
    };

    const handleCancelTranscript = async () => {
        if (!userId || (!patientName && !selectedPatient)) {
            console.error("User ID or patient name missing");
            return;
        }
    
        try {
            const patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
            const sessionRef = doc(db, `users/${userId}/summaries/${patientToUse}/visits/${sessionName}`);

            await updateDoc(sessionRef, {
                transcript: originalTranscript.data.results.channels[0].alternatives[0].paragraphs.transcript,
            });
    
            setTranscript(originalTranscript);
            setNewTranscript(originalTranscript.data.results.channels[0].alternatives[0].paragraphs.transcript);
            setResetKey(prev => prev + 1); 
            setIsTranscriptEdited(false); // Reset the edit flag
            //console.log("Transcript reset to original");
        } catch (error) {
            console.error("Error resetting transcript:", error);
        }
    };

    const handleTextChangeTranscript = (updatedTranscript) => {
        setNewTranscript(updatedTranscript);
        setIsTranscriptEdited(true);
    };
    




    const splitTextTemplates = (text, searchTerm) => {
        if (!searchTerm) return [text];
    
        const regex = new RegExp(`(${searchTerm})`, 'gi');
        return text.split(regex);
    };  

    const splitTextSummaries = (text, searchTerm) => {
        if (!searchTerm) return [text];
    
        const regex = new RegExp(`(${searchTerm})`, 'gi');
        return text.split(regex);
    };    


    const toggleCardExpansion = () => {
        setIsCardExpanded(!isCardExpanded);
    };

    const handleTranscriptSearchChange = (e) => {
        setTranscriptSearchTerm(e.target.value);
    };


    const openFormAddingTemplate = () => {
        setAddingNewTemplate(true);
        setTimeout(() => {
            if (templateAddref.current) {
                templateAddref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
    }

    const closeFormAddingTemplate = () => {
        setAddingNewTemplate(false);
    }

    const handleAddSummary = () => {
        setNewTemplateSummaries([...newTemplateSummaries, newTemplateSummary]);
        setNewTemplateSummary({ name: "", content: "" }); // Reset new summary inputs
    };

    const handleImportLibrarySummaryToNewTemplate = (selectedSummary) => {
        if (!selectedSummary) {
            console.error("No summary selected for import");
            return;
        }

        const newSummaryToAdd = {
            name: selectedSummary.id,
            content: selectedSummary.content
        };
    
        setNewTemplateSummaries(currentSummaries => [...currentSummaries, newSummaryToAdd]);
        //showSnackbar("dark", "notifications", `Summary '${selectedSummary.id}' added to your new template.`, "You can continue editing your template.");
    };
    

    const handleDeleteSummaryTemplate = (index) => {
        // Create a new array excluding the summary at the specified index
        const updatedSummaries = newTemplateSummaries.filter((_, i) => i !== index);
    
        // Update the state with the new array
        setNewTemplateSummaries(updatedSummaries);
    };

    const handleEditSummaryContentTemplate = (index, newContent) => {
        // Create a copy of the current summaries
        const updatedSummaries = [...newTemplateSummaries];
        
        // Update the content of the summary at the given index
        updatedSummaries[index] = { ...updatedSummaries[index], content: newContent };
    
        // Update the state with the modified summaries
        setNewTemplateSummaries(updatedSummaries);
    };


    const handleCreateTemplate = async () => {
        const db = getFirestore();
        const user = getAuth().currentUser;
    
        if (!user) {
            console.error("User not authenticated");
            return;
        }

        if (!newTemplateName || newTemplateName.trim() === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Template Name',
                text: 'Please enter a name for this Template.',
                confirmButtonColor: '#344767',
                confirmButtonText: 'OK'
            });
            return; 
        }
        if (!newTemplateDescription || newTemplateDescription.trim() === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Template Description',
                text: 'Please enter a description for this Template.',
                confirmButtonColor: '#344767',
                confirmButtonText: 'OK'
            });
            return; 
        }
    
        // Create a new template document in 'templateprompts' collection
        const templateRef = doc(collection(db, `users/${user.uid}/templateprompts`), newTemplateName);
    
        // Prepare the template data
        const templateData = {
            name: newTemplateName,
            description: newTemplateDescription,
            iconName: "note_add"
            //createdAt: Timestamp.fromDate(new Date()), // Optional, if you want to track when the template was created
        };
    
        try {
            // Save the template data
            await setDoc(templateRef, templateData);
    
            // Save each summary as a sub-document under this template
            const summariesRef = collection(templateRef, 'summaries');
            newTemplateSummaries.forEach(async (summary) => {
                const summaryRef = doc(summariesRef, summary.name);
                const summaryData = {
                    content: summary.content,
                };
                await setDoc(summaryRef, summaryData);
            });
    
            //console.log("Template and summaries created successfully");
            // Optionally, reset state or provide feedback to the user
            setAddingNewTemplate(false);
            setNewTemplateName('');
            setNewTemplateDescription('');
            setNewTemplateSummaries([]);
            setSaveSuccessNewTemplates(true); 
            setSnackbar({
                show: true,
                title: "Template created successfully!",
                message: "Your template will be available shortly",
            });
            await fetchTemplates();
        } catch (error) {
            console.error("Error creating template and summaries:", error);
            // Optionally, handle errors (e.g., show error message to the user)
        }
    };

    const fetchTemplates = async () => {
        const db = getFirestore();
        const templatesRef = collection(db, `users/${userId}/templateprompts`);
      
        try {
          const templateSnapshot = await getDocs(templatesRef);
          let templatesData = [];
      
          for (const doc of templateSnapshot.docs) {
            const summariesSnapshot = await getDocs(collection(db, `users/${userId}/templateprompts/${doc.id}/summaries`));
            let summariesData = summariesSnapshot.docs.map(summaryDoc => ({
              id: summaryDoc.id,
              content: summaryDoc.data().content // Assuming 'content' holds the prompt text
            }));
      
            templatesData.push({
              id: doc.id,
              name: doc.data().name,
              iconName: doc.data().iconName,
              description: doc.data().description,
              associatedPrompts: summariesData
            });
          }
      
          // Update local storage
          saveTemplatesToLocalstorage(templatesData);
      
          // Update application state
          setTemplates(templatesData);
      
          //console.log("Fetched and updated templates with summaries: ", templatesData);
        } catch (error) {
          console.error("Error fetching templates and summaries: ", error);
        }
    };



    const copyAllTemplateSummaries = async () => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString("en-US", { month: 'long', day: '2-digit', year: 'numeric' });
        const formattedTime = currentDate.toLocaleTimeString("en-US", {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        const fullDateTime = `${formattedDate} ${formattedTime}`;
        const headerText = `Note Title: ${sessionName}\nProvider: ${providerName}\nDate: ${fullDateTime}\n\n`;

        const allSummariesText = Object.entries(templateSummaries)
        .map(([id, summary]) => `====\n${id}\n====\n\n${summary.response}`)
        .join("\n\n");

        const completeText = headerText + allSummariesText;
        try {
            await navigator.clipboard.writeText(completeText);
            setCopyAllTemplate(true);

            setTimeout(() => {
                setCopyAllTemplate(false);
            }, 2000);
        } catch (err) {
            console.error("Failed to copy summaries to clipboard:", err);
            
        }
    };

    const copySelectedTemplateSummaries = async () => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString("en-US", { month: 'long', day: '2-digit', year: 'numeric' });
        const formattedTime = currentDate.toLocaleTimeString("en-US", {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        const fullDateTime = `${formattedDate} ${formattedTime}`;
        const headerText = `Note Title: ${sessionName}\nProvider: ${providerName}\nDate: ${fullDateTime}\n\n`;
    
        // Filter and format only the selected summaries
        const selectedSummariesText = Object.entries(templateSummaries)
            .filter(([promptType]) => selectedTemplateSummaries[promptType])
            .map(([promptType, summaryDetails]) => {
                return `====\n${promptType}\n====\n\n${summaryDetails.response}`;
            })
            .join("\n\n");
    
        const completeText = headerText + selectedSummariesText;
        try {
            await navigator.clipboard.writeText(completeText);
            // Set state to show UI feedback for successful copy
            setCopySelectedTemplateSums(true);
    
            setTimeout(() => {
                // Reset the feedback state after a delay
                setCopySelectedTemplateSums(false);
            }, 2000);
        } catch (err) {
            console.error("Failed to copy selected template summaries to clipboard:", err);
            // Handle error, possibly update UI to indicate failure
        }
    };
    
        
    const copySingleTemplateSummary = async (promptType, text) => {
        const textToCopy = `${promptType}:\n${text}`;

        try {
          await navigator.clipboard.writeText(textToCopy);
          setCopyTemplateSummary(prev => ({ ...prev, [promptType]: true }));

          setTimeout(() => {
            setCopyTemplateSummary(prev => ({ ...prev, [promptType]: false }));
          }, 2000);
        } catch (err) {
          console.error("Failed to copy summary:", err);
        }
    };
      

    const copyAllRegularSummaries = async () => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString("en-US", { month: 'long', day: '2-digit', year: 'numeric' });
        const formattedTime = currentDate.toLocaleTimeString("en-US", {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        const fullDateTime = `${formattedDate} ${formattedTime}`;
        const headerText = `Note Title: ${sessionName}\nProvider: ${providerName}\nDate: ${fullDateTime}\n\n`;

        const allSummaries = Object.entries(summaries).map(([promptType, summaryDetails]) => {
            return `====\n${promptType}\n====\n\n${summaryDetails.response}`;
        }).join("\n\n");

        const completeText = headerText + allSummaries;
        try {
            await navigator.clipboard.writeText(completeText);
            setCopyAllSummary(true);

            setTimeout(() => {
                setCopyAllSummary(false);
            }, 2000);
        } catch (err) {
            console.error("Failed to copy summaries to clipboard:", err);
            
        }
    };

    const copySelectedSummaries = async () => {
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString("en-US", { month: 'long', day: '2-digit', year: 'numeric' });
        const formattedTime = currentDate.toLocaleTimeString("en-US", {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        const fullDateTime = `${formattedDate} ${formattedTime}`;
        const headerText = `Note Title: ${sessionName}\nProvider: ${providerName}\nDate: ${fullDateTime}\n\n`;
      
        const selectedSummariesText = Object.entries(summaries)
          .filter(([promptType]) => selectedSummaries[promptType])
          .map(([promptType, summaryDetails]) => {
            return `====\n${promptType}\n====\n\n${summaryDetails.response}`;
          })
          .join("\n\n");
      
        const completeText = headerText + selectedSummariesText;
        
        if (!selectedSummariesText) {
          console.error("No summaries selected to copy.");
          return; // Optionally handle this case in your UI, e.g., show a message to the user
        }
      
        try {
          await navigator.clipboard.writeText(completeText);
          setCopySelectedSummary(true);
      
          setTimeout(() => {
            setCopySelectedSummary(false);
          }, 2000);
        } catch (err) {
          console.error("Failed to copy selected summaries to clipboard:", err);
          // Optionally handle this error in your UI
        }
    };
      

    const copySingleRegularSummary = async (promptType, text) => {
        const textToCopy = `${promptType}:\n${text}`;

        try {
          await navigator.clipboard.writeText(textToCopy);
          setCopySummary(prev => ({ ...prev, [promptType]: true }));

          setTimeout(() => {
            setCopySummary(prev => ({ ...prev, [promptType]: false }));
          }, 2000);
        } catch (err) {
          console.error("Failed to copy summary:", err);
        }
    };

    const summariesOrder = [
        "Chief Complaint",
        "Subjective",
        "Objective",
        "Risk Assessment",
        "Mental Status Exam",
        "Therapeutic Interventions",
        "Medications",
        "Family & Social history",
        "Assessment and Plan"
    ];
    
    function sortSummariesWithCustomOrder(generatedSummaries, fixedOrder) {
        // Separate predefined and custom summaries
        const predefinedSummaries = {};
        const customSummaries = {};
    
        Object.keys(generatedSummaries).forEach(key => {
            if (fixedOrder.includes(key)) {
                predefinedSummaries[key] = generatedSummaries[key];
            } else {
                customSummaries[key] = generatedSummaries[key];
            }
        });
    
        // Sort predefined summaries according to the fixed order
        const orderedSummaries = {};
        fixedOrder.forEach(key => {
            if (predefinedSummaries[key]) {
                orderedSummaries[key] = predefinedSummaries[key];
            }
        });
    
        // Append custom summaries below predefined ones
        // Optionally, sort customSummaries here based on another criterion if desired
        Object.keys(customSummaries).forEach(key => {
            orderedSummaries[key] = customSummaries[key];
        });
    
        return orderedSummaries;
    }

    const handleInputChange = (e) => {
        const inputValue = e.target.value;
        if (inputValue.includes('/')) {
          setIsInputValid(true); // Set input as invalid
        } else {
          setIsInputValid(false); // Set input as valid
          setSessionNameBeforeUpload(inputValue);
        }
    };


    const handleTextChange = (promptType, newText) => {
        setRefineTemplateNotes(prevTexts => ({
          ...prevTexts,
          [promptType]: { text: newText,}
        }));
        //console.log("refine notes: ", refineTemplateNotes)
    };

    // Callback function to update recording status of talking to notes 
    const handleRecordingStatusChange = (promptType, isListening) => {
        setIsRecordingToNotes(prevStates => ({
            ...prevStates,
            [promptType]: isListening,
        }));    
    };

    const handleTextChangeSummaries = (promptType, newText) => {
        setRefineSummariesNotes(prevTexts => ({
          ...prevTexts,
          [promptType]: { text: newText,}
        }));
        //console.log("refine summary notes: ", refineSummariesNotes)
    };

    const handleRecordingStatusChangeSums = (promptType, isListening) => {
        setIsRecordingToSummaries(prevStates => ({
            ...prevStates,
            [promptType]: isListening,
        }));    
    };

      
    
    


    return (
        <DashboardLayout>
            <DashboardNavbar staticNavbar={true} />
            < TitleSection />
            {/*<div>
                <p>{status}</p>
                <button onClick={startRecording}>Start Recording</button>
                <button onClick={stopRecording}>Stop Recording</button>
                <audio src={mediaBlobUrl} controls />
            </div>*/}
            {hasActiveOrTrialSubscription ? (
                <>
                    <SoftBox mt={3} mb={4}>
                        <Grid container spacing={2} justifyContent="center">

                            {/* New Conversation Section */}
                            <Grid item xs={12} lg={12} xl={11} xxl={10}>
                                <Card sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }} >
                                    <SoftBox p={2} lineHeight={1}>
                                        <SoftBox px={2} display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" mb={3} mt={1} >
                                            <SoftTypography variant='h5' fontWeight='medium' >
                                                Current Recording Information
                                            </SoftTypography>
                                            {/*<SoftButton variant="contained" color="dark" size="small" onClick={resetAllValues} sx={{ mr: 2}}  >
                                                <Icon  sx={{ fontWeight: 'bold' }}>
                                                    autorenew
                                                </Icon>&nbsp;
                                                <SoftTypography variant="button" color="white" >
                                                    New Recording
                                                </SoftTypography>
                                            </SoftButton>*/}
                                            <Tooltip title="Resets everything in order to start a brand new consultation" placement="top" >
                                                <SoftButton variant="contained" color="dark" size="small" onClick={resetAllValues}>
                                                    <Icon sx={{ fontWeight: "bold" }}>add</Icon>&nbsp; New Recording
                                                </SoftButton>
                                            </Tooltip>
                                        </SoftBox>
                                        <SeparatorPatient />
                                        <SoftBox
                                            display="flex"
                                            flexDirection="column"
                                            alignItems="center"
                                            justifyContent="center"
                                            height="100%"
                                            mt={2}
                                        >
                                            {/* Patient Selector and Add New Button */}
                                            <SoftBox display="flex" mt={1} flexDirection="row" alignItems="center" justifyContent="center" width="80%">
                                                <SoftBox flex={1} mr={2} flexDirection="column" sx={{ zIndex: 1000 }} >
                                                    <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                            Existing Patient
                                                        </SoftTypography>
                                                    </SoftBox>
                                                    <SoftSelect placeholder={'Search or Select Patient'}
                                                        value={selectedPatientBeforeUpload ? { value: selectedPatientBeforeUpload, label: selectedPatientBeforeUpload } : ''}
                                                        //value= {patientName ? '' : selectedPatient}
                                                        options={filteredPatients.map(patient => ({ value: patient, label: patient }))}
                                                        onChange={handleSoftSelectChange}
                                                        size="medium"
                                                        style={{ width: '100%' }}
                                                    />
                                                </SoftBox>
                                                <SoftBox flex={1} mr={0} flexDirection="column">
                                                    <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                            New Patient
                                                        </SoftTypography>
                                                    </SoftBox>
                                                    <SoftBox position='relative'>
                                                        <SoftInput 
                                                            placeholder="Name of the New Patient" 
                                                            value={patientNameBeforeUpload}
                                                            onChange={(e) => {
                                                                setPatientNameBeforeUpload(e.target.value);
                                                                if (e.target.value) {
                                                                    handleAddNewPatient();
                                                                }
                                                            }}
                                                        />
                                                    </SoftBox>
                                                </SoftBox>
                                            </SoftBox>

                                    
                                            <SoftBox display="flex" flexDirection="row" alignItems="center" mt={2} justifyContent="center" width="80%" >
                                            {/* Patient Age */}
                                            <SoftBox flex={0.2} mr={2}>
                                                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                        Age
                                                    </SoftTypography>
                                                </SoftBox>
                                                <SoftInput 
                                                    placeholder="Patient's Age" 
                                                    value={patientAgeBeforeUpload}
                                                    onChange={(e) => setPatientAgeBeforeUpload(e.target.value)}
                                                    style={{ width: '100%' }}
                                                />
                                            </SoftBox>

                                            {/* Patient Gender */}
                                            <SoftBox flex={0.2}>
                                                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                        Gender
                                                    </SoftTypography>
                                                </SoftBox>
                                                <SoftInput 
                                                    placeholder="Patient's Gender" 
                                                    value={patientGenderBeforeUpload}
                                                    onChange={(e) => setPatientGenderBeforeUpload(e.target.value)}
                                                    style={{ width: '100%' }}
                                                />
                                            </SoftBox>
                                            <SoftBox flex={0.5} ml={4}>
                                                <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                        Name of Todays Visit
                                                    </SoftTypography>
                                                    {/*<Tooltip title="Enter a descriptive name for this visit/session">
                                                        <IconButton size="small">
                                                            <InfoIcon fontSize="small" />
                                                        </IconButton>
                                                        </Tooltip>*/}
                                                </SoftBox>
                                           
                                                <SoftInput 
                                                    placeholder="Title of today's visit" 
                                                    value={sessionNameBeforeUpload}
                                                    onChange={handleInputChange}
                                                    style={{ width: '100%' }}
                                                    //error={ isInputValid ? true : false}
                                                />
                                            </SoftBox>
                                        </SoftBox>
                                    </SoftBox>
                                    <SoftBox p={2} lineHeight={1}>
                                        <SoftBox pt={5}>
                                            <SeparatorRecord />
                                        </SoftBox>
                                        <SoftBox pt={3} mb={1} display="flex" flexDirection="row" alignItems="center"  justifyContent="center" width="100%">
                                            <SoftBox 
                                                display="flex" 
                                                flexDirection="row" 
                                                alignItems="center" 
                                                justifyContent="center" 
                                                width="100%" 
                                                sx={{ margin: '0 auto' }} 
                                            >
                                                <AudioRecorder
                                                    onRecordingComplete={(audioBlob) => AudioElement(audioBlob)}
                                                    recorderControls={recorderControls}
                                                    showVisualizer={true}
                                                />
                                                <SoftBox pl={4} pr={4} >
                                                    {audioDetails.file ? (
                                                        <SoftBadge
                                                        variant="contained"
                                                        color="success"
                                                        size="sm"
                                                        badgeContent={
                                                            <SoftTypography color="dark" variant="button" >
                                                                Recording temporary saved
                                                            </SoftTypography>
                                                        }
                                                        circular
                                                        container
                                                        />
                                                    ) : (
                                                        <SoftBadge
                                                            variant="contained"
                                                            color="secondary"
                                                            size="sm"
                                                            badgeContent={
                                                                <SoftTypography color="dark" variant="button" >
                                                                    No current recording 
                                                                </SoftTypography>
                                                            }
                                                            circular
                                                            container
                                                        />
                                                    )}
                                                </SoftBox>
                                                

                                                <SoftBox pl={4}  display="flex" flexDirection="row" alignItems="center">
                                                    <Tooltip title={tempDisableUpload ? "Processing the previous recording. Please wait for a couple of seconds and try again." : remainingHours <= 0 ? "You have used up all your available hours for this month." : "Starts the generating process of the current audio recording"} placement="top" >
                                                        <span>
                                                        <SoftButton disabled={tempDisableUpload || remainingHours <= 0}  sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', mr: 2 }} startIcon={<FileUploadOutlinedIcon />} variant="contained" color="dark" size="medium" onClick={handleAudioUpload}>
                                                            { uploadState ? "re-Upload" : "upload" }
                                                        </SoftButton>
                                                        </span>
                                                    </Tooltip>
                                                    <Tooltip title="Deletes the current audio (file)" placement="top" >
                                                        <SoftButton sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)'}} variant="contained" size="medium" color="light" startIcon={<RestartAltOutlinedIcon sx={{ fontWeight: "bold", fontSize: "2.5rem"}} />} onClick={handleReset}>
                                                            Clear
                                                        </SoftButton>
                                                    </Tooltip>
                                                </SoftBox>
                                            </SoftBox>

                                        </SoftBox>
                                        <SoftBox >
                                            {audioDetails.file ? (
                                                <SoftBox display="flex" alignItems="center" justifyContent="center" pt={2}> 
                                                    <SoftTypography color="dark" variant="button" >
                                                        Recording Time: {formatTime(recordingTime)}
                                                    </SoftTypography>
                                                </SoftBox>
                                            ) : (
                                                null
                                            )}
                                            {remainingHours <= 0 && (
                                                <SoftBox display="flex" justifyContent="center" alignItems="center" pt={3} mb={-3} >
                                                    <SoftBadge
                                                        variant="contained"
                                                        color="warning"
                                                        size="md"
                                                        badgeContent={
                                                            <SoftTypography color="dark" variant="h6">
                                                                You have used up all your available hours for this month.
                                                            </SoftTypography>
                                                        }
                                                        //circular
                                                        container
                                                    />
                                                </SoftBox>
                                            )}
                                            {remainingHours > 0 && remainingHours < 5 && (
                                                <SoftBox display="flex" justifyContent="center" alignItems="center" pt={3} mb={-3} >
                                                    <SoftBadge
                                                        variant="contained"
                                                        color="warning"
                                                        size="md"
                                                        badgeContent={
                                                            <SoftTypography color="dark" variant="h6">
                                                              👋 &nbsp;&nbsp;You only have {remainingHours} hours left for this month.
                                                            </SoftTypography>
                                                        }
                                                        //circular
                                                        container
                                                    />
                                                </SoftBox>
                                            )}
                                        </SoftBox>
                                    </SoftBox>
                                    
                                    {audioDetails.url && (
                                        <SoftBox pt={1} pb={1} display="flex" justifyContent="center" alignItems="center">
                                            {/*<audio src={audioDetails.url} controls />
                                            <a href={audioDetails.url} download="recording.mp3">Download Recording</a>*/}
                                            <Tooltip title="Download this Recording" placement="top" >
                                                <SoftButton 
                                                    size="small" 
                                                    color="dark" 
                                                    variant="outlined" 
                                                    onClick={() => {
                                                        //let patientToUse = isAddingNew && patientName ? patientName : selectedPatient;
                                                        const filenameInput = prompt("Please enter a name for your recording", "recording");
                                                        const filename = filenameInput || 'recording';
                                                        const link = document.createElement("a");
                                                        link.href = audioDetails.url;
                                                        link.download =  `${filename}.mp3`;
                                                        document.body.appendChild(link); 
                                                        link.click(); 
                                                        document.body.removeChild(link); 
                                                    }}
                                                >
                                                    Download 
                                                </SoftButton>
                                            </Tooltip>
                                        </SoftBox>
                                    )}
                                    
                                    <SoftBox >
                                        <SoftBox pt={3} pb={1} display="flex" justifyContent="center" alignItems="center" >
                                            {/*<SoftButton onClick={toggleDropzone} size="small" variant="contained" color="dark">
                                                    {showDropzone ? 'Hide Upload Modal' : 'Upload Recording File'}
                                            </SoftButton>*/}
                                            <SoftTypography 
                                                variant="button" 
                                                color="dark"
                                                onClick={toggleDropzone} 
                                                sx={{
                                                    cursor:'pointer',
                                                    textDecoration: 'underline'
                                                }}
                                            >
                                                {showDropzone ? 'Hide Upload Modal' : 'Upload Recording File'}
                                            </SoftTypography>
                                        </SoftBox>
                                        { showDropzone && (
                                            <SoftBox px={3} pt={3} >
                                                <SoftDropzone
                                                    options={{ 
                                                        //ignoreHiddenFiles: false,
                                                        maxFilesize: 1280,
                                                        addRemoveLinks: true,
                                                        //thumbnailHeight: 50,
                                                        //thumbnailWidth: 50,
                                                        //maxFiles: 1,
                                                        addedfile: handleFileAdded,
                                                    }}
                                                />
                                            </SoftBox>
                                        )}
                                    </SoftBox>
                                    {/*<SeparatorRecord />*/}
                                    </SoftBox>
                                </Card>
                            </Grid>
                            <Grid item xs={10} lg={11}>
                            
                                    <SoftBox >
                                        {/*<SoftTypography >
                                            Test 
                                        </SoftTypography>*/}
                                        {/*< VoiceglowChatbot />*/}
                                        {/*< MyChat />*/}
                                        {/*<VoiceflowChat />*/}
                                        {/*<NoteSection />*/}

                                    </SoftBox>
                                
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={11}>
                                <Card sx={{
                                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)'
                                }}>
                                    <SoftBox p={2} >
                                        <SoftBox display="flex" justifyContent="space-between" alignItems="center" pt={0} px={2} mb={3}>
                                            <SoftBox display="flex" alignItems="center">
                                                <SoftTypography variant="h6" >{tabText(currentTab)}</SoftTypography>
                                                <Tooltip title={
                                                    currentTab === 0 ? tooltips.templates :
                                                    currentTab === 1 ? tooltips.summarization :
                                                    tooltips.transcript
                                                    }
                                                    placement="right"
                                                >
                                                    <IconButton>
                                                        <InfoOutlinedIcon fontSize="small" color="dark" />
                                                    </IconButton>
                                                </Tooltip>
                                            </SoftBox>
                                            <SoftBox sx={{ width: {md: '70%',lg: '65%', xl: '63%', xxl: '60%' }}} >
                                                <AppBar position="static">
                                                    <Tabs value={currentTab} onChange={handleTabChange} aria-label="Transcription tabs">
                                                        <Tab label="My Templates" />
                                                        <Tab label="My Summaries" />
                                                        <Tab label="Patient Instructions" />
                                                    </Tabs>
                                                </AppBar>
                                            </SoftBox>
                                        </SoftBox>
                                        {currentTab === 0 && (
                                            <SoftBox px={1} py={2} pt={4}>
                                                <Grid container spacing={2}>
                                                    {templates.map((template, index) => (
                                                        <Grid item xs={12} sm={6} md={4} key={index}>
                                                            <ComplexProjectCard
                                                                color="info" // You can dynamically set color if needed
                                                                iconName={template.iconName}
                                                                title={template.name}
                                                                //description={template.description}
                                                                onIconClick={(event) => handleOpenMenu(event, template.name)}
                                                                onCardClick={() => handleCardSelect(template.name)}
                                                                isSelected={selectedCard === template.name}
                                                            />
                                                        </Grid>
                                                    ))}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                        
                                                            
                                                            <Tooltip title="Import Templates From Library">
                                                            <span>
                                                            <PlaceholderCard
                                                                title={{ variant: "h5", text: "Import From Library" }}
                                                                icon="library_add"
                                                                onClick={openLibraryModal}
                                                                //disabled={ currentUserSubscription === "Small Plan" ? true : false}
                                                            />
                                                            </span>
                                                            </Tooltip>
                                                            
                                                    </Grid>
                                                </Grid>
                                                {selectedCard ? (
                                                    <SoftBox mt={3}>
                                                        <Card sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }} >
                                                            <SoftBox p={2} display="flex" justifyContent="space-between" alignItems="center">
                                                                {isCardExpanded ? 
                                                                    <SoftTypography pl={2} variant="h6">{selectedCard}</SoftTypography> :
                                                                    <SoftTypography pl={2} variant="body2"> Description & Included Summary Notes for {selectedCard}</SoftTypography> 
                                                                }
                                                                <SoftButton size="small" color="light" onClick={toggleCardExpansion}>
                                                                    {isCardExpanded ? 
                                                                        <ExpandLessIcon color="#344767" fontSize="large" /> : 
                                                                        <ExpandMoreIcon /> 
                                                                    }
                                                                </SoftButton>
                                                            </SoftBox>
                                                            {isCardExpanded && (
                                                                <SoftBox px={2} mb={2} >
                                                                    <SoftBox mt={1} mb={2}>
                                                                        <SeparatorDescription />
                                                                    </SoftBox>
                                                                    <SoftTypography pl={2} variant="body2">
                                                                        {templates.find(template => template.name === selectedCard).description}
                                                                    </SoftTypography>
                                                                    <SoftBox mt={3} mb={2}>
                                                                        <SeparatorSumsList />
                                                                    </SoftBox>
                                                                    <SoftBox mt={2}>
                                                                        {templates.find(template => template.name === selectedCard).associatedPrompts.map((prompt, index) => (
                                                                            <SoftBox key={index} mt={0}>
                                                                                <SoftTypography pl={2} variant="body2" fontWeight="medium" color="text">
                                                                                    - {prompt.id}
                                                                                </SoftTypography>
                                                                            </SoftBox>
                                                                        ))}
                                                                    </SoftBox>
                                                                </SoftBox>
                                                            )}
                                                        </Card>
                                                    </SoftBox>
                                                ) : (
                                                    <SoftBox mt={3} display="flex" justifyContent="center" alignItems="center">
                                                        <SoftTypography textAlign="center" variant="h6" color="textSecondary">
                                                         🔔&nbsp;&nbsp;&nbsp;&nbsp;Please select a template from the list by clicking it to see details and generate content based on your recording. When you upload a recording, the selected template will be generated.
                                                        </SoftTypography>
                                                    </SoftBox>
                                                )}
                                                {isEditMode && selectedTemplate && (
                                                    <SoftBox ref={editSectionRef} py={4}>
                                                        <Card sx={{ boxShadow: '0px 0px 50px rgba(0, 0, 0, 0.1)' }}>
                                                            <SoftBox p={2}>
                                                                {templates.filter(template => template.name === selectedTemplate.name).map((template) => {
                                                                    // Step 1: Extract and sort the prompts
                                                                    const sortedPrompts = [...template.associatedPrompts].sort((a, b) => {
                                                                        return templateSummariesOrder.indexOf(a.id) - templateSummariesOrder.indexOf(b.id);
                                                                    });

                                                                    return (
                                                                        <div key={template.name}>
                                                                            <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                                                                <SoftBox display="flex" alignItems="center" pl={2}>
                                                                                    <SoftTypography variant="h6" mr={1}>Currently editing:</SoftTypography>
                                                                                    <SoftBadge
                                                                                        variant="contained"
                                                                                        color="warning"
                                                                                        size="sm"
                                                                                        badgeContent={
                                                                                            <SoftTypography color="dark" variant="h6">
                                                                                                {template.name}
                                                                                            </SoftTypography>
                                                                                        }
                                                                                        //circular
                                                                                        //container
                                                                                    />
                                                                                </SoftBox>
                                                                                <SoftBox >
                                                                                    <Tooltip title="Add a new summary to this template" placement="bottom" >
                                                                                        <SoftButton startIcon={ <AddOutlinedIcon /> } onClick={handleOpenAddNewSummary} color="dark" size="medium" sx={{ mr: 2 }}  >
                                                                                            Add Summary
                                                                                        </SoftButton>
                                                                                    </Tooltip>
                                                                                    <Tooltip title="Close editing form" placement="bottom" >
                                                                                        <SoftButton variant="outlined" startIcon={ <CloseOutlinedIcon /> } onClick={handleCloseEdit} color="dark" size="medium"  >
                                                                                            Close editor
                                                                                        </SoftButton>
                                                                                    </Tooltip>
                                                                                </SoftBox>
                                                                            </SoftBox>
                                                                            <SeparatorEditTemplate />
                                                                            <SoftBox py={1} display="flex" justifyContent="center" alignItems="center" >
                                                                                <SoftTypography variant="button" color="text" >
                                                                                    Click one of the summaries to view details and edit. You can also drag and drop to change their order.
                                                                                </SoftTypography>
                                                                            </SoftBox>
                                                                            {/* Step 2: Render the sorted prompts */}
                                                                            <SoftBox mb={2} >
                                                                            <SoftBox borderRadius="10px" py={1}  >
                                                                                <DragDropContext onDragEnd={onDragEnd}>
                                                                                <Droppable droppableId="summaries">
                                                                                    {(provided) => (
                                                                                        <div {...provided.droppableProps} ref={provided.innerRef}>
                                                                                            {sortedPrompts.map((prompt, index) => (
                                                                                                <Draggable key={prompt.id} draggableId={prompt.id} index={index}>
                                                                                                    {(provided) => (
                                                                                                        <div
                                                                                                            ref={provided.innerRef}
                                                                                                            {...provided.draggableProps}
                                                                                                            {...provided.dragHandleProps}
                                                                                                        >
                                                                                                            <SoftBox pb={1} >
                                                                                                            <Card sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', border:'1px solid #344767' }} >
                                                                                                                <SoftBox bgColor="light" p={2} >
                                                                                                                    <SoftBox sx={{ cursor: 'pointer' }} onClick={() => toggleSummaryExpansion(prompt.id)} display="flex" justifyContent="space-between" alignItems="center">
                                                                                                                        <SoftTypography pl={1} variant="h6">{prompt.id}</SoftTypography>
                                                                                                                        {expandedTemplateSummaries[prompt.id] && (
                                                                                                                            <SoftBox>
                                                                                                                                <Tooltip title="Delete this summary from the template" placement="bottom" >
                                                                                                                                    <SoftButton color="error" variant="outlined" size="small" onClick={() => handleDeleteSummaryClick(prompt.id)}>
                                                                                                                                        Delete
                                                                                                                                    </SoftButton>
                                                                                                                                </Tooltip>
                                                                                                                            </SoftBox>
                                                                                                                        )}
                                                                                                                    </SoftBox>
                                                                                                                    {expandedTemplateSummaries[prompt.id] && (
                                                                                                                        <SoftBox>
                                                                                                                            <SoftInput
                                                                                                                                value={prompt.content}
                                                                                                                                onChange={currentUserSubscription !== "Silver Subscription" ? (e) => handlePromptChange(prompt.id, e.target.value) : null}
                                                                                                                                multiline
                                                                                                                                rows={10}
                                                                                                                                sx= {{ mt:1}}
                                                                                                                                fullWidth
                                                                                                                                //disabled={currentUserSubscription === "Silver Subscription"}
                                                                                                                            />
                                                                                                                            {currentUserSubscription === "Silver Subscription" && (
                                                                                                                                <SoftBox px={4} py={2} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                                                                                                                                <SoftBadge
                                                                                                                                    variant="contained"
                                                                                                                                    color="error"
                                                                                                                                    size="md"
                                                                                                                                    badgeContent={
                                                                                                                                        <SoftTypography variant="button">
                                                                                                                                            🔔&nbsp;&nbsp;Editing this summary is available for Platinum and Gold Package subscribers only.
                                                                                                                                        </SoftTypography>
                                                                                                                                    }
                                                                                                                                    container
                                                                                                                                />
                                                                                                                                </SoftBox>
                                                                                                                            )}
                                                                                                                            {editingPromptName === prompt.id && (
                                                                                                                                <SoftBox display="flex" justifyContent="space-between" alignItems="center" width="100%" pt={2} pb={2}>
                                                                                                                                    {saveSuccessTemplate && (
                                                                                                                                        <SoftBadge variant="contained" color="success" size="sm" sx={{ ml: 1 }} badgeContent={<SoftTypography fontWeight="medium" variant="button">Changes saved successfully!</SoftTypography>} container />
                                                                                                                                    )}
                                                                                                                                    {currentUserSubscription !== "Silver Subscription" ? (
                                                                                                                                        <>
                                                                                                                                            <SoftButton color="dark" size="small" onClick={() => handleSaveEditedPrompts(prompt.id)}>Save</SoftButton>
                                                                                                                                        </>
                                                                                                                                    ) : (
                                                                                                                                        null
                                                                                                                                    )}
                                                                                                                                </SoftBox>
                                                                                                                            )}
                                                                                                                        </SoftBox>
                                                                                                                    )}
                                                                                                                </SoftBox>
                                                                                                            </Card>
                                                                                                            </SoftBox>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </Draggable>
                                                                                            ))}
                                                                                            {provided.placeholder}
                                                                                        </div>
                                                                                    )}
                                                                                </Droppable>
                                                                                </DragDropContext>
                                                                                    
                                                                            </SoftBox>
                                                                            {/*<SeparatorEditTemplate />*/}
                                                                            </SoftBox>
                                                                            {addNewSummaryTemplate && (
                                                                                <SoftBox ref={addNewSummaryRef} p={4} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                                                                                    <SoftBox pt={3} pb={0} display="flex" alignItems="center">
                                                                                        {/*<SeperatorNewSummaryTemplate />*/}
                                                                                        <SoftTypography variant="h6" >
                                                                                            Adding a new summary to the template: 
                                                                                        </SoftTypography>
                                                                                        <SoftBadge
                                                                                            variant="contained"
                                                                                            color="warning"
                                                                                            size="xs"
                                                                                            badgeContent={
                                                                                                <SoftTypography color="dark" variant="button">
                                                                                                    {currentTemplateId}
                                                                                                </SoftTypography>
                                                                                            }
                                                                                        />

                                                                                    </SoftBox>

                                                                                    <SoftBox width="100%" > 
                                                                                        <SoftBox pt={2} display="flex" justifyContent="flex-end">
                                                                                            <Tooltip title="Closes this form, changes will be temporary saved during this session" placement="left" >
                                                                                            <IconButton onClick={handleCloseAddNewSummary}>
                                                                                                <CloseIcon />
                                                                                            </IconButton>
                                                                                            </Tooltip>
                                                                                        </SoftBox>
                                                                                        <SoftBox mb={2} display="flex" flexDirection="column" alignItems="flex-start" >
                                                                                            <SoftBox display="flex" alignItems="center">

                                                                                                <SoftTypography component="label" variant="button" fontWeight="medium" mb={0.8} ml={1}>
                                                                                                    Summary Note Name
                                                                                                </SoftTypography>
                                                                                                <Tooltip title="Enter a unique name for the summary note. This will be used to identify it in the templates." placement="right">
                                                                                                    <IconButton sx={{mb:1, ml:0.5}} size="small">
                                                                                                        <InfoOutlinedIcon fontSize="inherit" color="dark" />
                                                                                                    </IconButton>
                                                                                                </Tooltip>
                                                                                            </SoftBox>

                                                                                            <SoftInput
                                                                                                placeholder="Enter New Summary Name"
                                                                                                value={newAddSummaryTemplate.name}
                                                                                                onChange={(e) => setNewAddSummaryTemplate({ ...newAddSummaryTemplate, name: e.target.value })}
                                                                                                fullWidth
                                                                                            />
                                                                                        </SoftBox>

                                                                                        <SoftBox mb={2} display="flex" flexDirection="column" alignItems="flex-start">
                                                                                            <SoftBox display="flex" alignItems="center">
                                                                                                <SoftTypography component="label" variant="button" fontWeight="medium" mb={0.8} ml={1} >
                                                                                                    Summary Content
                                                                                                </SoftTypography>
                                                                                                <Tooltip title="Enter a unique name for the summary note. This will be used to identify it in the templates." placement="right">
                                                                                                    <IconButton sx={{mb:1, ml:0.5}} size="small">
                                                                                                        <InfoOutlinedIcon fontSize="inherit" color="dark" />
                                                                                                    </IconButton>
                                                                                                </Tooltip>
                                                                                            </SoftBox>
                                                                                            <SoftInput
                                                                                                placeholder="Enter Summary Content"
                                                                                                value={newAddSummaryTemplate.content}
                                                                                                onChange={(e) => setNewAddSummaryTemplate({ ...newAddSummaryTemplate, content: e.target.value })}
                                                                                                multiline
                                                                                                rows={4}
                                                                                                fullWidth
                                                                                            />
                                                                                        </SoftBox>

                                                                                        <SoftBox pt={1} display="flex" justifyContent="flex-end">
                                                                                        <Tooltip 
                                                                                            title={currentUserSubscription === "Silver Subscription" ? "This feature is available for Platinum and Gold Package subscribers only." : "Add summary to the template"} 
                                                                                            placement="top" 
                                                                                        >
                                                                                            <span> 
                                                                                                <SoftButton 
                                                                                                    startIcon={<CheckCircleOutlineOutlinedIcon />} 
                                                                                                    color="dark" 
                                                                                                    size="medium" 
                                                                                                    onClick={handleSaveNewSummaryToTemplate} 
                                                                                                    disabled={currentUserSubscription === "Silver Subscription"}
                                                                                                > 
                                                                                                    Save Summary
                                                                                                </SoftButton>
                                                                                            </span>
                                                                                        </Tooltip>
                                                                                        </SoftBox>
                                                                                    </SoftBox>
                                                                                    <SoftBox pt={4} display="flex" justifyContent="space-between">
                                                                                        <Tooltip title="Add a summary from the library" placement="top">
                                                                                            <SoftButton color="dark" startIcon={showLibrarySummaries ? < CloseOutlinedIcon /> : < LibraryAddOutlinedIcon /> } variant="outlined" size="medium" onClick={handleToggleLibrarySummaries}>
                                                                                                {showLibrarySummaries ? "Hide Library Summaries" : "Add a summary from the summaries Library"}
                                                                                            </SoftButton>
                                                                                        </Tooltip>
                                                                                    </SoftBox>
                                                                                    {showLibrarySummaries && renderInlineLibrarySummaries()}
                                                                                </SoftBox>
                                                                            )}
                                                                            <SoftBox display="flex" justifyContent="flex-start" >
                                                                                <SoftTypography pb={1} ml={1} pt={1} variant="body2" fontWeight="medium" sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={toggleHelpSecond} >
                                                                                    I need help writing the content
                                                                                </SoftTypography>
                                                                            </SoftBox>
                                                                            { showHelpSecond && (
                                                                                <>
                                                                                <SoftBox px={2} py={5} > 
                                                                                    < CustomTooltip toggleHelp={toggleHelpSecond} />
                                                                                </SoftBox>
                                                                                </>

                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </SoftBox>
                                                        </Card>
                                                    </SoftBox>
                                                )}

                                                
                                                {!addingNewTemplate ? (
                                                    <SoftBox pt={6} display="flex" justifyContent="center" >
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Tooltip 
                                                                title={currentUserSubscription === "Silver Subscription" ? "This feature is not included in your subscription. Upgrade to the Gold or Platinum plan to access this feature" : "Create Your Personal Template"}
                                                                placement="top"
                                                                //disableHoverListener={currentUserSubscription !== "Small Plan"} 
                                                            >
                                                            <div>
                                                                <PlaceholderCard
                                                                    title={{ variant: "h5", text: "Add New Template" }}
                                                                    onClick={currentUserSubscription !== "Silver Subscription" ? openFormAddingTemplate : null}
                                                                    //outlined= "true"
                                                                    //hasBorder= "true"
                                                                    //disabled={ currentUserSubscription === "Small Plan" ? true : false}
                                                                />
                                                            </div>
                                                            </Tooltip>
                                                        </Grid>
                                                    </SoftBox>
                                                ) : (
                                                    <SoftBox mt={6} mb={2} sx={{ textAlign: 'left' }} ref={templateAddref}  >
                                                    <Grid container spacing={3} justifyContent="center">
                                                        <Grid item xs={12} lg={11}>
                                                            <Card sx={{ overflow: "visible", boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
                                                            <SoftBox p={2} lineHeight={1}>
                                                                <SoftBox display="flex" justifyContent="space-between" alignItems="center" >
                                                                    <SoftBox>
                                                                        <SoftTypography variant="h6" fontWeight="medium">
                                                                        New Template
                                                                        </SoftTypography>
                                                                        <SoftTypography variant="button" fontWeight="regular" color="text">
                                                                        Create a new Template
                                                                        </SoftTypography>
                                                                    </SoftBox>
                                                                    <Tooltip title="Close this form, changes will be temporary saved during this session" >
                                                                    <IconButton onClick={closeFormAddingTemplate}>
                                                                        <CloseIcon />
                                                                    </IconButton>
                                                                    </Tooltip>
                                                                </SoftBox>

                                                                <SoftBox py={2} >
                                                                    <SeperatorTemplateInfo />
                                                                </SoftBox>
                                                                <SoftBox
                                                                    display="flex"
                                                                    flexDirection="column"
                                                                    justifyContent="flex-end"
                                                                    height="100%"
                                                                >
                                                                    <SoftBox display="flex" alignItems="center" mb={1} ml={0.5}>
                                                                        <SoftBox lineHeight={0.5} display="inline-block">
                                                                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                                            Template Name
                                                                            </SoftTypography>
                                                                        </SoftBox>
                                                                        <Tooltip title="Enter a unique name for the summary note. This will be used to identify it in the templates." placement="right">
                                                                            <IconButton size="small" > 
                                                                            <InfoOutlinedIcon color="dark" fontSize="inherit" /> 
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </SoftBox>
                                                                    <SoftInput placeholder="Psychotherapy Progress Note" value={newTemplateName} onChange={(e) => setNewTemplateName(e.target.value)} />
                                                                </SoftBox>
                                                                <SoftBox
                                                                    display="flex"
                                                                    flexDirection="column"
                                                                    justifyContent="flex-end"
                                                                    height="100%"
                                                                >
                                                                    <SoftBox display="flex" alignItems="center" mb={1} ml={0.5} mt={3}>
                                                                        <SoftBox lineHeight={0.5} display="inline-block">
                                                                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                                            Template Description
                                                                            </SoftTypography>
                                                                        </SoftBox>
                                                                        <Tooltip title="Enter a unique name for the summary note. This will be used to identify it in the templates." placement="right">
                                                                            <IconButton size="small" > 
                                                                            <InfoOutlinedIcon color="dark" fontSize="inherit" /> 
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </SoftBox>
                                                                {/*<SoftBox mb={1.5} ml={0.5} mt={0.5} lineHeight={0} display="inline-block">
                                                                    <SoftTypography
                                                                    component="label"
                                                                    variant="caption"
                                                                    fontWeight="regular"
                                                                    color="text"
                                                                    >
                                                                    Display link to prompt engineering
                                                                    </SoftTypography>
                                                                </SoftBox>*/}
                                                                    <SoftInput placeholder="A structured note format used for documenting a patient's progress, including subjective information, ..."  value={newTemplateDescription} onChange={(e) => setNewTemplateDescription(e.target.value)} />
                                                                </SoftBox>
                                                                <SoftBox pt={6} pb={2} >
                                                                    <SeperatorTemplateAdding />
                                                                </SoftBox> 
                                                                <SoftBox display="flex" alignItems="center" mb={1} ml={0.5}>
                                                                    <SoftBox lineHeight={0.5} display="inline-block">
                                                                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                                        Summary Note Name
                                                                        </SoftTypography>
                                                                    </SoftBox>
                                                                    <Tooltip title="Enter a unique name for the summary note. This will be used to identify it in the templates." placement="right">
                                                                        <IconButton size="small" > 
                                                                        <InfoOutlinedIcon color="dark" fontSize="inherit" /> 
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </SoftBox>
                                                                <SoftInput placeholder="Enter Summary Name" value={newTemplateSummary.name} onChange={(e) => setNewTemplateSummary({ ...newTemplateSummary, name: e.target.value})} />
                                                                
                                                                <SoftBox display="flex" alignItems="center" mb={1} ml={0.5} mt={3}>
                                                                    <SoftBox lineHeight={0.5} display="inline-block">
                                                                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                                        Summary Content
                                                                        </SoftTypography>
                                                                    </SoftBox>
                                                                    <Tooltip title="Enter a unique name for the summary note. This will be used to identify it in the templates." placement="right">
                                                                        <IconButton size="small" > 
                                                                            <InfoOutlinedIcon color="dark" fontSize="inherit" /> 
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </SoftBox>
                                                                <SoftInput 
                                                                    placeholder="Enter Summary Content" 
                                                                    value={newTemplateSummary.content} 
                                                                    onChange={(e) => setNewTemplateSummary({ ...newTemplateSummary, content: e.target.value })} 
                                                                    multiline
                                                                    rows={4}
                                                                />
                                                                <SoftBox display="flex" justifyContent="space-between" mt={3} pr={0}>
                                                                    <SoftTypography ml={1} variant="body2" fontWeight="medium" sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={toggleHelp} >
                                                                        I need help writing the content
                                                                    </SoftTypography>
                                                                    <Tooltip title="Add this summary to this template" placement="top">
                                                                    <SoftButton color="dark" startIcon={ <AddOutlinedIcon /> } size="small" onClick={handleAddSummary} mt={2}>
                                                                        Add Summary
                                                                    </SoftButton>
                                                                    </Tooltip>
                                                                </SoftBox>

                                                                { showHelp && (
                                                                    <>
                                                                    <SoftBox px={2} py={5} > 
                                                                        < CustomTooltip toggleHelp={toggleHelp} />
                                                                    </SoftBox>
                                                                    </>

                                                                )}
                                                                <SoftBox pt={4} pb={ showLibrarySummariesNewTemplate ? 0 : 4} display="flex" justifyContent="center">
                                                                    <Tooltip title="Add a summary from the library" placement="top">
                                                                        <SoftButton color="dark" variant="outlined" size="medium" startIcon={showLibrarySummariesNewTemplate ? < CloseOutlinedIcon /> : < LibraryAddOutlinedIcon /> } onClick={handleToggleLibrarySummariesNewTemplate}>
                                                                            {showLibrarySummariesNewTemplate ? "Hide Library Summaries" : "Add a summary from the summaries Library"}
                                                                        </SoftButton>
                                                                    </Tooltip>
                                                                </SoftBox>
                                                                {showLibrarySummariesNewTemplate && renderInlineLibrarySummariesNewTemplate()}

                                                                <SoftBox pt={2} pb={2} >
                                                                    <SeperatorTemplatePrompts />
                                                                </SoftBox> 

                                                                {newTemplateSummaries.length > 0 ? (
                                                                    <SoftBox display="flex" justifyContent="center" width="100%" mt={4}>
                                                                        <SoftBox width="90%" >
                                                                            {newTemplateSummaries.map((summary, index) => (
                                                                            <Card key={index} bgColor="#e9ecef" sx={{ mb: 2, overflow: "visible", boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', backgroundColor:"#e9ecef"}}>
                                                                                <SoftBox p={2} lineHeight={1}>
                                                                                    <SoftBox pl={1} >
                                                                                        <SoftTypography variant="h6" fontWeight="medium">{summary.name}</SoftTypography>
                                                                                    </SoftBox>
                                                                                
                                                                                <SoftBox pt={2} pb={2}>
                                                                                    <SoftInput
                                                                                        multiline
                                                                                        rows={4}
                                                                                        value={summary.content}
                                                                                        onChange={(e) => handleEditSummaryContentTemplate(index, e.target.value)}
                                                                                        fullWidth
                                                                                    />
                                                                                </SoftBox>

                                                                                <SoftBox mt={1} display="flex" justifyContent="flex-end">
                                                                                    <Tooltip title="Remove this summary from this template" placement="right" >
                                                                                    <SoftButton variant="outlined" color="error" size="small" onClick={() => handleDeleteSummaryTemplate(index)}>
                                                                                        Remove
                                                                                    </SoftButton>
                                                                                    </Tooltip>
                                                                                </SoftBox>
                                                                                </SoftBox>
                                                                            </Card>
                                                                            ))}
                                                                        </SoftBox>
                                                                    </SoftBox>
                                                                ) : (
                                                                    <SoftBox pt={2} display="flex" justifyContent="center" alignItems="center" >
                                                                        <SoftBadge
                                                                            variant="contained"
                                                                            color="error"
                                                                            size="xs"
                                                                            badgeContent={
                                                                                <SoftTypography color="dark" variant="button">
                                                                                    Create and add a summary to include this in the new template 
                                                                                </SoftTypography>
                                                                            }
                                                                        />
                                                                    </SoftBox>
                                                                )}
                                                                
                                                                <SoftBox display="flex" justifyContent="flex-end" mt={5}>
                                                                <SoftBox mr={1}>
                                                                    <Tooltip title="Close this form, changes will be temporary saved during this session" >
                                                                    <SoftButton onClick={closeFormAddingTemplate} color="light" size="small">cancel</SoftButton>
                                                                    </Tooltip>
                                                                </SoftBox>
                                                                    <Tooltip title={newTemplateSummaries.length < 1 ? "No summaries included yet" : "Create template"} placement="top" > 
                                                                        <span>
                                                                            <SoftButton 
                                                                                onClick={handleCreateTemplate} 
                                                                                color="dark" 
                                                                                size="small" 
                                                                                disabled={newTemplateSummaries.length < 1}
                                                                            >
                                                                                create Template
                                                                            </SoftButton>
                                                                        </span>
                                                                    </Tooltip>
                                                                </SoftBox>
                                                            </SoftBox>
                                                            </Card>
                                                        </Grid>
                                                    </Grid>
                                                    </SoftBox>
                                                )}
                                                <Menu
                                                    anchorEl={anchorEl}
                                                    open={Boolean(anchorEl)}
                                                    onClose={handleCloseMenu}
                                                >
                                                    <MenuItem onClick={handleEditClick}>
                                                        <ListItemIcon>
                                                            <EditOutlinedIcon fontSize="small" sx={{ color: '#344767' }} />
                                                        </ListItemIcon>
                                                        <ListItemText>
                                                            <SoftTypography color="dark" variant="button" fontWeight="medium">
                                                            Edit Template
                                                            </SoftTypography>
                                                        </ListItemText>
                                                    </MenuItem>
                                                    <MenuItem onClick={handleOpenCopyTemplateDialog}>
                                                        <ListItemIcon>
                                                            <FileCopyOutlinedIcon fontSize="small" sx={{ color: '#344767' }} />
                                                        </ListItemIcon>
                                                        <ListItemText>
                                                            <SoftTypography color="dark" variant="button" fontWeight="medium">
                                                                Copy Template
                                                            </SoftTypography>
                                                        </ListItemText>
                                                    </MenuItem>
                                                    <MenuItem onClick={handleDeleteClick} > 
                                                        <ListItemIcon>
                                                            <DeleteOutlinedIcon fontSize="small" sx={{ color: "red" }} />
                                                        </ListItemIcon>
                                                        <ListItemText>
                                                            <SoftTypography color="error" variant="button" fontWeight="medium">
                                                            Delete
                                                            </SoftTypography>
                                                        </ListItemText>
                                                    </MenuItem>
                                                </Menu>
                                            </SoftBox>
                                        )}
                                        {currentTab === 1 && (
                                            <SoftBox  >
                                                < Grid item xs={12} lg={12}>
                                                    < PromptSettings promptsData={promptsData} onUpdatePromptsData={updatePromptsData} refetchData={fetchAndUpdatePromptsData} subscription={currentUserSubscription} />
                                                </Grid>
                                                < Grid item xs={12} lg={12} textAlign={'right'} >
                                                    <SoftBox pt={3} display="flex" justifyContent="center">
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <PlaceholderCard
                                                                title={{ variant: "h5", text: "Import Summary From Library" }}
                                                                icon="library_add"
                                                                onClick={openSummaryLibrary}
                                                            />
                                                        </Grid>
                                                    </SoftBox>
                                                </Grid>
                                                < Grid item xs={12} lg={12} textAlign={'right'} mb={0} mt={0} >
                                                    {isAddPromptOpen ? (
                                                        <SoftBox mt={3} mb={4} sx={{ textAlign: 'left' }} ref={summaryAddRef} >
                                                        <Grid container spacing={3} justifyContent="center">
                                                            <Grid item xs={12} lg={11}>
                                                                <Card sx={{ overflow: "visible", boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}>
                                                                <SoftBox p={2} lineHeight={1}>
                                                                    <SoftTypography variant="h6" fontWeight="medium">
                                                                    New Summary
                                                                    </SoftTypography>
                                                                    <SoftTypography variant="button" fontWeight="regular" color="text">
                                                                    Create a new summarization prompt
                                                                    </SoftTypography>
                                                                    <Divider />
                                                                    <SoftBox
                                                                    display="flex"
                                                                    flexDirection="column"
                                                                    justifyContent="flex-end"
                                                                    height="100%"
                                                                    >
                                                                    <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                                        Summary Name
                                                                        </SoftTypography>
                                                                    </SoftBox>
                                                                    <SoftInput placeholder="Assesement and Plan" value={newPromptName} onChange={(e) => setNewPromptName(e.target.value)} />
                                                                    </SoftBox>
                                                                    <SoftBox
                                                                    display="flex"
                                                                    flexDirection="column"
                                                                    justifyContent="flex-end"
                                                                    height="100%"
                                                                    >
                                                                    <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                                                                        <SoftTypography component="label" variant="caption" fontWeight="bold">
                                                                        Prompt Text
                                                                        </SoftTypography>
                                                                    </SoftBox>
                                                                    {/*<SoftBox mb={1.5} ml={0.5} mt={0.5} lineHeight={0} display="inline-block">
                                                                        <SoftTypography
                                                                        component="label"
                                                                        variant="caption"
                                                                        fontWeight="regular"
                                                                        color="text"
                                                                        >
                                                                        Display link to prompt engineering
                                                                        </SoftTypography>
                                                    </SoftBox>*/}
                                                                    <SoftInput 
                                                                        placeholder='Take the role of a Provider. Speak in the first person and use the transcript in order to write the assessment and plan section of a medical note. Each problem should start with "# " (not a numeral) and each action item should be on a separate line. Each problem should mention each medication being taken for that problem, as well as the dose of the medication if that is clear. Do not make anything up. Do not use the patients name.'
                                                                        value={newPromptText} 
                                                                        onChange={(e) => setNewPromptText(e.target.value)} 
                                                                        multiline
                                                                        rows={5}
                                                                    />
                                                                    </SoftBox>                                                   
                                                                    <SoftBox display="flex" justifyContent="space-between" mt={3}>
                                                                    
                                                                    <SoftTypography pb={1} ml={1} pt={1} variant="body2" fontWeight="medium" sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={toggleHelpThird} >
                                                                        I need help writing the content
                                                                    </SoftTypography>
                                                                    {saveSuccess && <SoftTypography fontWeight="regular" variant="body2" color="text" sx={{ ml: 1 }}>Prompt has been added successfully!</SoftTypography>}
                                                                    <SoftBox mr={1}>
                                                                        <Tooltip title="Closes this modal, your changes will be temporary saved during this session" placement="top" >
                                                                        <SoftButton sx={{ mr:1}} onClick={handleAddPromptClose} color="light" size="small">cancel</SoftButton>
                                                                        </Tooltip>
                                                                        <Tooltip 
                                                                            title={currentUserSubscription === "Silver Subscription" ? "🔔 This feature is available for Platinum and Gold Package subscribers only." : "Create a new prompt"} 
                                                                            placement="top"
                                                                        >
                                                                            <span> {/* Wrapping in span for disabled button tooltip */}
                                                                                <SoftButton 
                                                                                    onClick={handleCreatePrompt} 
                                                                                    color="dark" 
                                                                                    size="small"
                                                                                    disabled={currentUserSubscription === "Silver Subscription"}
                                                                                >
                                                                                    Create
                                                                                </SoftButton>
                                                                            </span>
                                                                        </Tooltip>

                                                                    </SoftBox>
                                                                    
                                                                    </SoftBox>
                                                                    { showHelpThird && (
                                                                        <>
                                                                        <SoftBox px={2} py={5} > 
                                                                            < CustomTooltip toggleHelp={toggleHelpThird} />
                                                                        </SoftBox>
                                                                        </>

                                                                    )}
                                                                </SoftBox>
                                                                </Card>
                                                            </Grid>
                                                        </Grid>
                                                        </SoftBox>
                                                    ) : (
                                                        <SoftBox pb={1} display="flex" justifyContent="center">
                                                                <Grid item xs={12} sm={6} md={4}>
                                                                    <Tooltip title="Create Your Own Summarization" placement="right" >
                                                                        <div>
                                                                        <PlaceholderCard
                                                                            title={{ variant: "h5", text: "Add New Summary" }}
                                                                            onClick={handleAddPromptOpen}
                                                                        />
                                                                        </div>
                                                                    </Tooltip>
                                                                </Grid>
                                                        </SoftBox>
                                                    )}
                                                </Grid>

                                            </SoftBox>
                                        )}
                                        {currentTab === 2 && (
                                            <SoftBox p={2} pt={4}>
                                                <SoftBox display="flex" flexDirection="column" alignItems="left" px={1} pt={1} pb={4}>
                                                    <SoftBadge
                                                        variant="contained"
                                                        color="warning"
                                                        size="md"
                                                        sx = {{ mb: 2, ml: -2}}
                                                        badgeContent={
                                                            <SoftTypography  variant="h6" fontWeight="medium">
                                                                Selecting and Viewing Email Templates
                                                            </SoftTypography>
                                                        }
                                                    />
                                                    <SoftTypography variant="body2" mt={1}>
                                                        <strong>Instructions:</strong> Choose one of the available email templates below for communicating with patients. These templates are designed to facilitate your communication towards patients after the consultation by providing structured and customizable email formats. To view and adjust the content of a template, click on the three dots icon on the right side of the template card. This will allow you to review the template&apos;s details and make any necessary modifications to suit your specific needs.
                                                    </SoftTypography>
                                                    <SoftTypography variant="body2" mt={2}>
                                                        <strong>Note:</strong> Remember, the template you choose will serve as a foundation for your message, which you can personalize further after the session to ensure clear and personalized communication towards your patient.
                                                    </SoftTypography>
                                                </SoftBox>


                                                <SoftBox pb={5} pt={2} >
                                                    <SeperatorPatientInstructions />
                                                </SoftBox>

                                                <Grid mb={5} container spacing={2}>
                                                {Object.values(patientInstructions).map((instruction, index) => (
                                                    <Grid item xs={12} sm={12} md={4} key={index}>
                                                        <ComplexProjectCard
                                                                color="info" // You can dynamically set color if needed
                                                                iconName="email"
                                                                title={instruction.id}
                                                                //description={template.description}
                                                                onIconClick={(event) => handleOpenMenuInstructions(event, instruction.id)}
                                                                onCardClick={() => handleInstructionSelect(instruction.id)}
                                                                isSelected={selectedInstructions.includes(instruction.id)}
                                                        />
                                                    </Grid>
                                                ))}
                                                </Grid>
                                                {Object.keys(editModeInstruction).map((instructionId) => {
                                                    if (!editModeInstruction[instructionId]) return null; // Skip if not in edit mode

                                                    const instruction = patientInstructions[instructionId];
                                                    return (
                                                        <SoftBox key={`edit-${instructionId}`} p={2}>
                                                        <SoftBox display="flex" alignItems="center" justifyContent="space-between" >
                                                            <SoftBadge
                                                                variant="contained"
                                                                color="secondary"
                                                                size="md"
                                                                sx = {{ mb: 1, ml: -0.5}}
                                                                badgeContent={
                                                                    <SoftTypography variant="h6">Editing: {instruction.id}</SoftTypography>
                                                                }
                                                            />
                                                            <SoftBox mb={0.5} >
                                                                <SoftButton sx={{ mr: 1}} color="dark" size="small" variant="contained" onClick={() => handleSaveInstructionEdit(instruction.id)} > 
                                                                    Save
                                                                </SoftButton>
                                                                <Tooltip title="Closes the editing mode for this template, unsaved changes will be lost" placement="top">
                                                                <SoftButton  color="dark" size="small" variant="outlined" onClick={() => handleCloseEditMode(instruction.id)} > 
                                                                    <CloseIcon />
                                                                </SoftButton>
                                                                </Tooltip>
                                                            </SoftBox>
                                                        </SoftBox>
                                                        <SoftInput
                                                            fullWidth
                                                            multiline
                                                            rows={10}
                                                            variant="outlined"
                                                            value={editedInstructionText[instructionId]}
                                                            onChange={(e) => setEditedInstructionText({
                                                            ...editedInstructionText,
                                                            [instructionId]: e.target.value,
                                                            })}
                                                            
                                                        />
                                                        {saveSuccessInstruction[instructionId] && (
                                                            <SoftBox p={4} display="flex" alignItems="center" justifyContent="center">
                                                                <SoftBadge 
                                                                    variant="contained"
                                                                    color="success"
                                                                    size="md"
                                                                    sx = {{ mb: 1}}
                                                                    badgeContent={
                                                                        <SoftTypography  variant="button">{instruction.id} saved successfully!</SoftTypography>
                                                                    }
                                                                />
                                                            </SoftBox>
                                                        )}
                                                        </SoftBox>
                                                    );
                                                })}
                                                <SoftBox display="flex" flexDirection="column" alignItems="left" px={1} pt={8} pb={3}>
                                                    <SoftBadge
                                                        variant="contained"
                                                        color="warning"
                                                        size="md"
                                                        sx = {{ mb: 2, ml: -2}}
                                                        badgeContent={
                                                            <SoftTypography  variant="h6" fontWeight="medium">
                                                                Personalize Your Email Settings
                                                            </SoftTypography>
                                                        }
                                                    />
                                                    <SoftTypography variant="body2" mt={1}>
                                                        Ensure your communications reflect your professional identity by customizing the sender name and email address for outgoing emails to patients. These settings will be applied to all emails sent from the system, enhancing recognition and trust among your recipients.
                                                    </SoftTypography>
                                                    <SoftTypography variant="body2" mt={2}>
                                                        <strong>Note:</strong> These values act as defaults. You can still customize the sender&apos;s name and email for each patient.
                                                    </SoftTypography>
                                                </SoftBox>
                                                <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" mt={2}>
                                                    <SoftBox flex={1.5} pr={1}>
                                                        <Tooltip title="This is the sender's name of the email the patient will receive" placement="top" >
                                                            <SoftTypography variant="button" fontWeight="bold" ml={0.7} mb={1}>Sender Name:</SoftTypography>
                                                        </Tooltip>
                                                        <SoftInput
                                                        placeholder="Your Name"
                                                        fullWidth
                                                        success={saveSuccessSender}
                                                        value={senderName}
                                                        onChange={handleSenderNameChange}
                                                        />
                                                    </SoftBox>
                                                    <SoftBox flex={2} pl={1}>
                                                        <SoftTypography variant="button" fontWeight="bold" ml={0.7} mb={1}>Sender Email:</SoftTypography>
                                                        <SoftInput
                                                        placeholder="your_email@example.com"
                                                        fullWidth
                                                        success={saveSuccessSender}
                                                        value={senderEmail}
                                                        onChange={handleSenderEmailChange}
                                                        />
                                                    </SoftBox>
                                                    {/*<SoftBox flex={2} pl={1}>
                                                        <SoftTypography variant="button" fontWeight="bold" ml={0.7} mb={1}>Review Link:</SoftTypography>
                                                        <SoftInput
                                                        placeholder="your_email@example.com"
                                                        fullWidth
                                                        success={saveSuccessSender}
                                                        value={senderEmail}
                                                        onChange={handleSenderEmailChange}
                                                        />
                                                    </SoftBox>*/}
                                                </SoftBox>
                                                <SoftBox display="flex" bgColor="light" flexDirection="column" alignItems="stretch" mt={4} sx={{ padding: 2, borderRadius: "10px" }}>
                                                    <SoftBox display="flex" justifyContent="flex-start" alignItems="center">
                                                        <Switch checked={toggleReviewLink} onChange={handleToggleChange} />
                                                        <SoftBox ml={2}>
                                                            <SoftTypography variant="button" color="text">
                                                                Include a review link in your email
                                                            </SoftTypography>
                                                        </SoftBox>
                                                        <SoftBox ml={2} width={{ xl: '55%', xxl: '65%' }}>
                                                            <SoftInput
                                                                placeholder="https://www.your-review-link.com"
                                                                fullWidth
                                                                success={saveSuccessSender}
                                                                value={reviewLink}
                                                                onChange={handleReviewLinkChange}
                                                            />
                                                        </SoftBox>
                                                    </SoftBox>
                                                </SoftBox>
                                                <SoftBox pt={5} display="flex" alignItems="center" justifyContent="flex-end" >
                                                    <Tooltip title="Updates/saves the current sender's name and email values." placement="top" >
                                                        <SoftButton color="dark" variant="contained" size="medium" onClick={saveSenderDetails} >
                                                            Save Sender Details
                                                        </SoftButton>
                                                    </Tooltip>

                                                </SoftBox>
                                               
                                                <Menu
                                                    anchorEl={anchorElInstructions}
                                                    open={Boolean(anchorElInstructions)}
                                                    onClose={handleCloseMenuInstructions}
                                                >
                                                    <MenuItem onClick={handleEditClickInstruction}>
                                                        <ListItemIcon>
                                                            <EditOutlinedIcon fontSize="small" sx={{ color: '#344767' }} />
                                                        </ListItemIcon>
                                                        <ListItemText>
                                                            <SoftTypography color="dark" variant="button" fontWeight="medium">
                                                            Edit email instruction
                                                            </SoftTypography>
                                                        </ListItemText>
                                                    </MenuItem>
                                                    <MenuItem onClick={handleDeleteClick} disabled> 
                                                        <ListItemIcon>
                                                            <DeleteOutlinedIcon fontSize="small" sx={{ color: "red" }} />
                                                        </ListItemIcon>
                                                        <ListItemText>
                                                            <SoftTypography color="error" variant="button" fontWeight="medium">
                                                            Delete
                                                            </SoftTypography>
                                                        </ListItemText>
                                                    </MenuItem>
                                                </Menu>
                                            </SoftBox>
                                        )}

                                        {/*{currentTab === 3 && (
                                            <SoftBox sx={{ Height: '250px', padding: "30px", px: "80px"}}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12} sm={4} lg={3}>
                                                    <ControllerCard
                                                        color={"secondary"}
                                                        state={sentimentAnalysis}
                                                        icon={sentimentAnalysis ? customIcons.highlightIconLight : customIcons.highlightIconDark}
                                                        title="Sentiment Analysis"
                                                        onChange={toggleSentimentAnalysis}
                                                        tooltipText="Analyzes the tone and sentiment of speech in audio, categorizing each sentence as positive, negative, or neutral."
                                                    />
                                                
                                                </Grid>
                                                <Grid item xs={12} sm={4} lg={3}>
                                                    <ControllerCard
                                                        color={"secondary"}
                                                        state={entityDetection}
                                                        icon={entityDetection ? customIcons.entityDetectionIconLight : customIcons.entityDetectionIconDark}
                                                        title='Entity Detection'
                                                        onChange={toggleEntityDetection}
                                                        tooltipText="Extracts and identifies named entities like people, places, and medications from audio content."
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={4} lg={3}>
                                                    <ControllerCard
                                                        color={"secondary"}
                                                        state={keyPhrases}
                                                        icon={keyPhrases ? customIcons.keyPhrasesIconLight : customIcons.keyPhrasesIconDark}
                                                        title='Key Phrases'
                                                        onChange={toggleKeyPhrases}
                                                        tooltipText="Identifies and labels key phrases spoken in the audio, highlighting important points or themes."
                                                    />
                                                </Grid>
                                                
                                                <Grid item xs={12} sm={4} lg={3}>
                                                    <ControllerCard
                                                        color={"secondary"}
                                                        state={topicDetection}
                                                        icon={topicDetection ? customIcons.topicDetectionIconLight : customIcons.topicDetectionIconDark}
                                                        title='Topic Detection'
                                                        onChange={toggleTopicDetection}
                                                        tooltipText="Recognizes and labels topics discussed in the audio, providing insights into the subject matter."
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={4} lg={3}>
                                                    <ControllerCard
                                                        color={"secondary"}
                                                        state={speakerDiarization}
                                                        icon={speakerDiarization ? customIcons.speakerDiarizationIconLight : customIcons.speakerDiarizationIconDark}
                                                        title='Speaker Diarization'
                                                        onChange={toggleSpeakerDiarization}
                                                        tooltipText="Automatically detect the number of speakers and associate each word with who said it."
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={4} lg={3}>
                                                    <ControllerCard
                                                        color={"secondary"}
                                                        state={contentModeration}
                                                        icon={contentModeration ? customIcons.contentModerationIconLight : customIcons.contentModerationIconDark}
                                                        title='Content Moderation'
                                                        onChange={toggleContentModeration}
                                                        tooltipText="Identifies and flags sensitive or inappropriate content in audio files."
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={4} lg={3}>
                                                    <ControllerCard
                                                        color={"secondary"}
                                                        state={textFormatting}
                                                        icon={textFormatting ? customIcons.textFormattingIconLight : customIcons.textFormattingIconDark}
                                                        title='Text Formatting'
                                                        onChange={toggleTextFormatting}
                                                        tooltipText=""
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={4} lg={3}>
                                                    <ControllerCard
                                                        color={"secondary"}
                                                        state={punctuation}
                                                        icon={punctuation ? customIcons.punctuationIconLight : customIcons.punctuationIconDark}
                                                        title='Punctuation'
                                                        onChange={togglePunctuation}
                                                        tooltipText=""
                                                    />
                                                </Grid>
                                            </Grid>
                                            </SoftBox>
                                        )}*/}
                                    </SoftBox>
                                </Card>
                            </Grid>
                        </Grid>
                    </SoftBox>
                    {
                        isLoading && (
                            <SoftBox>
                                <Grid container spacing={3} justifyContent="center">
                                    <Grid item xs={12} lg={11} ref={loaderRef} >
                                        <LoadingSpinner 
                                            loading={isLoading} 
                                            patientName={patientName}
                                            selectedPatient={selectedPatient}
                                        />
                                    </Grid>
                                </Grid>
                            </SoftBox>
                        )
                    }
                    {
                        isLoadingNewTranscript && (
                            <SoftBox>
                                <Grid container spacing={3} justifyContent="center">
                                    <Grid item xs={12} lg={11} ref={loaderRefNewTranscript} >
                                        <LoadingSpinnerNewTranscript 
                                            loading={isLoadingNewTranscript} 
                                            patientName={patientName}
                                            selectedPatient={selectedPatient}
                                        />
                                    </Grid>
                                </Grid>
                            </SoftBox>
                        )
                    }
                    {
                        allDataGenerated && (
                            <SoftBox py={4} >
                                <Grid container spacing={3} justifyContent="center">
                                    <Grid item xs={12} lg={11} >
                                        <SoftBox display="flex" flexDirection="column" alignItems="center">
                                            <SoftBox mb={6} mt={-1} >
                                                <Tooltip title="Resets everything in order to start a brand new consultation" placement="top" >
                                                    <SoftButton variant="contained" color="dark" size="medium" onClick={scrollToRecordingRef} style={{ minWidth: '400px' }}>
                                                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>&nbsp; New Recording
                                                    </SoftButton>
                                                </Tooltip>
                                            </SoftBox>
                                            <Tooltip title="everything saved!" placement="left">
                                                <SoftButton variant="outlined" color="success" size="medium" circular iconOnly >
                                                <Icon sx={{ fontWeight: "bold" }}>done</Icon>
                                                </SoftButton>
                                            </Tooltip>
                                            <SoftBox mt={2}>
                                                <SoftBadge
                                                    variant="contained"
                                                    color="success"
                                                    size="md"
                                                    badgeContent={
                                                        <SoftTypography variant="button">
                                                            Everything saved successfully for {nameToDisplay}
                                                        </SoftTypography>
                                                    }
                                                    container
                                                />
                                            </SoftBox>
                                        </SoftBox>
                                        {/*< SeperatorAllSaved />*/}
                                    </Grid>
                                </Grid>
                            </SoftBox>
                        )
                    }
                    { errorTranscriptUndefined && (
                        <SoftBox display="flex" alignItems="center" justifyContent="center" py={5} >
                            <SoftTypography varaint="h5" >
                                There is no transcript to generate any notes from. 
                            </SoftTypography>
                        </SoftBox>
                    )}
                    <SoftBox>
                        <Grid container spacing={3} justifyContent="center">
                            <Grid item xs={12} lg={11}>
                            {
                                Object.keys(generatedEmails).length > 0 && (
                                    <SoftBox mt={2} mb={2}>
                                        { showGeneratedEmailContent ? (
                                            <SoftBox pt={2} pb={1} display="flex" alignItems="center" justifyContent="center" >
                                                <SoftButton color="error" size="medium" startIcon={<CloseOutlinedIcon />} variant="outlined" onClick={handleGenerateEmailContentClose} >
                                                    Close email modal 
                                                </SoftButton>
                                            </SoftBox>
                                        ) : (
                                            <SoftBox p={2} display="flex" alignItems="center" justifyContent="center" >
                                                <SoftButton color="dark" size="medium" startIcon={<ForwardToInboxOutlinedIcon sx={{ mr:1}} />} variant="outlined" onClick={handleToggleGeneratedEmailContent} >
                                                    Send Instruction email to {nameToDisplay}
                                                </SoftButton>
                                            </SoftBox>
                                        )}

                                        {
                                            showGeneratedEmailContent && Object.keys(generatedEmails).length > 0 && (
                                                <SoftBox mt={2} mb={6}>
                                                    <Card raised>
                                                        <SoftBox p={2}>
                                                            <SoftBox mt={2} mb={1} display="flex" alignItems="center" justifyContent="flex-start">
                                                                <SoftBadge
                                                                    variant="contained"
                                                                    color="warning"
                                                                    size="md"
                                                                    badgeContent={
                                                                        <SoftTypography variant="h6">
                                                                            Securely send one of the generated emails to the patient
                                                                        </SoftTypography>
                                                                    }
                                                                />
                                                            </SoftBox>
                                                            <SoftBox mt={1} mb={5} display="flex" flexDirection="column"  justifyContent="flex-start">
                                                                <SoftTypography ml={1.5} mr={3} variant="body2" >
                                                                    This email will be send via our custom, white-labeled and HIPAA compliant service. 
                                                                </SoftTypography>
                                                                <SoftTypography ml={1.5} mr={3} variant="body2" >
                                                                    The patient&apos;s email is deleted immediatly after the email has been send.
                                                                </SoftTypography>
                                                            </SoftBox>
                                                            {Object.entries(generatedEmails).map(([instructionId, emailData]) => (
                                                                    <SoftBox key={instructionId} p={1}  >
                                                                        <SoftBadge
                                                                            variant="contained"
                                                                            color="secondary"
                                                                            size="md"
                                                                            sx={{ ml:3, mb: -0.5}}
                                                                            badgeContent={
                                                                                <SoftTypography variant="h6" fontWeight="medium">
                                                                                    {instructionId}
                                                                                </SoftTypography>
                                                                            }
                                                                        />
                                                                        <Card sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', mx:2, mb:3}} >
                                                                            {/*{ emailSentSuccess && (
                                                                                <SoftBox pt={2} display="flex" justifyContent="flex-end" mr={2} >
                                                                                    <SoftBox mr={2} >
                                                                                        <SoftBadge
                                                                                            variant="contained"
                                                                                            color="success"
                                                                                            size="md"
                                                                                            badgeContent={
                                                                                                <SoftTypography variant="button">
                                                                                                    Email sent to patient.
                                                                                                </SoftTypography>
                                                                                            }
                                                                                        />
                                                                                    </SoftBox>
                                                                                    <Tooltip title="everything saved!" placement="left">
                                                                                        <SoftButton sx={{ mt: 0.7, mr:2}} variant="outlined" color="success" size="small" circular iconOnly >
                                                                                        <Icon sx={{ fontWeight: "bold" }}>done</Icon>
                                                                                        </SoftButton>
                                                                                    </Tooltip>
                                                                                </SoftBox>
                                                                                        )}*/}
                                                                            <SoftBox p={2} display="flex" flexDirection="column" justifyContent="flex-start" >
                                                                                <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Email subject</SoftTypography>
                                                                                <SoftInput
                                                                                    placeholder="Follow-up steps for [Patient Name]"
                                                                                    fullWidth
                                                                                    
                                                                                    value={emailSubjects[instructionId] || ""}
                                                                                    onChange={(e) => handleEmailSubjectChange(instructionId, e.target.value)}
                                                                                />
                                                                                <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Email content</SoftTypography>
                                                                                <SoftInput
                                                                                    placeholder="generated email content specific to this session"
                                                                                    fullWidth
                                                                                    multiline
                                                                                    rows={10}
                                                                                    
                                                                                    value={emailData.response}
                                                                                    onChange={(e) => handleEmailContentEdit(instructionId, e.target.value)}
                                                                                />
                                                                                <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Sender name</SoftTypography>
                                                                                { !senderName && (
                                                                                    <SoftBadge sx={{ mt: -0.5, mb:1, ml:0.5 }} size="xs" variant="contained" color="warning" badgeContent="TIP: You can configure a default sender name in your Patient Instructions tab for future use." container  />
                                                                                )}
                                                                                <SoftInput
                                                                                    placeholder="Enter your name here"
                                                                                    fullWidth
                                                                                    value={emailSenderNames[instructionId] || senderName}
                                                                                    onChange={(e) => handleEmailSenderNameChange(instructionId, e.target.value)}
                                                                                />
                                                                                <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Sender email</SoftTypography>
                                                                                { !senderEmail && (
                                                                                    <SoftBadge sx={{ mt: -0.5, mb:1, ml:0.5 }} size="xs" variant="contained" color="warning" badgeContent="TIP: You can configure a default sender email in your Patient Instructions tab for future use." container />
                                                                                )}
                                                                                <SoftInput
                                                                                    placeholder="your_email@example.com"
                                                                                    fullWidth
                                                                                    value={emailSenderEmails[instructionId] || senderEmail}
                                                                                    onChange={(e) => handleEmailSenderEmailChange(instructionId, e.target.value)}
                                                                                />
                                                                                <SoftTypography sx={{ mt:3}} variant="button" fontWeight="bold" ml={0.7} mb={1}>Patient&apos;s email</SoftTypography>
                                                                                <SoftInput
                                                                                    placeholder="email of the patient to send it to"
                                                                                    fullWidth
                                                                                    value={patientEmail}
                                                                                    onChange={handlePatientEmailChange}
                                                                                />


                                                                                <SoftBox display="flex" alignItems="center" mt={3}>
                                                                                    <Checkbox checked={agreementEmail} onChange={handleSetAgreement} />
                                                                                    <SoftTypography
                                                                                        variant="button"
                                                                                        fontWeight="regular"
                                                                                        onClick={handleSetAgreement}
                                                                                        sx={{ cursor: "pointer", userSelect: "none" }}
                                                                                    >
                                                                                        The patient has given their consent for the transmission of their personal health information via email.
                                                                                    </SoftTypography>
                                                                                </SoftBox>
                                                                                
                                                                            </SoftBox>

                                                                            
                                                                            <SoftBox px={2} pb={2} pt={0} display="flex" alignItems="center" justifyContent="flex-end" >
                                                                                <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 Email sending to patients is available for Platinum and Gold Package subscribers only." : !agreementEmail ? "You must obtain the patient's consent before sending the email." : "Send email"} placement="top">
                                                                                    <span>
                                                                                    <SoftButton disabled={!agreementEmail || currentUserSubscription === "Silver Subscription"} startIcon={<SendOutlinedIcon />} variant={agreementEmail && currentUserSubscription !== "Silver Subscription" ? "contained" : "outlined"} color="dark" onClick={() => handleSendEmail(instructionId)} >
                                                                                        Send this email 
                                                                                    </SoftButton>
                                                                                    </span>
                                                                                </Tooltip>
                                                                            </SoftBox>
                                                                            {!["Platinum Subscription", "Gold Subscription"].includes(currentUserSubscription) && (
                                                                                <SoftBox px={4} pt={4} sx={{ mb: 3}} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                                                                                <SoftBadge
                                                                                    variant="contained"
                                                                                    color="error"
                                                                                    size="md"
                                                                                    badgeContent={
                                                                                        <SoftTypography variant="button">
                                                                                            🔔&nbsp;&nbsp;This feature is available for Platinum and Gold Package subscribers only.
                                                                                        </SoftTypography>
                                                                                    }
                                                                                    container
                                                                                />
                                                                                </SoftBox>
                                                                            )}
                                                                        </Card>
                                                                    </SoftBox>
                                                            ))}
                                                        </SoftBox>
                                                    </Card>
                                                </SoftBox>
                                            )
                                        }
                                    </SoftBox>
                                )
                            }

                                {
                                    Object.keys(templateSummaries).length > 0 && (
                                        <SoftBox mt={4} mb={4} >
                                            <Card raised >
                                                <SoftBox p={2} >
                                                    <SoftBox pl={2} pt={2} pb={3} display="flex" justifyContent="space-between" alignItems="center"  >
                                                        <SoftBadge
                                                            variant="contained"
                                                            color="secondary"
                                                            size="sm"
                                                            badgeContent={
                                                                <SoftTypography variant="h6" fontWeight="medium" >
                                                                    {templateNameToDisplay} for {nameToDisplay}
                                                                </SoftTypography>
                                                            }
                                                            //circular
                                                            container
                                                        />
                                                        <SoftBox display="flex" alignItems="center" sx={{ width: '60%' }} pr={3}>
                                                            
                                                            <SoftButton variant={copyAllTemplate ? "outlined" : "contained"} startIcon={copyAllTemplate ? <CheckCircleOutlineOutlinedIcon /> : <ContentCopyOutlinedIcon />} color="dark" size="inherit" sx={{ mr: 2 }} onClick={copyAllTemplateSummaries} >
                                                                {copyAllTemplate ? "Copied!" : "Copy all"}
                                                            </SoftButton>
                                                            <SoftButton variant={copySelectedTemplateSums ? "outlined" : "contained"} startIcon={copySelectedTemplateSums ? <CheckCircleOutlineOutlinedIcon /> : <ContentCopyOutlinedIcon />} color="dark" size="inherit" sx={{ mr: 2 }} onClick={copySelectedTemplateSummaries} >
                                                                {copySelectedTemplateSums ? "Copied!" : "Selected notes"}
                                                            </SoftButton>
                                                            
                                                            <SoftBox sx={{ width: '40%' }} >
                                                                <SoftInput
                                                                    placeholder="Search in generated Template Summaries..."
                                                                    value={templateSearchTerm}
                                                                    onChange={(e) => setTemplateSearchTerm(e.target.value)}
                                                                    icon={{ component: "search", direction: "left" }}
                                                                />
                                                            </SoftBox>
                                                        </SoftBox>
                                                    </SoftBox>
                                                    <SoftBox pb={2} >
                                                        <SeparatorTemplate  />
                                                    </SoftBox>
                                                    {/* Template Summaries */}
                                                    <SoftBox sx={{ maxHeight: '600px', overflowY: 'auto' }} >
                                                    {Object.entries(templateSummaries).map(([promptType, summaryText], index) => (
                                                        <SoftBox key={index} py={2} px={2} >
                                                            <Card sx={{ p: 2, boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', position: 'relative' }}>
                                                                <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={4} >
                                                                    <SoftBox display="flex" alignItems="center" >
                                                                        <SoftTypography pl={1} variant="h5" color="dark">
                                                                            {promptType}
                                                                        </SoftTypography>
                                                                        <Tooltip title="open menu" placement="top" >
                                                                            <IconButton 
                                                                                color="dark"
                                                                                onClick={(e) => handleOpenMenuTemplateSum(e, promptType)}
                                                                                sx={{
                                                                                    transition: "0.3s ease-in-out",
                                                                                    "&:hover": {
                                                                                        backgroundColor: "rgba(0, 0, 0, 0.14)", 
                                                                                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", 
                                                                                    },
                                                                                }}
                                                                            >
                                                                                <MoreVertIcon />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        <Menu
                                                                            anchorEl={anchorElTemplateSummary}
                                                                            open={Boolean(anchorElTemplateSummary)}
                                                                            onClose={handleCloseMenuTemplateSum}
                                                                        >
                                                                            <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 Regeneration is available for Platinum and Gold Package subscribers only." : ""} placement="top">
                                                                                <div> {/* Wrap the MenuItem in a div for tooltip functionality on a potentially disabled item */}
                                                                                    <MenuItem onClick={currentUserSubscription !== "Silver Subscription" ? () => regenerateTemplateSummary(promptType) : null} disabled={currentUserSubscription === "Silver Subscription"}>
                                                                                        <ListItemIcon>
                                                                                            <LoopOutlinedIcon fontSize="small" sx={{ color: currentUserSubscription === "Silver Subscription" ? 'action.disabled' : '#344767' }} />
                                                                                        </ListItemIcon>
                                                                                        <ListItemText>
                                                                                            <SoftTypography color={currentUserSubscription === "Silver Subscription" ? "text.disabled" : "dark"} variant="button" fontWeight="medium">
                                                                                                Regenerate Note
                                                                                            </SoftTypography>
                                                                                        </ListItemText>
                                                                                    </MenuItem>
                                                                                </div>
                                                                            </Tooltip>
                                                                            <MenuItem onClick={() => makeSummaryMoreConcise(promptType)}>
                                                                                <ListItemIcon>
                                                                                    <SummarizeOutlinedIcon fontSize="small" sx={{ color: '#344767' }} />
                                                                                </ListItemIcon>
                                                                                <ListItemText>
                                                                                    <SoftTypography color="dark" variant="button" fontWeight="medium">
                                                                                        Make Concise
                                                                                    </SoftTypography>
                                                                                </ListItemText>
                                                                            </MenuItem>
                                                                            <MenuItem onClick={() => deleteTemplateSummary(promptType)}>
                                                                                <ListItemIcon>
                                                                                    <DeleteOutlinedIcon fontSize="small" sx={{ color: "red" }} />
                                                                                </ListItemIcon>
                                                                                <ListItemText>
                                                                                    <SoftTypography color="error" variant="button" fontWeight="medium">
                                                                                    Delete
                                                                                    </SoftTypography>
                                                                                </ListItemText>
                                                                            </MenuItem>
                                                                        </Menu>
                                                                    </SoftBox>
                                                                    <Tooltip title="Edit Summary" placement="right">
                                                                        <SoftButton 
                                                                            color="light" 
                                                                            iconOnly 
                                                                            onClick={() => handleEditTemplateSummary(promptType)}
                                                                            sx={{
                                                                                position: 'absolute',
                                                                                top: '15px',
                                                                                right: '15px'
                                                                            }}
                                                                        >
                                                                            <Icon>edit</Icon>
                                                                        </SoftButton>
                                                                    </Tooltip>
                                                                    <Tooltip title="Copy Summary" placement="right">
                                                                        <SoftButton 
                                                                            color="dark" 
                                                                            iconOnly 
                                                                            onClick={() => copySingleTemplateSummary(promptType, summaryText.response)}
                                                                            sx={{
                                                                                position: 'absolute',
                                                                                top: '65px',
                                                                                right: '15px'
                                                                            }}
                                                                        >
                                                                            <Icon>
                                                                            {copyTemplateSummary[promptType] ? "check" : "copy" }
                                                                            </Icon>
                                                                        </SoftButton>
                                                                    </Tooltip>
                                                                    <Tooltip title= { selectedTemplateSummaries[promptType] ? "Un-select Summary" : "Select summary" } placement="right">
                                                                        <SoftButton
                                                                            onClick={() => toggleTemplateSummarySelection(promptType)}
                                                                            variant="contained"
                                                                            iconOnly
                                                                            circular="true"
                                                                            sx={{ position: 'absolute', top: '120px', right: '15px' }} 
                                                                            color={selectedTemplateSummaries[promptType] ? 'success' : 'warning'}
                                                                        >
                                                                            <Icon>
                                                                                {selectedTemplateSummaries[promptType] ? 'check_circle' : 'check_circle_outline'}
                                                                            </Icon>
                                                                        </SoftButton>
                                                                    </Tooltip>
                                                                </SoftBox>
                                                                {isRegeneratingTemplate[promptType] ? (
                                                                    <SoftBox mb={4} style={{ display: 'flex', justifyContent: 'center' }}>
                                                                        <ClockLoader color="#344767" speedMultiplier={0.7} size={80} />
                                                                    </SoftBox>
                                                                ) : editModeTemplate[promptType] ? (
                                                                    <textarea
                                                                        value={editedTextTemplate[promptType]}
                                                                        onChange={(e) => handleTemplateTextChange(e, promptType)}
                                                                        rows={15}
                                                                        style={{ 
                                                                            width: '90%',
                                                                            minHeight: '50px',
                                                                            border: '1px solid #ccc',
                                                                            borderRadius: '8px',
                                                                            padding: '15px',
                                                                            fontSize: '16px',
                                                                            fontFamily: 'Arial, sans-serif',
                                                                            backgroundColor: '#fff',
                                                                            color: '#333',
                                                                            boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                                                                            lineHeight: '1.5',
            
                                                                        }}
                                                                    />
                                                                ) : (

                                                                        <SoftTypography variant="body2" pr={8} style={{ whiteSpace: 'pre-wrap', minHeight: '70px' }}>
                                                                            {splitTextTemplates(summaryText.response, templateSearchTerm).map((part, partIndex) => 
                                                                                part.toLowerCase() === templateSearchTerm.toLowerCase() ? 
                                                                                <span key={partIndex} style={{ backgroundColor: 'lightblue' }}>{part}</span> : 
                                                                                part
                                                                            )} 
                                                                        </SoftTypography>
                                                                )}
                                                                 {editModeTemplate[promptType] && (
                                                                    <SoftBox pt={3} display="flex" justifyContent="center">
                                                                        <SoftButton size="small" color="dark" onClick={() => handleSaveTemplate(promptType)} sx={{ marginRight: '15px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }} >Save</SoftButton>
                                                                        <SoftButton size="small" color="light" onClick={() => handleCancelTemplate(promptType)} sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }} >Cancel</SoftButton>
                                                                    </SoftBox>
                                                                )}
                                                                {!openTalkToNotes[promptType] ? (
                                                                    <SoftBox pt={3} display="flex" alignItems="center" justifyContent="flex-end">
                                                                        <SoftButton 
                                                                            onClick={() => handleOpenTalkNotes(promptType)}
                                                                            color="dark"
                                                                            variant="outlined"
                                                                        >
                                                                            <QuestionAnswerOutlinedIcon fontSize="small" sx={{ color: '#344767', mr: 1 }} />
                                                                            Talk to Note
                                                                        </SoftButton>
                                                                    </SoftBox>
                                                                ) : (
                                                                    <SoftBox style={{padding: '20px', backgroundColor: '#f0f0f0', borderRadius: '8px', margin: '20px 0'}}>
                                                                        <SoftBox display="flex" alignItems="center" justifyContent="space-between" >
                                                                            <SoftBox display="flex" alignItems="center">
                                                                                <VolumeUpIcon sx={{ color: '#333', mr: 1 }} />
                                                                                <SoftTypography variant="h6" style={{color: '#333'}}>
                                                                                    Talking to {promptType}
                                                                                </SoftTypography>
                                                                            </SoftBox>
                                                                            <SoftButton color="dark" size="inherit" variant="outlined" onClick={() => (handleCloseTalkNotes(promptType))} > 
                                                                                <CloseIcon />
                                                                            </SoftButton>
                                                                        </SoftBox>
                                                                        <div>
                                                                            <SpeechToText 
                                                                                promptType={promptType}
                                                                                onTextChange={(promptType, text) => handleTextChange(promptType, text)}
                                                                                onRecordingStatusChange={handleRecordingStatusChange}                                                                          
                                                                            />
                                                                        </div>
                                                                        {isRecordingToNotes[promptType] && (
                                                                            <SoftBox pt={2} mb={-1} display="flex" alignItems="center" justifyContent="center" > 
                                                                                <ScaleLoader speedMultiplier={0.8} height={15} width={3} color="#344767" /> 
                                                                            </SoftBox>
                                                                        )}
                                                                        <SoftBox pt={3} display="flex" alignItems="center" justifyContent="center">
                                                                            <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 This feature is available for Platinum and Gold Package subscribers only." : isRecordingToNotes[promptType] ? "Stop recording to refine note" : ""} placement="right">
                                                                                <span>
                                                                                <SoftButton disabled={!!isRecordingToNotes[promptType] || currentUserSubscription === "Silver Subscription"} onClick={() => onRefineNote(promptType)} color="dark" variant="contained" startIcon={<AutoAwesomeOutlinedIcon sx={{ mr: 1 }}/>}>
                                                                                    Re-Fine Note 
                                                                                </SoftButton>
                                                                                </span>
                                                                            </Tooltip>
                                                                        </SoftBox>
                                                                        {!["Platinum Subscription", "Gold Subscription"].includes(currentUserSubscription) && (
                                                                            <SoftBox px={4} pt={4} sx={{ mb: 3}} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                                                                            <SoftBadge
                                                                                variant="contained"
                                                                                color="error"
                                                                                size="md"
                                                                                badgeContent={
                                                                                    <SoftTypography variant="button">
                                                                                        🔔&nbsp;&nbsp;This feature is available for Platinum and Gold Package subscribers only.
                                                                                    </SoftTypography>
                                                                                }
                                                                                container
                                                                            />
                                                                            </SoftBox>
                                                                        )}
                                                                    </SoftBox>
                                                                )}
                                                            </Card>
                                                        </SoftBox>
                                                    ))}
                                                    </SoftBox>
                                                </SoftBox>
                                            </Card>
                                        </SoftBox>
                                    )
                                }
                        
                                {
                                    Object.keys(summaries).length > 0 ? (
                                        <SoftBox mt={4} mb={4} sx={{
                                            background: '#e9ecef', // This is a light gray color close to white
                                            borderRadius: '0.5rem',
                                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                                            }}
                                        >
                                        <Card raised >
                                            { errorSavingSummaries && (
                                                <>
                                                    <SoftBox 
                                                        sx={{ 
                                                            backgroundColor: "rgba(255, 152, 0, 0.2)", // Soft orange/red warning color
                                                            borderRadius: "8px", // Rounded corners
                                                            margin: "1rem", // Optional: Adds some space around the box
                                                            padding: "1rem" // Optional: Adds some padding inside the box for its content
                                                        }}
                                                    >
                                                        <SoftBox display="flex" justifyContent="space-between" alignItems="center" px={5} pt={2} pb={4}>
                                                            <SoftTypography variant="h6">
                                                                There was a problem saving the summaries. Please try again or choose one of the following options. 
                                                            </SoftTypography>
                                                            <SoftButton startIcon={<ReplayOutlinedIcon />} onClick={() => saveSummariesToFirestore(summaries)} variant="outlined" color="dark" >
                                                                Retry Saving 
                                                            </SoftButton>
                                                        </SoftBox>
                                                        <SoftBox display="flex" sx={{ fontStyle: 'italic' }} alignItems="center" justifyContent="center" px={6} pb={2}>
                                                            <SoftTypography variant="h6" textAlign="center">
                                                                Other possible solutions could be to directly paste the generated notes into your EHR system or to download the recording in order to try again later. 
                                                            </SoftTypography>
                                                        </SoftBox>
                                                        <SoftBox onClick={handleOpenModal} display="flex" sx={{ textDecoration: 'underline', cursor: 'pointer' }} alignItems="center" justifyContent="center" px={6} pb={0}>
                                                            <SoftTypography variant="h6" textAlign="center">
                                                                Report this problem. 
                                                            </SoftTypography>
                                                        </SoftBox>
                                                        <ReportProblemModal open={isModalOpen} onClose={handleCloseModal} />

                                                    </SoftBox>
                                                </>
                                            )}
                                            <Grid container spacing={3} alignItems="stretch">
                                            {/* Sidenav */}
                                            <Grid item xs={9} lg={3} sx={{ 
                                                display: 'flex', 
                                                flexDirection: 'column',
                                                minHeight: '600px', 
                                                maxHeight: '1200px',
                                                mt: 2,
                                                ml: 3,
                                                
                                                
                                                }}>
                                                <SoftBox pt={2} pb={1.5} pr={1} >
                                                    <SoftBadge
                                                        variant="contained"
                                                        color="secondary"
                                                        size="sm"
                                                        badgeContent={
                                                            <SoftTypography variant="h6" fontWeight="medium" >
                                                                Summaries for {nameToDisplay} 
                                                            </SoftTypography>
                                                        }
                                                        //circular
                                                        container
                                                    />
                                                </SoftBox>
                                                <SoftBox pt={1} sx={{ overflowY: 'visible', flex: 1 }}>
                                                    <SummariesSidenav 
                                                        summaries={summaries} 
                                                        onSummarySelect={handleSummarySelect} 
                                                        onRegenerateSummary={regenerateSummary}
                                                        onDeleteSummary={deleteSummary}
                                                        onMakeSummaryMoreConcise={makeRegularSummaryMoreConcise}
                                                        subscription={currentUserSubscription}
                                                    />
                                                </SoftBox>
                                                <SoftBox display="flex" flexDirection="column" >
                                                    <SoftBox mb={1} >
                                                        <SoftButton variant={copyAllSummary ? "outlined" : "contained"} startIcon={copyAllSummary ? < CheckCircleOutlineOutlinedIcon /> : <ContentCopyOutlinedIcon />} color="dark" size="medium"  onClick={copyAllRegularSummaries} >
                                                            {copyAllSummary ? "Copied!" : "Copy all" }
                                                        </SoftButton>
                                                    </SoftBox>
                                                    <SoftBox >
                                                        <SoftButton variant={copySelectedSummary ? "outlined" : "contained"} startIcon={copySelectedSummary ? < CheckCircleOutlineOutlinedIcon /> : <ContentCopyOutlinedIcon />} color="dark" size="medium"  onClick={copySelectedSummaries} >
                                                            {copySelectedSummary ? "Copied!" : "selected summaries" }
                                                        </SoftButton>
                                                    </SoftBox>
                                                </SoftBox>
                                                <SoftBox py={2} mb={1} >
                                                    <SoftInput
                                                        placeholder="Search in generated Summaries..."
                                                        value={summariesSearchTerm}
                                                        onChange={(e) => setSummariesSearchTerm(e.target.value)}
                                                        sx={{ width: '35%' }}
                                                        icon={{ component: "search", direction: "left" }}
                                                    />
                                                </SoftBox>
                                            </Grid>
                                            {/* Summaries */}
                                            <Grid item xs={11} lg={8.5}>
                                            <SoftBox p={2} pr={1} sx={{ maxHeight: '800px', overflowY: 'auto' }}>
                                                {Object.entries(summaries).map(([promptType, summaryText], index) => (
                                                <Card key={index} id={promptType} sx={{ mb: 2, p: 2, boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }}> 
                                                    <SoftBox display="flex" justifyContent="space-between" alignItems="center" pl={1} pr={2} mb={3} mt={2}>
                                                        <SoftTypography textAlign='center' color='dark' variant="h5">
                                                        {promptType}
                                                        </SoftTypography>
                                                        <SoftBox display="flex" alignItems="center">
                                                            <Tooltip title= { selectedSummaries[promptType] ? "Un-select Summary" : "Select summary" } placement="top">
                                                                <SoftButton
                                                                    onClick={() => toggleSummarySelection(promptType)}
                                                                    variant="contained"
                                                                    iconOnly
                                                                    circular="true"
                                                                    color={selectedSummaries[promptType] ? 'success' : 'warning'}
                                                                >
                                                                    <Icon>
                                                                        {selectedSummaries[promptType] ? 'check_circle' : 'check_circle_outline'}
                                                                    </Icon>
                                                                </SoftButton>
                                                            </Tooltip>
                                                            <Tooltip title="Edit Summary" placement="top">
                                                                <SoftButton sx={{ ml: 1.5 }} color="light" iconOnly onClick={() => handleSummaryTextEdit(promptType)} >
                                                                    <Icon >
                                                                        edit
                                                                    </Icon>
                                                                </SoftButton>
                                                            </Tooltip>
                                                            <Tooltip title="Copy Summary" placement="top">
                                                                <SoftButton color="dark" iconOnly sx={{ ml: 1 }} onClick={() => copySingleRegularSummary(promptType, summaryText.response)} >
                                                                    <Icon >
                                                                        {copySummary[promptType] ? "check" : "copy" }
                                                                    </Icon>
                                                                </SoftButton>
                                                            </Tooltip>
                                                        </SoftBox>
                                                    </SoftBox>
                                                    {isRegenerating[promptType] ? (
                                                        <SoftBox mb={4} style={{ display: 'flex', justifyContent: 'center' }}>
                                                            <ClockLoader  mb={2} color="#344767" speedMultiplier={0.7} size={80} />
                                                        </SoftBox>
                                                    ) : editMode[promptType] ? (
                                                        <textarea
                                                            value={editedText[promptType]}
                                                            onChange={(e) => handleSummaryTextChange(e, promptType)}
                                                            rows={10}
                                                            style={{ 
                                                                width: '100%',
                                                                minHeight: '100px',
                                                                border: '1px solid #ccc',
                                                                borderRadius: '8px',
                                                                padding: '15px',
                                                                fontSize: '16px',
                                                                fontFamily: 'Arial, sans-serif',
                                                                backgroundColor: '#fff',
                                                                color: '#333',
                                                                boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
                                                                lineHeight: '1.5',

                                                            }}
                                                        />
                                                    ) : (
                                                        <SoftTypography variant="body2" style={{ whiteSpace: 'pre-wrap', minHeight: '40px' }}>
                                                            {splitTextSummaries(summaryText.response, summariesSearchTerm).map((part, partIndex) => 
                                                                part.toLowerCase() === summariesSearchTerm.toLowerCase() ? 
                                                                <span key={partIndex} style={{ backgroundColor: 'lightblue' }}>{part}</span> : 
                                                                part
                                                            )}
                                                        </SoftTypography>
                                                    )}
                                                    {editMode[promptType] && (
                                                        <SoftBox pt={3} display="flex" justifyContent="center">
                                                            <SoftButton size="small" color="dark" onClick={() => handleSave(promptType)} sx={{ marginRight: '15px', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }} >Save</SoftButton>
                                                            <SoftButton size="small" color="light" onClick={() => handleCancel(promptType)} sx={{ boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' }} >Cancel</SoftButton>
                                                        </SoftBox>
                                                    )}
                                                    {!openTalkToSummaries[promptType] ? (
                                                        <SoftBox pt={3} display="flex" alignItems="center" justifyContent="flex-end">
                                                            <SoftButton 
                                                                onClick={() => handleOpenTalkSummaries(promptType)}
                                                                color="dark"
                                                                variant="outlined"
                                                            >
                                                                <QuestionAnswerOutlinedIcon fontSize="small" sx={{ color: '#344767', mr: 1 }} />
                                                                Talk to Note
                                                            </SoftButton>
                                                        </SoftBox>
                                                    ) : (
                                                        <SoftBox style={{padding: '20px', backgroundColor: '#f0f0f0', borderRadius: '8px', margin: '20px 0'}}>
                                                            <SoftBox display="flex" alignItems="center" justifyContent="space-between" >
                                                                <SoftBox display="flex" alignItems="center">
                                                                    <VolumeUpIcon sx={{ color: '#333', mr: 1 }} />
                                                                    <SoftTypography variant="h6" style={{color: '#333'}}>
                                                                        Talking to {promptType}
                                                                    </SoftTypography>
                                                                </SoftBox>
                                                                <SoftButton color="dark" size="inherit" variant="outlined" onClick={() => (handleCloseTalkSummaries(promptType))} > 
                                                                    <CloseIcon />
                                                                </SoftButton>
                                                            </SoftBox>
                                                            <div>
                                                                <SpeechToTextSummaries 
                                                                    promptType={promptType}
                                                                    onTextChange={(promptType, text) => handleTextChangeSummaries(promptType, text)}
                                                                    onRecordingStatusChange={handleRecordingStatusChangeSums}                                                                          
                                                                />
                                                            </div>
                                                            {isRecordingToSummaries[promptType] && (
                                                                <SoftBox pt={2} mb={-1} display="flex" alignItems="center" justifyContent="center" > 
                                                                    <ScaleLoader speedMultiplier={0.8} height={15} width={3} color="#344767" /> 
                                                                </SoftBox>
                                                            )}
                                                            <SoftBox pt={3} display="flex" alignItems="center" justifyContent="center">
                                                                <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 This feature is available for Platinum and Gold Package subscribers only." : isRecordingToNotes[promptType] ? "Stop recording to refine note" : ""} placement="right">
                                                                    <span>
                                                                    <SoftButton disabled={!!isRecordingToNotes[promptType] || currentUserSubscription === "Silver Subscription"} onClick={() => onRefineSummary(promptType)} color="dark" variant="contained" startIcon={<AutoAwesomeOutlinedIcon sx={{ mr: 1 }}/>}>
                                                                        Re-Fine Note 
                                                                    </SoftButton>
                                                                    </span>
                                                                </Tooltip>
                                                            </SoftBox>
                                                            {!["Platinum Subscription", "Gold Subscription"].includes(currentUserSubscription) && (
                                                                <SoftBox px={4} pt={4} sx={{ mb: 3}} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                                                                <SoftBadge
                                                                    variant="contained"
                                                                    color="error"
                                                                    size="md"
                                                                    badgeContent={
                                                                        <SoftTypography variant="button">
                                                                            🔔&nbsp;&nbsp;This feature is available for Platinum and Gold Package subscribers only.
                                                                        </SoftTypography>
                                                                    }
                                                                    container
                                                                />
                                                                </SoftBox>
                                                            )}
                                                        </SoftBox>
                                                    )}
                                                </Card>
                                                ))}
                                            </SoftBox>
                                            </Grid>
                                            </Grid>
                                        </Card>
                                        </SoftBox>
                                    ) : null
                                }
                            </Grid>
                        </Grid>
                    </SoftBox>
                    { transcript.status === 200
                    ? (
                        <SoftBox >
                            <Grid container spacing={3} justifyContent="center">
                            <Grid item xs={11} lg={11}> {/* Adjust lg value as needed for the transcription box */}
                                <Card sx={{boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)'}}>
                                    <SoftBox  display="flex" flexDirection="column" textAlign='center' p={2}> 
                                        <SoftBox display="flex" justifyContent="space-between" alignItems="center" px={2} mb={2} mt={2}>
                                            <SoftBadge
                                                variant="contained"
                                                color="warning"
                                                size="sm"
                                                badgeContent={
                                                    <SoftTypography variant="h6" color="dark" textAlign="left" fontWeight="medium">
                                                        Transcript with: {nameToDisplay}
                                                    </SoftTypography>
                                                }
                                                //circular
                                                container
                                            />
                                            {isTranscriptEdited && (
                                                <>
                                                    <SoftBox display="flex" alignItems="center" justifyContent="center">
                                                        <SoftButton variant="contained" size="small" color="dark" onClick={handleSaveTranscript} sx={{ mr: 2}}>
                                                            Save
                                                        </SoftButton>
                                                        <SoftButton variant="contained" size="small" color="light" onClick={handleCancelTranscript}>
                                                            Reset
                                                        </SoftButton>
                                                    </SoftBox>
                                                </>
                                            )}
                                            {transcriptChangesSuccess && (
                                                <SoftBox >
                                                    <SoftBox >
                                                        <SoftBadge
                                                            variant="contained"
                                                            color="success"
                                                            size="sm"
                                                            badgeContent={
                                                                <SoftTypography color="dark" variant="button" >
                                                                    Changes saved successfully! 
                                                                </SoftTypography>
                                                        }
                                                        //circular
                                                        container
                                                        />
                                                    </SoftBox>
                                                </SoftBox>
                                            )}
                                            <SoftBox display="flex" alignItems="center">
                                                <SoftBox display="flex" justifyContent="center" mr={3} >
                                                    <SoftInput
                                                        placeholder="Search in transcript..."
                                                        value={transcriptSearchTerm}
                                                        onChange={handleTranscriptSearchChange}
                                                        icon={{ component: "search", direction: "left" }}
                                                        //style={{ width: '100%' }}
                                                    />
                                                </SoftBox>
                                                {!isTranscriptEdited && (
                                                <SoftBox display="flex" justifyContent="center" mr={1} >
                                                    <Tooltip title="Regenerate the notes and contents based on changes that are made to the transcript" placement="bottom" >
                                                    <SoftButton 
                                                        color="light" 
                                                        variant="gradient" 
                                                        onClick={handleManualProcessing}
                                                        startIcon={ < ReplayOutlinedIcon /> }
                                                        
                                                    >
                                                        Redo Notes 
                                                    </SoftButton>
                                                    </Tooltip>
                                                </SoftBox>
                                                )}
                                            </SoftBox>
                                        </SoftBox>
                                        <SeparatorTranscript />
                                        { transcript.status === 200
                                            ? (
                                                <SoftBox sx={{ maxHeight: '600px', overflowY: 'auto' }} >
                                                    <SoftTypography >
                                                        <Result 
                                                            transcript={transcript} 
                                                            //isEditMode={editModeTranscript} 
                                                            key={resetKey}
                                                            onTextChange={handleTextChangeTranscript}
                                                            //editedText={editedTextTranscript} 
                                                            handleSaveTranscript={handleSaveTranscript}
                                                            handleCancelTranscript={handleCancelTranscript}
                                                            searchTerm={transcriptSearchTerm}
                                                            isTranscriptEdited={isTranscriptEdited}
                                                            setIsTranscriptEdited={setIsTranscriptEdited}

                                                        />
                                                    </SoftTypography>
                                                </SoftBox>
                                            )
                                            : (
                                                <SoftTypography variant="body1" color="text">
                                                    No Transcription to display yet
                                                </SoftTypography>
                                            )
                                        }
                                    </SoftBox>
                                </Card>
                            </Grid>
                            </Grid>
                        </SoftBox>
                        )
                        : (
                            <SoftBox >
                            <Grid container spacing={3} justifyContent="center">
                            <Grid item xs={11} lg={11}> {/* Adjust lg value as needed for the transcription box */}
                                <Card sx={{boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', display: 'hidden'}}>
                                
                                </Card>
                            </Grid>
                            </Grid>
                        </SoftBox>
                        )
                    }
                </>
            ) : (
                <SoftBox 
                    display="flex" 
                    justifyContent="center"
                    alignItems="center"    
                >
                    {/*<Grid container spacing={3} justifyContent="center">
                        <Grid item xs={12} md={10} xl={9}>*/}
                            <FreeTrialPrompt />
                        {/*</Grid>
                    </Grid>*/}
                </SoftBox>
            )}

            { templateLibrary && (
                <Dialog
                    fullScreen
                    open={templateLibrary}
                    onClose={closeLibraryModal}
                    sx={{
                        '& .MuiDialog-paper': {
                            width: '90%',
                            height: '90%',
                            maxHeight: 'none',
                            //border: '1px solid #000', 
                            borderRadius: '8px', 
                        },
                    }}
                >
                    <SoftBox display="flex" flexDirection="column" sx={{ height: '100%' }} >
                        <SoftBox display="flex" justifyContent="space-between" alignItems="center" pt={3} px={5} >
                            <SoftTypography variant="h5" color="text" >
                                Templates Library 
                            </SoftTypography>
                            <Tooltip title="Close The Library" placement="left" >
                                <SoftButton variant="outlined" color="dark" onClick={closeLibraryModal} >
                                    Close Library
                                </SoftButton>
                            </Tooltip>
                        </SoftBox>

                        <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                            <SoftBadge
                                variant="contained"
                                color="warning"
                                size="md"
                                badgeContent={
                                    <SoftTypography variant="h6">Choose your profession</SoftTypography>
                                }
                                container
                            />
                            <SoftBox pt={3} sx={{ width: {md: '70%',lg: '65%', xl: '63%', xxl: '60%' }}} >
                                <AppBar position='static' >
                                    <Tabs
                                        value={currentLibraryTab}
                                        onChange={handleLibraryTabChange}
                                    >
                                        <Tab label="Psychiatry" />
                                        <Tab label="Therapy" />
                                        <Tab label="Medical" />
                                        <Tab label="Psychology" />
                                        <Tab label="General" />
                                    </Tabs>
                                </AppBar>
                            </SoftBox>
                        </SoftBox>
                        {/*<SoftBox pt={4} >
                            <SeperatorLibrary />
                            </SoftBox>*/}
                        <SoftBox >
                            {renderTemplatesForCurrentTab()}
                        </SoftBox>
                    </SoftBox>
              
                </Dialog>
            )}
            { isSummaryLibraryOpen && (
                <Dialog
                    open={isSummaryLibraryOpen}
                    onClose={closeSummaryLibrary}
                    fullScreen
                    sx={{
                        '& .MuiDialog-paper': {
                            width: '90%',
                            height: '90%',
                            maxHeight: 'none',
                            //border: '1px solid #000', 
                            borderRadius: '8px', 
                        },
                    }}
                >
                    <SoftBox display="flex" flexDirection="column" sx={{ height: '100%' }} >
                        <SoftBox display="flex" justifyContent="space-between" alignItems="center" pt={3} px={5} >
                            <SoftTypography variant="h5" color="text" >
                                Summary Library 
                            </SoftTypography>
                            <Tooltip title="Close The Library" placement="left" >
                                <SoftButton variant="outlined" color="dark" onClick={closeSummaryLibrary} >
                                    Close Library
                                </SoftButton>
                            </Tooltip>
                        </SoftBox>

                        <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                            <SoftBadge
                                variant="contained"
                                color="warning"
                                size="md"
                                badgeContent={
                                    <SoftTypography variant="h6">Choose your profession</SoftTypography>
                                }
                                container
                            />
                            <SoftBox pt={3} sx={{ width: {md: '70%',lg: '65%', xl: '63%', xxl: '60%' }}} >
                                <AppBar position='static' >
                                    <Tabs
                                        value={currentSummaryTab}
                                        onChange={handleSummaryTabChange}
                                    >
                                        <Tab label="Psychiatry" />
                                        <Tab label="Therapy" />
                                        <Tab label="Medical" />
                                        <Tab label="Psychology" />
                                        <Tab label="General" />
                                    </Tabs>
                                </AppBar>
                            </SoftBox>
                        </SoftBox>
                        {/*<SoftBox pt={4} >
                            <SeperatorLibrary />
                            </SoftBox>*/}
                        <SoftBox >
                            {renderSummariesForCurrentTab()}
                        </SoftBox>
                    </SoftBox>
                </Dialog>
            )}
            { isCopyDialogOpen && (
                <Dialog 
                    open={isCopyDialogOpen} 
                    onClose={handleCloseCopyTemplateDialog}
                    fullScreen
                    sx={{
                        '& .MuiDialog-paper': {
                            width: {md: '60%',lg: '50%', xl: '50%', xxl: '50%' },
                            height: {md: '60%',lg: '60%', xl: '60%', xxl: '50%' },
                            maxHeight: 'none',
                            //border: '1px solid #000', 
                            borderRadius: '8px', 
                        },
                    }}
                >
                    <SoftBox display="flex" justifyContent="center" alignItems="center" p={2} pt={4}>
                        <SoftTypography variant="h5" color="text" >
                            Make a copy of the {selectedTemplate.id} template
                        </SoftTypography>
                    </SoftBox>
                    <SoftBox display="flex" justifyContent="center" alignItems="center" p={2} pt={4}>
                        <SoftTypography variant="h6" color="dark" >
                            How do you want to name this copy? 
                        </SoftTypography>
                    </SoftBox>
                    <SoftBox pb={2} display="flex" justifyContent="center" alignItems="center">
                        <SoftBox width="70%" >
                            <SoftInput
                                placeholder="Name of the copied template"
                                value={newTemplateName}
                                onChange={(e) => setNewTemplateName(e.target.value)}
                                //icon={{ component: "add", direction: "left" }}
                            />
                        </SoftBox>
                    </SoftBox>
                    <SoftBox pt={4} display="flex" justifyContent="center" alignItems="center">
                        <Tooltip title="Cancel copying of the template" placement="bottom" >
                        <SoftButton sx={{mr:1}} color="light" onClick={handleCloseCopyTemplateDialog}>Cancel</SoftButton>
                        </Tooltip>
                        <Tooltip title={currentUserSubscription === "Silver Subscription" ? "🔔 This feature is available for Platinum and Gold Package subscribers only." : "Click to copy template"} placement="bottom" >
                            <span>
                                <SoftButton startIcon={ <ContentCopyOutlinedIcon />} disabled={currentUserSubscription === "Silver Subscription"} sx={{ml:1}} color="dark" onClick={handleCopyTemplate}>Copy template</SoftButton>
                            </span>
                        </Tooltip>
                    </SoftBox>
                    {!["Platinum Subscription", "Gold Subscription"].includes(currentUserSubscription) && (
                        <SoftBox px={4} pt={4} sx={{ mb: 3}} display="flex" flexDirection="column" justifyContent="center" alignItems="center" >
                        <SoftBadge
                            variant="contained"
                            color="error"
                            size="md"
                            badgeContent={
                                <SoftTypography variant="button">
                                    🔔&nbsp;&nbsp;This feature is available for Platinum and Gold Package subscribers only.
                                </SoftTypography>
                            }
                            container
                        />
                        </SoftBox>
                    )}
                </Dialog>
            
            )}

            <SoftSnackbar
                //bgWhite="true"
                color={snackbar.color || "dark"}
                icon={snackbar.icon}
                title={snackbar.title}
                content={snackbar.message}
                open={snackbar.show}
                close={hideSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            />
                
        </DashboardLayout>
    );
}

export default RecordingAudio;